import { businessErrorsEn } from "./businessErrorsEn";
import { errorUiEn } from './errorUi';
import { completionEn } from "./completion";
import payroll from "./payrollEn";
export default {
  progressWorkPending: {
    label: "Reconciling",
    help: "Progress is awaiting reconciliation with time tracking. Displayed values are not final.",
  },
  internalCosts: {
    reverse: "Reverse current valuation",
    reverseConfirm: "Reverse the current valuation? The approved stock document is retained. Rebind the source after reversal succeeds.",
    categoryScope: "Office expenses cannot target a project; project incidental expenses require a project.",
    missingExchangeRate: "No exchange rate is available for the recognition date.",
    missingCostDetails: "The source or cost details have not been fully confirmed.",
    operationBindSource: "Link cost source",
    tab: "Internal costs",
    receiptTitle: "Receipt cost sources",
    invoiceTitle: "Costs and source history",
    missingQuantity: "Quantity without a source: {quantity}",
    approvedReceiptOnly: "Only approved receipts can receive cost sources.",
    mode: "Operation",
    bind: "Link sources",
    transfer: "Transfer from an approved stock issue",
    sourceKind: "Source type",
    source: "Source",
    quantity: "Quantity",
    currency: "Source currency",
    select: "Select",
    homogeneousPool: "Confirm equal unit cost for the tools in this pool",
    reason: "Confirmation reason",
    previous: "Previous page",
    next: "Next page",
    sourceSupplierInvoiceLine: "Supplier invoice line",
    sourceStockReceipt: "Material stock receipt",
    sourceTool: "Amortized tool",
    sourceReturnedMaterial: "Returned material",
    line: "Invoice line",
    nativeCost: "Cost in source currency",
    vndCost: "Cost in VND",
    partialHelp: "Costs are missing or partially known. A dash means unknown, not zero.",
    unresolvedReason: "Unresolved: {reason}",
    resolve: "Confirm sources and resolve costs",
    actualReturn: "Confirm an actual return",
    returnHelp: "The accountant confirms the returned value and selects the difference expense destination for this receipt. No cash or revenue is created.",
    returnReceipt: "Approved return receipt",
    confirmedValue: "Confirmed returned value",
    returnAboveCost: "Returned value cannot exceed the original cost of the returned quantity.",
    differenceCategory: "Difference expense category",
    differenceHolder: "Difference expense holder",
    holderProject: "Project",
    holderCommercial: "Commercial PO",
    holderUnallocated: "Unallocated",
    newSchedule: "New schedule for returned tools",
    newToolCode: "New tool code",
    newToolName: "New tool name",
    periods: "Allocation months",
    startMonth: "New schedule start month",
    scheduleCategory: "New schedule expense category",
    projectPermission: "Project read permission is required to select a project destination; contact the access administrator.",
    disposed: "Disposed cost",
    returnLineage: "Return source",
    operationSale: "Sale",
    operationResolveMissing: "Resolve missing sources",
    operationCorrection: "Correction",
    operationStockTransfer: "Stock transfer",
    operationActualReturn: "Actual return",
    statusConfirmed: "Confirmed",
    statusPartial: "Partial",
    statusMissingCost: "Missing cost",
    statusConflict: "Source conflict",
  },
  outboxDiagnostics: {
    title: 'Outbox diagnostics', description: 'Read dispatch status for services you are authorized to inspect. Opening this page sends no work.',
    chooseOwner: 'Choose a service to read its current outbox.', noAccess: 'You do not have permission to read any service diagnostics.',
    ownerTitle: '{owner} outbox', refresh: 'Refresh snapshot', all: 'All', apply: 'Apply filters', from: 'From (local time)', to: 'To (local time)',
    state: 'Dispatch state', eventKind: 'Event kind', otherEvent: 'Unregistered event kind', occurred: 'Occurred at', nextAttempt: 'Next scheduled attempt',
    processedAt: 'Marked dispatched at', failureCount: 'Stored failure count', errorClass: 'Error category', records: 'Outbox records', emptyPage: 'No records on this page.',
    observed: 'Observed at {at}', filtered: 'Filtered source observation', serviceWide: 'Service-wide observation', oldestAge: 'Oldest pending age (seconds): {seconds}',
    stale: 'This snapshot is older than two minutes. Refresh for current state. This is a refresh hint, not an SLO.',
    future: 'The observation time is ahead of this device. Verify the clocks before interpreting freshness.',
    pageCaption: 'Page {page} / {pages} · {shown} displayed / {total} matching records',
    unavailable: 'This service observation is unavailable.', invalidFilters: 'Check the date range and filter values, then read again.',
    limitationsTitle: 'What this observation can establish',
    owners: { identity: 'Identity', config: 'Master data', project: 'Project', workforce: 'Workforce', reporting: 'Reporting', document: 'Document', workflow: 'Workflow', chat: 'Chat', procurement: 'Procurement' },
    states: { ready: 'Ready', scheduled: 'Scheduled', processed: 'Marked dispatched' },
    loadStates: { notLoaded: 'Not loaded', loading: 'Reading source…', ready: 'Source observation received', partial: 'Partial observation', empty: 'No matching records', unavailable: 'Source unavailable', forbidden: 'Current read access was denied' },
    errorClasses: { none: 'No stored error', unclassified: 'Stored error; not classified for retry' },
    summary: { total: 'Matching records', ready: 'Ready', scheduled: 'Scheduled', processed: 'Marked dispatched', pendingWithFailures: 'Pending with failures', maximumFailureCount: 'Highest stored failure count' },
    limitations: {
      non_atomic_observation: 'Counts and rows are an observation across reads, not an atomic snapshot.',
      inconsistent_observation: 'The source changed between reads; refresh before interpreting its counts.',
      dispatch_not_consumer_ack: 'Dispatched does not prove that a consumer applied the event.',
      failure_count_not_attempt_count: 'Stored failure count is not the total number of publish attempts.',
      unregistered_event_kind: 'An event kind is outside the compiled registry; its raw type is hidden.',
      future_pending_timestamp: 'Some pending timestamps are in the future; verify clock consistency.',
      query_timeout: 'The source read timed out.', query_unavailable: 'The source could not be read.', other: 'The source reports an additional completeness limitation.'
    },
  },
  customerFinance: {
    reasons: {
      projectScope: 'Only readable projects are included.', projectSourceIncomplete: 'The project source did not return a complete set.',
      projectSourceLimit: 'The project source reached its processing limit; totals are incomplete.', projectSourceUnavailable: 'The project source is unavailable.',
      invoiceSourceLimit: 'The invoice source reached its processing limit; totals are incomplete.', legacyCustomerUnresolved: 'Some legacy invoices cannot be assigned to a verified customer.',
      invoiceCurrencyMissing: 'An invoice has no verified currency.', invoiceCustomerMismatch: 'Customer links on a readable invoice are inconsistent.',
      invoiceOwnerUnresolved: 'An invoice owner could not be verified.', invoiceSourceChanged: 'An invoice changed during calculation; refresh to recalculate.',
      invoiceAmountMissing: 'An invoice amount is missing.', invoiceBalanceInvalid: 'An invoice balance needs reconciliation.',
      invoiceDueDateMissing: 'A positive receivable has no due date; its overdue amount is unknown.',
    },
    title: 'Revenue and receivables', revenue: 'Contract revenue', invoices: 'Invoices and receivables',
    basis: 'Current documents, separated by currency. Contract revenue is before VAT; invoice balances use invoice amounts including VAT. These figures are not added together or converted into another currency.',
    revenueBasis: 'Signed Active/Completed contracts, before VAT. Totals include all eligible contracts within the readable customer scope, independently of the document page.',
    invoiceBasis: 'Issued invoices and their recorded payments. Overdue balances use the current business date; this is not a historical period-end balance.',
    complete: 'Totals across the customer scope verified by this source.', partial: 'Partial coverage: totals cover only the records that this source could verify and authorize.',
    observed: 'Calculated: {at}', incompleteData: 'Some source data could not be verified. Unknown amounts are shown as —.',
    invalidSource: 'The returned financial source does not match this customer.',
    currency: 'Currency', contractAmount: 'Contract value, before VAT', records: 'Contracts', invoiced: 'Invoiced, including VAT',
    collected: 'Collected against invoices', outstanding: 'Receivable balance', overdue: 'Overdue balance',
    noTotals: 'No verified totals for this source and scope. This does not establish a zero balance for the whole customer.',
    sourceRecords: 'Source documents ({total})', sourceRecordsLabel: 'Financial source documents', document: 'Document', date: 'Document date', page: 'Page {page}/{total}',
  },
  customerProjectActivity: {
    coverage: "Select a project from the loaded customer page, then load each source separately. Counts belong to that project, not the whole customer. Monetary values retain their currency and are not added together.",
    project: "Selected project", chooseProject: "Choose a loaded project",
    loaded: "{loaded}/{total} project records loaded", load: "Load source", projectLink: "Open project workspace",
    receivedAt: "Received {at}",
  },
  customerActivity: {
  "title": "Activity and follow-ups",
  "coverage": "History from loaded pages. Project milestones are planned dates, not transactions. Changing the project page replaces its displayed milestones.",
  "forbidden": "No permission for this source",
  "projectPage": "Project page {page}/{pages}: {loaded}/{total} projects",
  "interactionsLoaded": "{loaded}/{total} interactions loaded",
  "partial": "Partially loaded",
  "currentPages": "Current pages loaded",
  "receivedAt": "Received {at}",
  "needsAction": "Needs action",
  "needsActionEmpty": "No open follow-up in the loaded pages.",
  "filter": "Filter source",
  "noLoadedEvents": "No loaded activity matches this filter.",
  "sources": {
    "quotation": "Quotations", "contract": "Contracts", "document": "Documents", "survey": "Surveys",
    "project": "Projects",
    "interaction": "Customer interactions"
  },
  "kinds": {
    "quotationSubmitted": "Quotation submitted", "quotationValidity": "Quotation validity date", "quotationUndated": "Quotation without event date",
    "contractSigned": "Contract signed", "contractEffective": "Contract effective date", "documentUploaded": "Document uploaded", "surveyRecorded": "Survey date",
    "projectStart": "Planned start",
    "projectEnd": "Planned finish",
    "interaction": "Interaction date",
    "followUp": "Open follow-up due"
  }
},
  todayWork: {
  "loadedEmpty": "No loaded work matches the current filters.",
  "title": "Today",
  "description": "Everything on your plate today: project work, approvals, customer follow-ups, personal tasks and meetings.",
  "sourceStatus": "Source status",
  "coverage": "Only loaded work is sorted. Data can change between reads; load more or refresh each source to update it. Calendar warranty and reminder layers retain the calendar date range.",
  "loadedOverdueCount": "{n} loaded overdue items",
  "loadedCount": "{n} items loaded",
  "loadMore": "Load more",
  "groupFilter": "Filter by due date",
  "delegated": "Delegated approval",
  "reminded": "Reminder sent",
  "escalated": "Escalated",
  "summary": "You have {overdue} overdue items, {today} due today and {events} calendar events today.",
  "openCalendar": "Open calendar",
  "tasksTitle": "To do",
  "search": "Search work",
  "allDue": "Any due date",
  "allSources": "All",
  "quickAdd": "Add a personal task for today (Enter)",
  "add": "Add",
  "allClear": "Nothing left to do — you are all caught up!",
  "clearFilters": "Clear filters",
  "daysLate": "{count} days late",
  "todayAt": "Today {time}",
  "open": "Open {name}",
  "openShort": "Open",
  "agendaTitle": "Today’s schedule",
  "agendaError": "Could not load the calendar.",
  "agendaEmpty": "No events today.",
  "allDay": "All day",
  "happeningNow": "Happening now",
  "upNext": "Up next",
  "needsResponse": "Not answered",
  "join": "Join",
  "greeting": {
    "morning": "Good morning, {name}",
    "noon": "Good day, {name}",
    "afternoon": "Good afternoon, {name}",
    "evening": "Good evening, {name}",
  },
  "stats": {
    "overdue": "Overdue",
    "today": "Due today",
    "approval": "Awaiting your approval",
    "followUp": "Follow-ups due",
    "events": "Events today",
  },
  "batches": {
    "TimesheetApprovals": "{count} timesheets awaiting approval",
    "ReportReviews": "{count} reports awaiting review",
  },
  "batchSources": {
    "timesheets": "Timesheets to approve",
    "reports": "Reports to review",
  },
  "groups": {
    "overdue": "Overdue",
    "today": "Today",
    "upcoming": "Upcoming",
    "undated": "No due date"
  },
  "states": {
    "notLoaded": "Not loaded",
    "loading": "Loading",
    "ok": "Current pages loaded",
    "empty": "No work",
    "forbidden": "No permission for this source",
    "error": "Could not load this source",
    "partial": "Partially loaded — not the full set"
  }
},
  customerInteractions: {
    title: "Customer interactions",
    customer: "Customer",
    contact: "Contact",
    channel: "Channel",
    occurredOn: "Interaction date",
    notes: "Notes",
    owner: "Owner",
    followUpOn: "Follow-up date",
    completed: "Follow-up completed",
    followUpState: "Follow-up status",
    channels: {
      Call: "Call",
      Email: "Email",
      Meeting: "Meeting",
      Other: "Other",
    },
    states: {
      open: "Open",
      due: "Due today",
      overdue: "Overdue",
      completed: "Completed",
    },
  },
  contextCreate: {
    quotation: "Create quotation",
    purchaseRequest: "Create purchase request",
    paymentRequest: "Create payment request",
  },
  sourceStates: {
    notLoaded: "Not loaded", loading: "Loading", ok: "Current pages loaded", empty: "No records",
    partial: "Partially loaded — not the full set", forbidden: "No permission for this source", error: "Could not load this source",
  },
  globalSearch: {
    recent: "Recently opened records",
    documentsMetadataHint: "Searches register metadata; file access is checked separately.",
    seeMore: "See more results",
    forbidden: "You no longer have permission to read this source.",
    sourceError: "This source could not be loaded.",
    placeholder: "Search customers, projects, materials, products, document registers, my approvals…",
    partialError: "Some groups could not load. Try again.",
    empty: "No matching results.",
  },
  annualLeave: {
    monthlySummary: "Leave ledger for {month} (through selected date)",
    monthOpening: "Opening monthly balance",
    monthCredits: "Credits this month",
    monthUsed: "Leave used this month",
    monthClosing: "Closing balance",
    exhausted: "Annual leave balance is exhausted. Check before approving leave.",
    probation: "On probation: leave is not credited yet. Eligible months are credited when employment becomes official.",
    accrualSummary: "Entitlement: {annual} days/year · Accrued leave: {accrued} days.",
    accrualHelp: "From 2027: the first month of the year receives the rest of the entitlement, later months add 1 day (entitlement 14: January adds 3); joining or leaving during the year is prorated by months worked, rounded up to half a day. 2026 and earlier accrue annual entitlement / 12 × eligible months. Probation months are credited when employment becomes official.",
    payrollSource: "Payroll uses this ledger balance as of the payroll period end date.",
    title: "Annual leave ledger",
    subtitle:
      "Statutory entitlements from HR-certified facts with an adjustment history.",
    asOf: "As of",
    balance: "Leave balance",
    calculated: "Calculated entitlement",
    category: "Employment category",
    certification:
      "I certify the opening balance, service, eligibility and qualifying periods.",
    days: "Days",
    effectiveDate: "Effective date",
    employee: "Employee",
    entry: "Record leave entry",
    history: "Credit and adjustment history",
    kind: "Entry type",
    months: "Qualifying months",
    noOpening:
      "Opening balance is not certified; available balance is unknown.",
    ownOnly: "You are viewing your own annual leave balance. HR manages everyone's detailed ledger.",
    openingHelp:
      "Enter an evidenced opening balance. Work intervals are minutes from midnight, excluding breaks.",
    policy: "Entitlement policy",
    retry: "Retry pending entry",
    retryHelp: "Outcome is unknown. Retry the same entry to avoid duplicates.",
    serviceYears: "Completed service years",
    source: "Source and evidence",
    used: "Used",
    usage: "Approved leave usage",
    year: "Entitlement year",
    workingInterval: "Work interval {number}: start / end minute",
    Opening: "Opening balance",
    Grant: "Entitlement grant",
    Adjustment: "Adjustment",
    Normal: "Normal conditions",
    ProtectedOrHazardous: "Statutory 14-day category",
    EspeciallyHazardous: "Especially hazardous work",
    normalDays: "Normal annual days",
    protectedOrHazardousDays: "Protected/hazardous annual days",
    especiallyHazardousDays: "Especially hazardous annual days",
    seniorityYearsPerDay: "Service years per increment",
    seniorityDays: "Days per service increment",
  },
  exchangeRates: {
    title: "Exchange rates",
    description:
      "Maintain rates by currency pair and effective date. Automatic rates are averaged at 09:00 when bank quotes are sufficient; accepted document rates are never changed.",
    newTitle: "Set exchange rate",
    editTitle: "Edit exchange rate",
    listTitle: "Exchange-rate list",
    cancelEdit: "Exit edit",
    automaticSource: "Automatic · bank average",
    automaticLocked: "Automatic rates are read-only and updated by the system when bank data is sufficient.",
    sourceCurrency: "Source currency",
    targetCurrency: "Target currency",
    rate: "Target units per source unit",
    effectiveDate: "Effective date",
    sourceName: "Rate source",
    active: "Active",
    effectiveOn: "Effective through",
    sourceHint: "Bank or manual quote source",
  },
  payroll,
  ownFollowUp: {
    title: "My follow-up",
    readOnly: "Read-only detail for your assigned follow-up. Open the interaction directory to act with your existing permissions.",
    missing: "This follow-up no longer exists or is outside your ownership scope.",
    openDirectory: "Open interaction directory",
  },
  notificationAdmin: {
    retryAdmissionQueued: "Retry work was queued. This does not confirm notification delivery.",
    retryAdmissionUnknown: "The retry request outcome is unknown. Look up this operation before taking another action.",
    retryAdmissionInvalid: "The retry receipt does not match this request. Reconciliation is required.",
    retryAdmissionMissing: "No committed receipt is visible yet. Keep checking this operation; another retry has not been authorized.",
    retryStorageLimited: "New retry requests are blocked because this browser cannot retain their lookup keys. Reconcile pending operations or allow browser session storage.",
    lookupRetryOperation: "Look up retry result",
    diagnosticsScope: "Notification operational diagnostics",
    deliveryScope: "Notification delivery — all notifications, independent of list filters",
    deliveryUnavailable: "Delivery metrics are unavailable; normal operation cannot be confirmed.",
    deliveryIncomplete: "Delivery metrics are incomplete; check the processing state.",
    deliveryFailed: "Failed deliveries",
    deliveryDue: "Due and not delivered",
    deliverySending: "Sending",
    deliveryExpired: "Expired processing claims requiring reconciliation",
    deliveryOldestDue: "Oldest overdue age (seconds)",
    backlog: "Pending work",
    oldestPendingAge: "Oldest pending age (seconds)",
    errorClass: "Error category",
    maximumAttempts: "Maximum attempts",
    pendingAge: "Pending age (seconds)",
    diagnosticHelp: "Counts describe processing and delivery, not inbox receipt. Reconcile unknown outcomes before retrying.",
    title: "Notification settings",
    subtitle: "Configure recipients and frequency by event.",
    enabled: "Enabled",
    disabled: "Disabled",
    recipients: "Recipients",
    users: "Users",
    roles: "Global roles",
    related: "People related to this item",
    audienceMode: "Audience mode",
    conditions: "Trigger conditions",
    replace: "Replace default recipients",
    extend: "Extend default recipients",
    fields: "Notify when any selected field changes",
    sampleFields: "Changed fields in the sample",
    origin: "Change origin",
    beforeStatus: "Previous status",
    afterStatus: "New status",
    includeActor: "Include the person making the change",
    frequency: "Frequency",
    immediate: "Immediately",
    grouped: "Group for 5 minutes",
    saveDraft: "Save draft",
    publish: "Publish",
    restore: "Restore defaults",
    preview: "Preview",
    evaluate: "Evaluate sample",
    history: "History",
    reload: "Reload",
    close: "Close",
    version: "Version",
    failed: "Unable to complete the operation. Please try again.",
    conflict: "The rule has changed. Reload before editing again.",
    draftSaved: "Draft saved.",
    published: "Settings published.",
    restored: "A new default revision has been published.",
    workflowOwned: "Managed by Workflow",
    openWorkflow: "Open Workflow settings",
    configure: "View settings",
    defaults: "Defaults",
    proposed: "Proposed settings",
    module: "Module",
    moduleKey: "Module",
    eventKey: "Event",
    allModules: "All modules",
    searchEvents: "Find an event…",
    loading: "Loading…",
    empty: "No matching records.",
    searchRecipients: "Search by name…",
    inactive: "Inactive",
    lookupFailed: "Unable to load recipients.",
    refineSearch: "More results are available. Refine your search.",
    previewHelp:
      "Evaluate the current editor settings using a sample. This does not send notifications.",
    targetType: "Content type",
    targetId: "Content ID",
    parentId: "Parent Project ID (when required)",
    actor: "Sample actor",
    matched: "Matched",
    notMatched: "Not sent",
    directory: "Recipient lookup result",
    unavailableSelectors: "Unavailable historical recipients",
    fanout: "Recipients / limit",
    excluded: "Excluded people and reasons",
    target: "Destination",
    occurrences: "Notification processing history",
    status: "Status",
    from: "From",
    to: "To",
    filter: "Filter",
    pages: "Pages",
    previous: "Previous",
    next: "Next",
    attempts: "Attempts",
    retryReason: "Reason for retry",
    retry: "Retry processing",
    noPermission:
      "You do not have permission to view notification audit history (requires NotificationRules.Read).",
    viewFull: "View full screen",
    viewDetails: "View details",
    delivery: "Delivery",
    policySnapshot: "Settings captured at receipt",
    factSnapshot: "Recorded change",
    selectors: {
      project_creator: "Project creator",
      project_sales: "Project Sales",
      project_leader: "Current Project leader",
      project_previousLeader: "Previous Project leader",
      project_newLeader: "New Project leader",
      project_members: "Project members",
      project_relatedUsers: "People related to the Project change",
      wbs_pic: "PIC of the affected WBS",
      wbs_addedPic: "Newly assigned PIC",
      wbs_removedPic: "Removed PIC",
      issue_owner: "Issue owner",
      issue_actionPic: "Action PIC",
      project_requester: "Request submitter",
      owner_relatedUsers: "People related to the document",
      closure_reviewers: "Project closure reviewers",
    },
    noOccurrenceSelected: "No record selected",
    noOccurrenceSelectedHint: "Select an event in the list above to see its recipients and delivery results.",
    noRuleSelected: "No notification setting selected",
    noRuleSelectedHint: "Click \"View settings\" or select a row above to edit recipients and sending conditions.",
  },
  ...completionEn,
  materialTemporaryDetails: {
    totalAmount: "Total amount",
    submittedDate: "Submitted date",
    createdBy: "Created by",
    createdDate: "Created date",
  },
  productTemporaryDetails: {
    submittedDate: "Submitted date",
    createdBy: "Created by",
    createdDate: "Created date",
  },
  organizationTemporaryDetails: {
    phone: "Phone No",
    fax: "Fax No",
    submittedDate: "Submitted date",
    createdBy: "Created by",
    createdDate: "Created date",
  },
  partnerColumns: {
    name: "Partner name",
    shortName: "Partner short name",
    ownershipCountry: "Ownership country",
    legalRepresentative: "Legal representative",
    address: "Address",
    industry: "Business industry",
    fax: "Fax No:",
    contact1: "Contact person 1",
    contact2: "Contact person 2",
    contact3: "Contact person 3",
    contact4: "Contact person 4",
    placeholders: {
      name: "ABC Trading Co., Ltd.",
      shortName: "ABC Corp",
      ownershipCountry: "VN",
      legalRepresentative: "John Smith",
      industry: "Import - Export",
      address: "123 Nguyen Hue Street, District 1, Ho Chi Minh City",
    },
  },
  supplierColumns: {
    name: "Supplier Name",
    shortName: "Supplier short name",
    materialCount: "Material Count",
    placeholders: { name: "XYZ Supplier Co., Ltd.", shortName: "XYZ Supply" },
  },
  customerTemporaryDetails: {
    title: "Customer information (temporary)",
    help: "These fields are UI-only and are not sent to the backend.",
    fields: {
      endUser: "Customer name",
      customerShortName: "Customer short name",
      companyCategory: "Company category",
      ownershipCountry: "Ownership country",
      factoryCount: "Factory count",
      projectCount: "Project count",
      region: "Region",
      taxOrBusinessCode: "Tax ID",
      legalRepresentative: "Legal representative",
      address: "Address",
      businessIndustry: "Business industry",
      bankName: "Bank",
      bankAccountNumber: "Account number",
      transactionCurrency: "Currency",
      vatRate: "VAT (%)",
      creditDays: "Credit days",
      recurringPaymentDay: "Recurring payment day",
      companyPhone: "Phone No",
      faxNumber: "Fax No",
      contact1Name: "Contact person 1",
      contact1Department: "Department",
      contact1Position: "Position",
      contact1Phone: "Phone No",
      contact1Email: "Email",
      contact2Name: "Contact person 2",
      contact2Department: "Department",
      contact2Position: "Position",
      contact2Phone: "Phone No",
      contact2Email: "Email",
      contact3Name: "Contact person 3",
      contact3Department: "Department",
      contact3Position: "Position",
      contact3Phone: "Phone No",
      contact3Email: "Email",
      salesOwner: "Sales owner",
      submittedDate: "Submitted date",
      createdBy: "Created by",
      createdDate: "Created date",
    },
    placeholders: {
      endUser: "ABC Trading Co., Ltd.",
      customerShortName: "MMT",
      companyCategory: "Limited Liability Company",
      taxOrBusinessCode: "0123456789",
      legalRepresentative: "John Smith",
      businessIndustry: "Import - Export",
      ownershipCountry: "VN",
      region: "Ho Chi Minh City",
      salesOwner: "Select sales owner",
      companyPhone: "0987654321",
      faxNumber: "028-3822-1234",
      transactionCurrency: "USD",
      vatRate: "10",
      createdBy: "Nguyen Van A",
      address: "123 Nguyen Hue Street, District 1, Ho Chi Minh City",
    },
  },
  menu: {
    overview: "Overview",
    crmMaster: "CRM Master",
    projectManagement: "Projects",
    workforceOperations: "People & operations",
    governance: "Governance & catalogs",
    finance: "Finance & accounting",
    externalProgress: "External progress",
    administration: "Administration",
    operatingCost: "Operating costs",
    attendanceGroup: "Attendance & calendar",
    crm: "CRM",
    purchasing: "Purchasing",
    accounting: "Accounting",
    hrAdministration: "Administration & HR",
    system: "System",
    paymentVouchers: "Payment vouchers",
    cashAndBank: "Cash & bank",
    invoices: "Invoices",
    financeReports: "Reports & period close",
    accountingCatalogs: "Accounting catalogs",
    requestsGroup: "Requests & receipts",
    projectMyWork: "My work",
    projectRegister: "Projects",
    projectExecution: "Execution",
    projectReports: "Project reports",
    projectExternal: "External sharing",
    trackingWarnings: "Warnings",
    externalCustomer: "Customer",
    externalSubcontractor: "Subcontractor",
    execution: "Project tracking",
    organizations: "Partners & suppliers",
    salesDocuments: "Quotations & contracts",
    documentTemplates: "Document templates",
    procurementDocuments: "Requests & orders",
    warehouse: "Warehouse",
    notificationSettings: "Notifications",
    audit: "Audit & usage",
    diagnostics: "System diagnostics",
    favorites: "Favorites",
    recent: "Recent",
    addFavorite: "Pin {name} to Favorites",
    removeFavorite: "Remove {name} from Favorites",
    pendingApprovals: "{count} pending approvals",
    payrollGroup: "Payroll",
    usersAndAccess: "Users & access",
    search: "Search menu…",
    toggle: "Toggle navigation",
    breadcrumb: "Breadcrumb",
    theme: "Switch color theme",
    detail: "Detail",
    copyright: "Copyright © 2014–{year} NMI. All rights reserved.",
  },
  table: {
    records: "records",
    filter: "Filter",
    sort: "Sort",
    selectAll: "Select all",
    searchValues: "Search values",
    pageSize: "Rows per page",
    firstPage: "First page",
    previousPage: "Previous page",
    nextPage: "Next page",
    lastPage: "Last page",
    goToPage: "Go to page {page}",
    resizeColumnHint: "Drag to resize, double-click to reset",
    columns: "Columns",
    chooseColumns: "Choose visible columns",
    resetColumns: "Reset columns",
    columnLocked: "Always shown",
    rowNumber: "No.",
  },
  setup: {
    expand: "Expand section",
    collapse: "Collapse section",
    update: "Update",
    fieldOrder: "Field order",
    resetOrder: "Reset field order",
    expandSide: "Show revision history",
    collapseSide: "Hide revision history",
  },
  workflow: {
    saveDraft: "Save draft",
    submitApproval: "Submit for approval",
    saveAndSubmit: "Save and submit",
    savedNotSubmitted:
      "Draft saved but not submitted. You can retry submission.",
  },
  referenceData: {
    unavailable:
      "Some reference data is unavailable with your current permissions. Primary records remain visible; dependent actions are disabled.",
  },
  permissionCatalog: {
    features: {
      EmployeeProfiles: "Employee profiles",
      SkillAssessments: "Skill map – skill assessments",
      SkillCatalogs: "Skill catalog and rating scale",
      OperationalRequests: "Requests: leave, overtime, business trip, onsite, vehicle, meals, time correction",
      AdministrativeReceipts: "Received records – HR & Admin",
      AccountingReceipts: "Received records – Accounting",
      AnnualLeave: "Annual leave ledger",
      Timesheets: "Project timesheets (hours logged in Projects › Execution › My work)",
      TimesheetApprovals: "Timesheet approvals",
      TimesheetPeriods: "Timesheet period lock",
      Capacity: "Capacity and workload",
      CompanyCalendars: "Company work calendar – drafting",
      CompanyCalendarApprovals: "Company work calendar – approval",
      Attendance: "Attendance administration (time clock)",
      Payroll: "Payroll and payslips",
      MandayCosts: "Manday cost",
      CompanyVehicles: "Company vehicle fleet",
      ControlledDocuments: "Controlled document register",
      ApprovalTasks: "Approval inbox (workflow approval steps)",
      WorkflowActivities: "Workflow tasks (non-approval)",
      ProjectDashboards: "Operations center: project portfolio, resources",
      ExecutionWarnings: "Schedule and health warnings",
      Notifications: "My notifications",
      Chat: "Internal chat (project chat)",
      Projects: "Projects and project registration",
      ProjectRegistrationInbox: "Project registration inbox",
      ProjectLeaders: "Project leader assignment",
      WbsNodes: "WBS structure and my work",
      Execution: "Project tracking: resource allocation, task assignment, progress updates",
      ProjectMilestones: "Project milestones (planned, actual)",
      ExternalProgress: "External progress",
      WbsTemplates: "WBS templates by product type",
      Reports: "Project reports",
      ReportSchedules: "Scheduled report delivery",
      Issues: "Issues: countermeasures, delivery, tracking",
      Lessons: "Lessons learned library",
      CustomerSurveys: "Customer satisfaction surveys",
      ProjectClosureReviews: "Project closure reviews by role",
      ProjectClosureConclusions: "Project closure conclusion",
      ProjectClosures: "Project closure sign-off",
      Customers: "Customers",
      CustomerInteractions: "Customer interactions",
      ProjectCommunications: "Customer communication log per project",
      CustomerHistory: "Customer project financial history",
      FinancialProfiles: "Financial profiles of customers, partners, suppliers",
      Partners: "Partners",
      Suppliers: "Suppliers",
      Products: "Products",
      ProductCategories: "Product categories",
      ProductRevisions: "Product revisions",
      CustomerProducts: "Customer products",
      Quotations: "Quotations",
      QuotationLines: "Cost prices in quotations",
      ProjectContracts: "Contracts and acceptance records",
      WarrantyTickets: "Warranty and after-sales tickets",
      DocumentTemplates: "Document templates: quotation, contract, RFQ, P/O",
      PurchaseRequests: "Purchase requests (PR)",
      PurchaseOrders: "Purchase orders (P/O)",
      MaterialStock: "Warehouse: receipts, issues, stock",
      Materials: "Materials and parts catalog",
      PaymentRequests: "Advance, payment and settlement requests",
      ProjectInvoices: "Sales invoices (per project)",
      SupplierInvoices: "Supplier invoices and payables",
      CashBook: "Cash and bank book",
      BankStatements: "Bank statements (account 112)",
      Finance: "Financial statements and period close",
      Amortizations: "Prepaid expenses and tool amortization",
      ExpenseCategories: "Expense code catalog",
      ExchangeRates: "Exchange rates",
      Users: "User accounts",
      Roles: "Roles and account groups",
      Departments: "Departments",
      WorkflowDefinitions: "Workflow definitions",
      WorkflowInstances: "Workflow runs",
      NotificationRules: "Notification settings",
      SystemSettings: "System settings",
      AuditTrail: "System log and permission audit",
      SystemDiagnostics: "Technical diagnostics (Outbox)",
      Documents: "Shared attachments",
    },
    featureHelp: {
      EmployeeProfiles: "Employee profiles menu. Everyone can always view, fill in and submit their own profile without any grant.",
      SkillAssessments: "Skill map screen: periodic skill assessments.",
      SkillCatalogs: "Skill catalog and scoring scale used in skill assessments.",
      OperationalRequests: "Requests & receipts menu. Every account can always create, edit, submit and view its own requests; the permissions below are for people who review, confirm or approve other people's requests.",
      AdministrativeReceipts: "«Received records» tab on the HR & Admin side: approved requests routed to HR & Admin.",
      AccountingReceipts: "«Received records» tab on the Accounting side: approved requests with costs routed to Accounting.",
      AnnualLeave: "Annual leave tab. Everyone can always see their own leave balance.",
      Timesheets: "Projects › Execution › My work: each person logs hours on the task row and submits the day.",
      TimesheetApprovals: "Approval inbox › Timesheets: part monitoring and the «By team» view.",
      TimesheetPeriods: "Lock a period so nobody can change timesheets of a closed period.",
      Capacity: "Standard hours, missing hours and overload per employee on Timesheets and Overview.",
      CompanyCalendars: "Work calendar tab: company working days, days off and holidays per year.",
      CompanyCalendarApprovals: "Confirmation and approval of the company work calendar before it applies.",
      Attendance: "Attendance administration tab: time clock data and monthly attendance sheets.",
      Payroll: "Payroll menu: Payroll tab and My payslips tab.",
      MandayCosts: "Manday cost tab in Payroll: day rates used to cost projects.",
      CompanyVehicles: "Administration menu › Company vehicle fleet tab.",
      ControlledDocuments: "Administration menu › Controlled documents tab (opening the tab also needs Documents.Read – shared attachments, System group).",
      ApprovalTasks: "Work inbox › Approval inbox tab: workflow approval steps assigned to you or your group.",
      WorkflowActivities: "Non-approval workflow steps, e.g. receiving or processing a record.",
      ProjectDashboards: "Overview › Operations center: project portfolio, resources.",
      ExecutionWarnings: "Schedule delay and risk warnings on the Operations center.",
      Notifications: "Notification bell on the top bar.",
      Chat: "Chat panel on the top bar and the Discussion tab of a project.",
      Projects: "Project management menu and the project record: register → confirm → approve → execute → close.",
      ProjectRegistrationInbox: "Project registrations waiting for someone to handle them.",
      ProjectLeaders: "Assign or change the leader of an approved project.",
      WbsNodes: "Projects › Execution › My work and the WBS tree of a project.",
      Execution: "Projects › Execution › Warnings and the resource, assignment and progress-update parts of the project WBS & Gantt.",
      ProjectMilestones: "Planned and actual milestones of a project.",
      ExternalProgress: "Projects › External sharing: Customer and Subcontractor views.",
      WbsTemplates: "WBS templates used to build the WBS of a new project.",
      Reports: "Projects › Execution › Project reports (and the Finance report catalog under Accounting › Reports & period close).",
      ReportSchedules: "Project reports › ⋯ menu › Scheduled report delivery.",
      Issues: "The Request tracking tab (issues, countermeasures) of a project.",
      Lessons: "Project reports › Lessons learned block.",
      CustomerSurveys: "Customer satisfaction surveys at handover and project closure.",
      ProjectClosureReviews: "Project › Closure: each role enters its own review.",
      ProjectClosureConclusions: "Project › Closure: overall conclusion and closure approval.",
      ProjectClosures: "Sign the project closure record on behalf of the company.",
      Customers: "Customers menu. The Partners & suppliers menu (Partners, Suppliers tabs) also opens with View customers.",
      CustomerInteractions: "Customers › Customer interactions tab (also needs View customers).",
      ProjectCommunications: "Customer communication log on customer and partner records.",
      CustomerHistory: "Revenue and receivables of a customer's projects.",
      FinancialProfiles: "Tax code, bank accounts, payment terms of customers, partners, suppliers.",
      Partners: "Partners & suppliers › Partners tab.",
      Suppliers: "Partners & suppliers › Suppliers tab.",
      Products: "Products menu.",
      ProductCategories: "Product groups and classification.",
      ProductRevisions: "Revisions of a product.",
      CustomerProducts: "Links between products and the customers using them.",
      Quotations: "Quotations & contracts › Quotations tab.",
      QuotationLines: "Cost and expense columns of the quotation sheet.",
      ProjectContracts: "Quotations & contracts › Customer POs, Contracts & warranty tabs.",
      WarrantyTickets: "Quotations & contracts › Contracts & warranty tab.",
      DocumentTemplates: "Document templates menu.",
      PurchaseRequests: "Requests & orders › Purchase requests tab.",
      PurchaseOrders: "Requests & orders › Purchase orders tab.",
      MaterialStock: "Warehouse menu: stock, stocktake, receipts and issues.",
      Materials: "Materials & parts menu.",
      PaymentRequests: "Payment vouchers menu: advances, payments, settlements.",
      ProjectInvoices: "Invoices › Invoice issuance status tab.",
      SupplierInvoices: "Invoices › Supplier invoices tab.",
      CashBook: "Cash & bank › Cash book tab.",
      BankStatements: "Cash & bank › Bank statements tab.",
      Finance: "Reports & period close › Company financial statement, Month close tabs.",
      Amortizations: "Reports & period close › Prepaid and tools tab.",
      ExpenseCategories: "Accounting catalogs › Expense codes tab.",
      ExchangeRates: "Accounting catalogs › Exchange rates tab.",
      Users: "Users & access › Accounts tab.",
      Roles: "Users & access › Roles, Account groups, Permission catalog tabs.",
      Departments: "Users & access › Departments tab.",
      WorkflowDefinitions: "Workflow Definitions menu: steps and routing.",
      WorkflowInstances: "Running workflow of each record.",
      NotificationRules: "Notifications menu (System): delivery rules and history.",
      SystemSettings: "System settings menu: organization, security, email, calendar, integrations.",
      AuditTrail: "Audit & usage menu.",
      SystemDiagnostics: "Audit & usage › Outbox diagnostics (for technical administrators).",
      Documents: "Attachments on every screen (projects, purchasing, accounting…) and opening the Controlled documents tab.",
    },
    codes: {
      EmployeeProfiles: {
        Read: "View profile register",
        ReadSensitive: "View sensitive data",
        Manage: "Create, edit profiles",
        UpdateAny: "Edit any profile",
        Approve: "Approve profiles",
      },
      SkillAssessments: {
        Read: "View assessments",
        ReadTeam: "View team skills",
        Manage: "Create, edit assessments",
        Approve: "Approve assessments",
      },
      SkillCatalogs: {
        Read: "View catalog",
      },
      OperationalRequests: {
        Read: "View requests",
        ReadReview: "Review requests",
        Confirm: "Confirm requests",
        Approve: "Approve requests",
      },
      AdministrativeReceipts: {
        Read: "View received records",
        Manage: "Receive, process",
      },
      AccountingReceipts: {
        Read: "View received records",
        Manage: "Receive, process",
      },
      AnnualLeave: {
        Read: "View everyone's leave",
        Manage: "Adjust leave ledger",
      },
      Timesheets: {
        Read: "View own timesheets",
        Manage: "Log, submit timesheets",
      },
      TimesheetApprovals: {
        Read: "View pending timesheets",
        ReadAll: "View company-wide timesheets",
        Approve: "Approve timesheets",
      },
      TimesheetPeriods: {
        Read: "View periods",
        Manage: "Lock, unlock periods",
      },
      Capacity: {
        Read: "View workload",
        Manage: "Import capacity data",
      },
      CompanyCalendars: {
        Read: "View company calendar",
        Manage: "Draft, submit calendar",
      },
      CompanyCalendarApprovals: {
        Read: "View pending calendars",
        Confirm: "Confirm calendar",
        Approve: "Approve calendar",
      },
      Attendance: {
        Read: "View everyone's attendance",
        ReadOwn: "View own attendance",
        Manage: "Import time clock data",
      },
      Payroll: {
        Read: "View payroll",
        ReadOwn: "View own payslips",
        Manage: "Prepare, edit payroll",
        Approve: "Approve payroll",
        Publish: "Publish payslips",
        Send: "Send payslips",
        Export: "Export to Excel",
      },
      MandayCosts: {
        Read: "View",
        ReadSensitive: "View detailed rates",
        Manage: "Create, activate rates",
      },
      CompanyVehicles: {
        Read: "View vehicles",
        Manage: "Manage vehicles, maintenance",
      },
      ControlledDocuments: {
        Read: "View register",
        Manage: "Draft, edit, submit, cancel",
        Confirm: "Confirm documents",
        Approve: "Approve documents",
      },
      ApprovalTasks: {
        Read: "View my approvals",
        ReadAll: "View all approvals",
        Approve: "Approve, reject",
      },
      WorkflowActivities: {
        Manage: "Complete assigned tasks",
      },
      ProjectDashboards: {
        Read: "View Operations center",
      },
      ExecutionWarnings: {
        Read: "View warnings",
      },
      Notifications: {
        Read: "Receive, view notifications",
      },
      Chat: {
        Read: "View chats",
        Manage: "Send, edit, delete messages",
        Moderate: "Moderate chats",
        Export: "Export content",
      },
      Projects: {
        Read: "View related projects",
        ReadAll: "View all projects",
        Manage: "Create, edit, submit registrations",
        UpdateAll: "Edit any registration",
        AssignLeader: "Assign project leader",
        Confirm: "Confirm registrations",
        Approve: "Approve registrations",
        Close: "Close projects",
        Cancel: "Cancel projects",
        ImportHistorical: "Import past projects",
      },
      ProjectRegistrationInbox: {
        Read: "View registration inbox",
        ReadRelated: "View related registrations",
        ReadUnassigned: "View unassigned registrations",
      },
      ProjectLeaders: {
        Read: "View assignments",
        Manage: "Assign, change leaders",
      },
      WbsNodes: {
        Read: "View WBS, my work",
        Manage: "Build, edit WBS",
      },
      Execution: {
        Read: "View execution",
        Manage: "Update progress, assign work",
      },
      ProjectMilestones: {
        Read: "View milestones",
        Manage: "Edit, record actual milestones",
      },
      ExternalProgress: {
        ReadCustomer: "View customer progress",
        ReadSubcontractor: "View subcontractor progress",
      },
      WbsTemplates: {
        Read: "View WBS templates",
        Manage: "Build, publish WBS templates",
      },
      Reports: {
        Read: "View reports",
        Manage: "Create, edit, submit reports",
        Approve: "Review, approve reports",
        Export: "Export reports",
      },
      ReportSchedules: {
        Read: "View schedules",
        Manage: "Set up schedules",
      },
      Issues: {
        Read: "View issues",
        Manage: "Create, handle issues",
        Approve: "Approve, decide issues",
      },
      Lessons: {
        Read: "View lessons",
        Manage: "Add, edit, delete lessons",
      },
      CustomerSurveys: {
        Read: "View surveys",
        Manage: "Create, update surveys",
      },
      ProjectClosureReviews: {
        Read: "View reviews",
        Manage: "Enter reviews",
      },
      ProjectClosureConclusions: {
        Read: "View conclusion",
        Approve: "Approve project closure",
      },
      ProjectClosures: {
        SignProduction: "Sign for Production",
        SignDirector: "Sign for Director",
      },
      Customers: {
        Read: "View customers",
        Manage: "Add, edit, import, delete",
        Export: "Export to Excel",
      },
      CustomerInteractions: {
        Read: "View interactions",
        Manage: "Log interactions",
      },
      ProjectCommunications: {
        Read: "View log",
        Manage: "Write communication log",
      },
      CustomerHistory: {
        ReadFinancial: "View financial history",
      },
      FinancialProfiles: {
        Read: "View financial profiles",
        ReadSensitive: "View bank accounts",
        Manage: "Edit financial profiles",
      },
      Partners: {
        Read: "View partners",
        Manage: "Add, edit, delete partners",
      },
      Suppliers: {
        Read: "View suppliers",
        Manage: "Add, edit, delete suppliers",
      },
      Products: {
        Read: "View products",
        Manage: "Add, edit, import, delete",
        Export: "Export to Excel",
      },
      ProductCategories: {
        Read: "View categories",
        Manage: "Manage categories",
      },
      ProductRevisions: {
        Read: "View revisions",
        Manage: "Create, activate revisions",
      },
      CustomerProducts: {
        Read: "View links",
        Manage: "Link, unlink products",
      },
      Quotations: {
        Read: "View quotations",
        Manage: "Create, edit, submit quotations",
        Export: "Export quotations",
      },
      QuotationLines: {
        ReadSensitive: "View cost prices",
      },
      ProjectContracts: {
        Read: "View contracts",
        Manage: "Create, edit contracts",
      },
      WarrantyTickets: {
        Read: "View warranty tickets",
        Manage: "Create, handle tickets",
      },
      DocumentTemplates: {
        Read: "View templates",
        Manage: "Design, edit templates",
      },
      PurchaseRequests: {
        Read: "View requests",
        Manage: "Create, edit, submit, cancel",
        Quote: "Enter supplier quotes",
        Confirm: "Confirm requests",
        Approve: "Approve requests",
        AdminReceive: "HR & Admin receipt",
        AccountingReceive: "Accounting receipt",
      },
      PurchaseOrders: {
        Read: "View orders",
        Manage: "Create, edit, submit, cancel",
        Deliver: "Record delivery",
      },
      MaterialStock: {
        Read: "View warehouse",
        Manage: "Create receipts, issues",
        Approve: "Approve stock slips",
        BypassApproval: "Post without approval",
        Reverse: "Reverse stock slips",
      },
      Materials: {
        Read: "View materials",
        Manage: "Add, edit, delete materials",
      },
      PaymentRequests: {
        Read: "View related vouchers",
        ReadAll: "View all vouchers",
        Manage: "Create, edit, submit, cancel",
        Approve: "Approve vouchers",
        Disburse: "Disburse",
        ConfirmPaid: "Confirm paid",
      },
      ProjectInvoices: {
        Read: "View invoices",
        Manage: "Issue, edit, void invoices",
        RecordPayment: "Record receipts",
      },
      SupplierInvoices: {
        Read: "View invoices",
        Manage: "Enter, edit invoices",
        RecordPayment: "Record payments",
        ReleasePaymentHold: "Release payment hold",
      },
      CashBook: {
        Read: "View cash book",
        Manage: "Post entries, opening balance",
        Reverse: "Reverse entries",
      },
      BankStatements: {
        Read: "View statements",
        Manage: "Import, reconcile statements",
      },
      Finance: {
        Read: "View statements, month close",
        PeriodClose: "Close month",
        PeriodReopen: "Reopen month",
      },
      Amortizations: {
        Read: "View amortization",
        Manage: "Create, edit amortization",
      },
      ExpenseCategories: {
        Read: "View expense codes",
        Manage: "Manage expense codes",
      },
      ExchangeRates: {
        Read: "View rates",
        Manage: "Enter, edit rates",
      },
      Users: {
        Read: "View accounts",
        Manage: "Create, edit, lock accounts",
        AssignPermissions: "Assign roles, permissions",
        Export: "Export list",
      },
      Roles: {
        Read: "View roles, groups",
        Manage: "Create, edit roles, groups",
        AssignMembers: "Assign members",
        AssignPermissions: "Assign permissions",
      },
      Departments: {
        Read: "View departments",
        Manage: "Manage departments",
      },
      WorkflowDefinitions: {
        Read: "View workflows",
        Manage: "Create, edit, activate workflows",
      },
      WorkflowInstances: {
        ReadAll: "View all runs",
        Manage: "Restart, resync",
        Start: "Start workflows",
      },
      NotificationRules: {
        Read: "View settings",
        Manage: "Edit settings",
      },
      SystemSettings: {
        Read: "View settings",
        Manage: "Edit settings",
      },
      AuditTrail: {
        Read: "View log",
        ReadSensitive: "View sensitive details",
        Export: "Export log",
      },
      SystemDiagnostics: {
        Read: "View diagnostics",
      },
      Documents: {
        Read: "View, download files",
        Manage: "Upload, delete files",
      },
    },
    codeHelp: {
      EmployeeProfiles: {
        Read: "Open Employee profiles and view the list and profile of every employee (sensitive fields excluded).",
        ReadSensitive: "View ID card, address, bank account and other encrypted profile fields.",
        Manage: "Create profiles for new employees, edit and submit profiles for approval.",
        UpdateAny: "Edit any employee's profile directly, including approved profiles.",
        Approve: "Approve or reject submitted employee profiles.",
      },
      SkillAssessments: {
        Read: "Open the Skill map and view skill assessment results.",
        ReadTeam: "View skill assessments of members of the team you lead.",
        Manage: "Create, edit and submit skill assessment forms.",
        Approve: "Approve or reject skill assessment forms.",
      },
      SkillCatalogs: {
        Read: "View the skill catalog and rating scale.",
      },
      OperationalRequests: {
        Read: "Base permission to see other people's requests; grant together with «Review requests».",
        ReadReview: "View everyone's request register for checking (needs «View requests»).",
        Confirm: "Confirm requests at the check step before approval; may reject (needs «View requests» and «Review requests»).",
        Approve: "Approve or reject requests at the approval step (needs «View requests» and «Review requests»).",
      },
      AdministrativeReceipts: {
        Read: "Open the Received records tab and see approved requests routed to HR & Admin.",
        Manage: "Receive and update processing of requests on the HR & Admin side.",
      },
      AccountingReceipts: {
        Read: "Open the Received records tab and see approved requests routed to Accounting.",
        Manage: "Receive and update processing of requests on the Accounting side.",
      },
      AnnualLeave: {
        Read: "View every employee's annual leave ledger.",
        Manage: "Post adjustment entries to the leave ledger (add or deduct leave days).",
      },
      Timesheets: {
        Read: "View your own timesheet history and timesheet reminders.",
        Manage: "Open the Timesheets tab: log, edit and submit timesheets; set timesheet reminders.",
      },
      TimesheetApprovals: {
        Read: "Open the Timesheet approvals tab and see timesheets waiting for you.",
        ReadAll: "View timesheets of every employee and every project.",
        Approve: "Approve or return timesheets.",
      },
      TimesheetPeriods: {
        Read: "View the lock state of timesheet periods.",
        Manage: "Lock or unlock a timesheet period.",
      },
      Capacity: {
        Read: "View standard hours, missing hours and overload per employee.",
        Manage: "Import capacity data (standard hours) for employees.",
      },
      CompanyCalendars: {
        Read: "View the company work calendar per year.",
        Manage: "Draft and edit the company work calendar and submit it for approval.",
      },
      CompanyCalendarApprovals: {
        Read: "View work calendars waiting for confirmation or approval.",
        Confirm: "Confirm a work calendar (step before approval).",
        Approve: "Approve or reject the company work calendar.",
      },
      Attendance: {
        Read: "Open Attendance administration and view time clock data and monthly attendance of everyone.",
        ReadOwn: "View your own monthly attendance.",
        Manage: "Import data from the time clock.",
      },
      Payroll: {
        Read: "Open the Payroll tab and view payroll periods.",
        ReadOwn: "Open the My payslips tab.",
        Manage: "Create payroll periods and edit payroll lines.",
        Approve: "Approve payroll.",
        Publish: "Publish payslips for employees to view.",
        Send: "Send payslips by email.",
        Export: "Export payroll to Excel.",
      },
      MandayCosts: {
        Read: "View manday cost profiles (opening the tab also needs «View detailed rates»).",
        ReadSensitive: "View the detailed rates of each manday cost profile.",
        Manage: "Create and activate manday cost profiles.",
      },
      CompanyVehicles: {
        Read: "Open Company vehicle fleet and view vehicles and maintenance history.",
        Manage: "Add and edit vehicles; record maintenance and servicing.",
      },
      ControlledDocuments: {
        Read: "View the controlled document register and its versions.",
        Manage: "Draft, edit, submit and cancel controlled documents.",
        Confirm: "Confirm documents at the check step before approval.",
        Approve: "Approve or reject controlled documents.",
      },
      ApprovalTasks: {
        Read: "Open the Approval inbox tab and see approval steps assigned to you or your group.",
        ReadAll: "View every approval task of everyone (workflow oversight).",
        Approve: "Approve or reject the assigned approval step.",
      },
      WorkflowActivities: {
        Manage: "Complete an assigned non-approval workflow step.",
      },
      ProjectDashboards: {
        Read: "Open the Operations center: project portfolio, resources.",
      },
      ExecutionWarnings: {
        Read: "View schedule delay and risk warnings of projects.",
      },
      Notifications: {
        Read: "Receive and view your notifications on the notification bell.",
      },
      Chat: {
        Read: "View the chats you take part in and the Discussion tab of projects.",
        Manage: "Send, edit and delete your own messages.",
        Moderate: "Moderate chats: handle other people's messages.",
        Export: "Export chat content to a file.",
      },
      Projects: {
        Read: "Open Project management and view projects you are a member of or related to.",
        ReadAll: "View every project of the company.",
        Manage: "Create, edit and submit project registrations; recover or delete failed drafts.",
        UpdateAll: "Edit the registration of any project without being a member.",
        AssignLeader: "Assign the project leader when approving a registration.",
        Confirm: "Confirm a project registration (step before approval).",
        Approve: "Approve or return a project registration; manage project document types.",
        Close: "Close a completed project.",
        Cancel: "Cancel a project or delete an unapproved registration.",
        ImportHistorical: "Import past projects (from before the software).",
      },
      ProjectRegistrationInbox: {
        Read: "View the registration inbox waiting for you.",
        ReadRelated: "View registrations you are related to (Sales, creator…).",
        ReadUnassigned: "View registrations nobody handles yet.",
      },
      ProjectLeaders: {
        Read: "View assigned project leaders.",
        Manage: "Assign or change project leaders.",
      },
      WbsNodes: {
        Read: "Open the My work tab and view the WBS tree of projects.",
        Manage: "Add, edit and delete WBS items.",
      },
      Execution: {
        Read: "Open Projects › Execution › Warnings and view resource allocation, assignments, progress, WBS dependencies.",
        Manage: "Update progress, allocate resources, assign work, change the plan with a reason.",
      },
      ProjectMilestones: {
        Read: "View planned and actual milestones of projects.",
        Manage: "Edit planned milestones and record actual dates.",
      },
      ExternalProgress: {
        ReadCustomer: "Open the Customer progress tab: progress presented to customers.",
        ReadSubcontractor: "Open the Subcontractor progress tab: progress of subcontracted work.",
      },
      WbsTemplates: {
        Read: "View WBS templates per product type.",
        Manage: "Build, edit and publish WBS templates; set the default template.",
      },
      Reports: {
        Read: "Open the Project reports tab (and the Finance report catalog tab under Accounting).",
        Manage: "Create, edit and submit project reports.",
        Approve: "Review, approve, return or reject reports; open Scheduled report delivery.",
        Export: "Export reports to a file.",
      },
      ReportSchedules: {
        Read: "Open Scheduled report delivery and view schedules.",
        Manage: "Create, edit, enable and disable report schedules.",
      },
      Issues: {
        Read: "Open Request tracking and view project issues.",
        Manage: "Create issues; update countermeasures, delivery, tracking; attach evidence.",
        Approve: "Approve issue tracking; record PIC and confirmation decisions.",
      },
      Lessons: {
        Read: "Open the Lessons learned tab.",
        Manage: "Add, edit and delete lessons learned.",
      },
      CustomerSurveys: {
        Read: "View customer satisfaction surveys.",
        Manage: "Create and update surveys.",
      },
      ProjectClosureReviews: {
        Read: "View closure reviews of every role.",
        Manage: "Enter and edit the closure review of your role.",
      },
      ProjectClosureConclusions: {
        Read: "View the project closure conclusion.",
        Approve: "Approve the project closure conclusion.",
      },
      ProjectClosures: {
        SignProduction: "Sign the closure record in the Production role.",
        SignDirector: "Sign the closure record in the Director role.",
      },
      Customers: {
        Read: "Open Customers and Partners & suppliers, view general information.",
        Manage: "Add, edit, import from Excel, activate, deactivate, delete, restore customers; duplicate check.",
        Export: "Export the customer list to Excel.",
      },
      CustomerInteractions: {
        Read: "Open the Customer interactions tab.",
        Manage: "Log and edit customer interactions.",
      },
      ProjectCommunications: {
        Read: "View the customer communication log per project.",
        Manage: "Write entries in the customer communication log.",
      },
      CustomerHistory: {
        ReadFinancial: "View revenue and receivables of a customer's projects.",
      },
      FinancialProfiles: {
        Read: "View financial profiles (tax code, payment terms…).",
        ReadSensitive: "View bank account numbers and sensitive financial data.",
        Manage: "Create and edit financial profiles of customers, partners, suppliers.",
      },
      Partners: {
        Read: "View partner information.",
        Manage: "Add, edit, deactivate, delete, restore partners.",
      },
      Suppliers: {
        Read: "View supplier information.",
        Manage: "Add, edit, deactivate, delete, restore suppliers.",
      },
      Products: {
        Read: "Open the Products menu.",
        Manage: "Add, edit, import from Excel, deactivate, delete, restore products.",
        Export: "Export the product list to Excel.",
      },
      ProductCategories: {
        Read: "View product categories.",
        Manage: "Add, edit, enable, disable product categories.",
      },
      ProductRevisions: {
        Read: "View product revisions.",
        Manage: "Create, edit, import and activate product revisions.",
      },
      CustomerProducts: {
        Read: "View products a customer uses.",
        Manage: "Link, edit and unlink customer products.",
      },
      Quotations: {
        Read: "Open the Quotations tab.",
        Manage: "Create, edit, submit and clone quotations (only Sales/PiPic/leader members of the project).",
        Export: "Export quotations to a file.",
      },
      QuotationLines: {
        ReadSensitive: "View cost prices and expenses of each quotation line.",
      },
      ProjectContracts: {
        Read: "Open Customer POs, Contracts & warranty; view contracts and acceptance records.",
        Manage: "Create and edit contracts and acceptance records.",
      },
      WarrantyTickets: {
        Read: "View warranty and after-sales tickets.",
        Manage: "Create tickets and update their handling.",
      },
      DocumentTemplates: {
        Read: "Open the Document templates menu.",
        Manage: "Design and edit quotation, contract, RFQ, P/O templates.",
      },
      PurchaseRequests: {
        Read: "Open the Purchase requests tab.",
        Manage: "Create, edit, submit, cancel and delete draft purchase requests.",
        Quote: "Enter and compare supplier quotes for a request.",
        Confirm: "Confirm a purchase request (step before approval).",
        Approve: "Approve or reject purchase requests.",
        AdminReceive: "HR & Admin receives approved requests.",
        AccountingReceive: "Accounting receives approved requests.",
      },
      PurchaseOrders: {
        Read: "Open the Purchase orders tab.",
        Manage: "Create, edit, submit, cancel and delete draft purchase orders.",
        Deliver: "Record that the supplier delivered.",
      },
      MaterialStock: {
        Read: "Open the Warehouse menu: stock, stocktake, receipt and issue history.",
        Manage: "Create receipt and issue slips; delete drafts.",
        Approve: "Approve receipt and issue slips.",
        BypassApproval: "Post stock slips immediately without approval.",
        Reverse: "Reverse a posted stock slip.",
      },
      Materials: {
        Read: "Open the Materials & parts menu.",
        Manage: "Add, edit, submit for approval, deactivate, delete, restore materials.",
      },
      PaymentRequests: {
        Read: "Open Payment vouchers and view vouchers you created or must pay.",
        ReadAll: "View every advance, payment and settlement voucher and project summaries.",
        Manage: "Create, edit, submit, cancel and delete draft vouchers.",
        Approve: "Approve or reject vouchers.",
        Disburse: "Pay out approved vouchers.",
        ConfirmPaid: "Confirm a voucher has been paid.",
      },
      ProjectInvoices: {
        Read: "Open the Invoice issuance status tab.",
        Manage: "Issue, edit and void sales invoices.",
        RecordPayment: "Record customer payments of invoices.",
      },
      SupplierInvoices: {
        Read: "Open the Supplier invoices tab and view payables.",
        Manage: "Enter and edit supplier invoices.",
        RecordPayment: "Record payments to suppliers.",
        ReleasePaymentHold: "Release the hold so an invoice can be paid.",
      },
      CashBook: {
        Read: "Open the Cash book tab.",
        Manage: "Post receipts and payments; set the opening balance.",
        Reverse: "Reverse posted cash book entries.",
      },
      BankStatements: {
        Read: "Open the Bank statements tab.",
        Manage: "Import statements and reconcile them with the books.",
      },
      Finance: {
        Read: "Open the Company financial statement and Month close tabs.",
        PeriodClose: "Close a month (lock figures).",
        PeriodReopen: "Reopen a closed month.",
      },
      Amortizations: {
        Read: "Open the Prepaid and tools tab.",
        Manage: "Create and edit amortization schedules of prepaid expenses and tools.",
      },
      ExpenseCategories: {
        Read: "Open the Expense codes tab.",
        Manage: "Add, edit and deactivate expense codes.",
      },
      ExchangeRates: {
        Read: "Open the Exchange rates tab.",
        Manage: "Enter and edit exchange rates.",
      },
      Users: {
        Read: "Open Users & access and view accounts.",
        Manage: "Create, edit, lock and unlock accounts.",
        AssignPermissions: "Assign roles, groups and personal permissions to accounts.",
        Export: "Export the account list.",
      },
      Roles: {
        Read: "View roles, account groups and the permission catalog.",
        Manage: "Create, edit, enable and disable roles and account groups.",
        AssignMembers: "Add and remove members of account groups.",
        AssignPermissions: "Assign permissions to roles and account groups.",
      },
      Departments: {
        Read: "Open the Departments tab and view the department tree.",
        Manage: "Add, edit and arrange departments and teams.",
      },
      WorkflowDefinitions: {
        Read: "Open the Workflow Definitions menu.",
        Manage: "Create, edit, clone, enable, disable and delete workflows.",
      },
      WorkflowInstances: {
        ReadAll: "View every workflow run and its step details.",
        Manage: "Restart a workflow and resync the record status.",
        Start: "Start a workflow for a record.",
      },
      NotificationRules: {
        Read: "Open Notifications (System) and view delivery rules and history.",
        Manage: "Edit notification delivery rules.",
      },
      SystemSettings: {
        Read: "Open the System settings menu.",
        Manage: "Edit system settings.",
      },
      AuditTrail: {
        Read: "Open Audit & usage and view the system log and permission audit.",
        ReadSensitive: "View sensitive before/after values in the log.",
        Export: "Export the log to a file.",
      },
      SystemDiagnostics: {
        Read: "View Outbox diagnostics of every module (technical administration).",
      },
      Documents: {
        Read: "View and download attachments; open the Controlled documents tab.",
        Manage: "Upload and delete attachments.",
      },
    },
    sections: {
      topbar: "Top bar: notifications, chat",
      projectClosure: "Project closure (in the project record)",
      shared: "Shared across screens",
    },
  },
  identityAdmin: {
    moduleOther: "Other",
    menuPreview: "Menu preview",
    menuPreviewNote: "With the selected permissions (including unsaved changes) the account sees {count} menu items.",
    menuPreviewEmpty: "No visible items",
    modules: {
      Web: "Application entry points",
      Identity: "Accounts & access",
      Config: "Master data & customers",
      Project: "Projects",
      Workforce: "Workforce & attendance",
      Reporting: "Reporting",
      Document: "Documents",
      Notification: "Notifications",
      Chat: "Chat",
      Workflow: "Approval workflow",
      Procurement: "Procurement & finance",
    },
    ruleLabels: {
      Read: "View",
      Manage: "Manage",
      Export: "Export",
      Import: "Import",
      Approved: "Approve",
      Action: "Action",
      Other: "Special",
    },
    change: {
      create: "Create: {name}",
      info: "General information",
      role: "Role",
      group: "Group",
      member: "Member",
      code: "Permission",
      codes: "{count} permissions",
    },
    gridNote: {
      user: "Click a cell to grant/revoke a personal permission. Light-blue cells come from a role or group — remove that role/group above to revoke. Click a feature name to toggle the whole row.",
      group: "Click a cell to grant/revoke a group permission; every member receives it. Light-blue cells come from the roles of the group. Click a feature name to toggle the whole row.",
      role: "Click a cell to add/remove a permission in this role; everyone and every group with the role receives it. Click a feature name to toggle the whole row.",
    },
    legendOwn: {
      user: "Personal grant",
      group: "Group permission",
      role: "In this role",
    },
    grantedBy: "Granted by: {sources}",
    grantReadAll: "View all",
    grantAll: "Grant all",
    revokeAll: "Revoke all",
    whoCanHint: "See who can use this feature",
    rowToggleHint: "Click to toggle the whole row",
    copySuffix: "copy",
    askPlaceholder: "Ask: type a person, group, role or feature (e.g. payroll, Tuan…)",
    askFeatures: "Who can…",
    askPeople: "What can this person do",
    whoCan: "Who can: {feature}",
    whatCan: "What can {name} do?",
    answerNote: "Computed from roles and groups; personal grants are shown on each person page. Click a name to open and edit.",
    action: "Action",
    people: "People",
    via: "Via role / group",
    nobody: "Nobody yet",
    addRole: "Add role",
    addGroup: "Add to group",
    addMember: "Add member",
    remove: "Remove",
    usedBy: "Used by",
    canDo: "What they can do",
    canDoSummary: "Can do {count} things in {modules} modules",
    heldOnly: "Only what is held",
    expandAll: "Expand all",
    collapseAll: "Collapse",
    catalogNote: "Every feature of the system by module. Click a permission or a feature name to see who can use it.",
    gridReadOnly: "Read only — you cannot change this item.",
    legendInherited: "From role/group",
    legendAdd: "Will grant",
    legendRemove: "Will revoke",
    technicalDetails: "Technical details ({count} effective permission rows)",
    history: "Change history",
    pendingChanges: "{count} pending changes:",
    reasonRequired: "Reason for the change (required)",
    grantOptions: "Validity",
    discard: "Undo",
    saveChanges: "Save changes",
    impactRole: "Affects {users} people · {groups} groups",
    impactGroup: "Affects {users} members",
    copied: "Copied roles, groups and personal grants of {name} — review, then press Save changes.",
    copyFrom: "Copy access from…",
    cloneRole: "Clone",
    editInfo: "Edit details",
    lockAccount: "Lock account",
    unlockAccount: "Unlock",
    railFilter: "Filter accounts",
    railFilterAll: "All accounts",
    railFilterLocked: "Locked",
    grantMore: "Grant to…",
    grantStaged: "Staged {code} for {name} — enter a reason and press Save changes.",
    grantNotAllowed: "You cannot grant personal permissions to this person.",
    newUser: "Create account",
    openResponsibilities: "Open responsibilities",
    openResponsibilitiesHelp:
      "Transfer every item below before deactivating, or force the deactivation: named approval tasks fall back to their step roles and the rest must be handled manually.",
    responsibilitySourceUnavailable:
      "Could not check: {sources}. A normal deactivation stays blocked until the source is back.",
    transferTo: "Transfer to",
    transfer: "Transfer this group",
    forceDeactivate: "Deactivate (force)",
    deactivated:
      "Account deactivated ({released} approval tasks released to their step roles).",
    transferred: "{count} items transferred.",
    responsibilityKinds: {
      WorkflowTask: "Named approval task",
      ProjectLeader: "Project leader",
      ProjectPic: "Task PIC",
      ProjectSales: "Project sales",
      Customer: "Customer owner",
      ControlledDocument: "Controlled document in progress",
    },
    editAccount: "Edit account / password",
    accountSaved: "Account saved.",
    password: "Initial password",
    resetPassword: "New password (leave blank to keep current)",
    confirmPassword: "Confirm password",
    passwordHelp: "Use at least 12 characters; both passwords must match.",
    passwordResetHelp:
      "Only fill this to reset the password. Use at least 12 characters; the user will need to sign in again.",
    selectRoles: "Select roles",
    selectGroups: "Select account groups",
    selectMembers: "Select members",
    linkedProfile: "HR profile link",
    linked: "Linked",
    notLinked: "Not linked",
    effectivePermissionCount: "Effective permissions ({count} codes)",
    auditHistory: "Authorization history",
    occurredAt: "Time",
    auditAction: "Action",
    actor: "Performed by",
    auditLimit:
      "Shows direct changes to this record among the latest 500 system events. Role/group changes are shown on their own records.",
    beforeChange: "Before",
    afterChange: "After",
    setGrantMetadata: "Replace scope / dates for all selected grants",
    setMembershipDates: "Replace dates for selected memberships",
    replaceMetadataHelp:
      "On save, these settings replace metadata on all retained and new selections. Times use your local time zone.",
    preserveMetadataHelp:
      "Preserve existing scopes and dates. New selections use the default settings.",
    invalidGrant:
      "Enter a scope identifier and valid dates; the end must be after the start.",
    directPermissionExpiry:
      "New direct permission grants expire after 90 days unless an end date is specified.",
    ruleBasedMembers:
      "Memberships are managed by employee rules and cannot be edited manually here.",
    roleImpact:
      "This role is assigned directly to {users} accounts and {groups} groups. Changes also affect group members; “—” means the count is unavailable to you.",
    groupPreview:
      "Preview {count} configured permission codes · {members} members",
    groupPreviewHelp:
      "Combines selected direct permissions and roles. Actual access also depends on status, scope, dates and each account’s HR eligibility.",
    searchPermissions: "Search permission / feature",
    selectedOnly: "Selected only",
    selectionCount: "{count} permission codes",
    scopes: {
      Global: "Global",
      Organization: "Organization",
      Project: "Project",
      Resource: "Resource",
      Own: "Own",
      Customer: "Customer",
      Catalog: "Catalog",
    },

    title: "People & access",
    lockHint: "Lock {name}: enter a reason and press \"Confirm\". If the person still owns open work, you will be asked to hand it over first.",
    unlockHint: "Reactivate {name}: enter a reason and press \"Confirm\".",
    accessViews: {
      subjects: "Who has access",
      catalog: "Roles & permissions",
      organization: "Departments",
    },
    railSearch: "Search people, groups, roles…",
    rolesShort: "{count} roles",
    membersShort: "{count} people",
    permissionsShort: "{count} permissions",
    lockedShort: "locked",
    catalogHint: "Every permission in the system",
    pickHint: "Pick a person or group on the left to see and edit their access.",
    holders: "Held by — Roles: {roles} · Groups: {groups} · {users} people (individual grants not included)",
    explain: {
      subjects: "Pick a person or group on the left (or use Ask): see what they can do per module and through which role/group; add/remove roles and groups, click cells to grant/revoke personal permissions — every change goes to the tray below, saved once with one reason.",
      catalog: "A role is a named bundle of permissions (e.g. Accounting). Pick a role to click cells on/off, see who uses it or clone it; open the catalog and click a feature to see who can use it.",
      users: "Pick a person to see what they may do and why: directly assigned roles, account groups, individual grants, and effective permissions with their source. Edit that person's access here.",
      roles: "A role is a named bundle of permissions (for example Accounting). Assigning a role to a person or group gives them the whole bundle.",
      permissions: "Catalog of everything that can be done in the system. Permissions are bundled into roles or granted directly to groups/people.",
      groups: "An account group is a set of people who receive the same roles and/or permissions (for example payroll viewers). Adding someone to the group gives them its access.",
      organization: "The department and team tree shared across the system. Employee profiles pick their unit from this tree; the profile's Department and Team are filled from it. A unit code cannot change after creation; deactivate units that are no longer used instead of deleting them.",
    },
    tabGroups: {
      people: "People",
      access: "Access",
    },
    tabs: {
      profiles: "Employee profiles",
      users: "By user",
      roles: "Roles",
      permissions: "Permission catalog",
      groups: "Account groups",
      departments: "Departments",
    },
    departments: {
      title: "Departments",
      new: "New unit",
      code: "Unit code",
      codeHint: "Uppercase letters, digits, - or _ only. Cannot change after creation.",
      name: "Unit name",
      parent: "Parent unit",
      topLevel: "— Top level —",
      description: "Description",
      sortOrder: "Order",
      members: "Employees",
      children: "Sub-units",
      path: "Path",
      active: "Active",
      inactive: "Inactive",
      activate: "Reactivate",
      deactivate: "Deactivate",
      search: "Search unit code or name",
      empty: "No units yet.",
      saved: "Unit saved.",
      membersHint: "Employee count from approved employee profiles.",
    },
    users: "Accounts",
    roles: "Roles",
    permissions: "Permissions",
    accountGroups: "Account groups",
    permissionCatalog: "Permission catalog",
    userName: "Username",
    employeeCode: "Employee code",
    loginEligible: "Login eligible",
    fullName: "Full name",
    email: "Email",
    directRoles: "Direct roles",
    effectivePermissions: "Effective permissions",
    permissionCode: "Permission code",
    source: "Source",
    sourceName: "Source name",
    scope: "Scope",
    scopeNotSupported: "not in effect (Q23)",
    scopeId: "Scope ID",
    validFrom: "Valid from",
    validTo: "Valid to",
    grantSource: "Grant source",
    system: "System",
    membershipMode: "Membership mode",
    members: "Members",
    newRole: "New role",
    newGroup: "New account group",
    reason: "Change reason",
    yes: "Yes",
    no: "No",
    activate: "Activate",
    deactivate: "Deactivate",
    saveRoles: "Save roles",
    saveGroups: "Save groups",
    saveMembers: "Save members",
    savePermissions: "Save permissions",
    service: "Service",
    feature: "Feature",
    readOnlyNoPermission: "You do not have the read permission for this area.",
    authorizationReadRequired:
      "Users.Read and Roles.Read are both required to inspect user authorization.",
    writeComposite:
      "Write is only a combined display of Add and Update; it is not submitted as a permission code.",
    matrixStatusHelp:
      "Implemented can be assigned; Planned is visible but locked; N/A does not apply. Sensitive permissions are highlighted.",
    planned: "Planned",
    plannedHelp:
      "This capability is on the roadmap but the backend is not ready; it cannot be assigned yet.",
    notApplicable: "N/A",
    notApplicableHelp:
      "This capability has no business meaning for this feature.",
    legacyCompatibility: "Legacy compatibility permissions",
    legacyCompatibilityHelp:
      "Endpoint-specific aliases retained during migration; they are not canonical rules and can be removed explicitly.",
    legacyCanonicalTarget: "Canonical target: {code}",
    legacyBadge: "Has legacy alias",
    legacyOnly: "Legacy-only alias",
    matrixScrollLabel:
      "Permission matrix; use horizontal scrolling to view all columns",
    directPermissionsFor: "Direct permissions · {name}",
    permissionsFor: "Permissions · {name}",
    saved: "Authorization changes saved.",
    concurrency: "Authorization data changed elsewhere. Refresh and try again.",
  },
  workflowAdmin: {
    title: "Workflow Definitions",
    retry: "Retry",
    subtitle: "Configure reusable approval and activity flows.",
    createTitle: "Create workflow definition",
    description: "Description",
    targetType: "Target type",
    targetTypes: "Target types",
    targetGroups: "Target groups",
    initiators: "Initiators",
    allUsers: "All users",
    initiatorPermissions: "Initiator permissions",
    allowRequesterApproval: "Allow requester to approve their own step",
    initiatorUsers: "Initiator users",
    initiatorRoles: "Initiator roles",
    department: "Department assignment",
    departmentUnsupported: "Not supported in Q ONE yet",
    steps: "Steps",
    addStep: "Add step",
    removeStep: "Remove step",
    assignmentMode: "Assignment mode",
    singleUser: "Single user",
    multipleUsers: "Multiple users",
    role: "Role",
    assignee: "Assignee",
    assignees: "Assignees",
    notificationRecipients:
      "Notification recipients when this step is activated",
    notificationRecipientsHelp:
      "Leave both fields empty to use the default. When selected, only the chosen roles and users are notified; enable the option below to include the default recipients.",
    notificationRoles: "Notification roles",
    notificationUsers: "Notification users",
    notificationRolesPlaceholder: "— Select notification roles —",
    notificationUsersPlaceholder: "— Select notification users —",
    alsoNotifyDefault: "Also notify this step's default recipients",
    notificationPreviewDefault: "Notify this step's default recipients",
    notificationPreviewCustom: "Notify the selected roles/users",
    notificationPreviewIncludeDefault: "Also includes the default recipients",
    activityHelp:
      "Activity steps are completed through the dedicated permission/API.",
    terminalStep: "System completion · Completed",
    terminalStepHelp:
      "This is applied automatically after every configured step finishes and is not an editable workflow step.",
    dependencies: "Usage",
    locked: "Locked",
    editable: "Editable",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    optional: "Optional",
    version: "Version",
    clone: "Clone as new version",
    cloneNamePrompt: "Name for the cloned workflow version:",
    cloned: "Workflow version cloned.",
    rejectionMode: "Rejection behavior",
    rejectTerminate: "Terminate workflow",
    rejectPrevious: "Return to previous step",
    rejectTarget: "Return to selected step",
    rejectTargetStep: "Target step order",
    candidateMode: "Candidate assignment",
    candidateStatic: "Static candidates",
    candidateSharedRole: "Shared role; first decision wins",
    candidateDynamic: "Dynamic single user",
    candidateDynamicActor: "Dynamic business authorization",
    dynamicSource: "Dynamic user source",
    operationalReviewer: "Operational request reviewer",
    operationalDirectManager: "Requester's direct manager",
    operationalNextManager: "Requester's next Manager",
    operationalProjectLeader: "Request/project-part Project Leader",
    operationalRequestTarget: "OperationalRequest (Workforce & operations)",
    operationalRequestPartTarget:
      "OperationalRequestPart (project workforce & operations)",
    targetTypesHelp: "Choose the target type to which this workflow applies.",
    unnamedStep: "Unnamed step",
    initiator: "Workflow initiator",
    commaHelp: "Separate custom values with commas.",
    saved: "Workflow definition saved.",
    validation: "Please correct: {fields}",
    validationNameRequired: "Name is required.",
    validationTargetTypeRequired: "Choose a target type.",
    validationStepsRequired: "A workflow must contain at least one step.",
    validationSlaRequired: "Set an SLA when escalation roles are selected.",
    validationSlaRange:
      "SLA must be a whole number from 1 to 8760 working hours.",
    validationDynamicSource:
      "The dynamic user source does not match the selected assignment mode.",
    validationAssignee: "Choose exactly one approver source for this step.",
    validationCandidateMode:
      "An Activity is completed by the requester and cannot use dynamic approvers.",
    validationUnknown: "This configuration value is invalid.",
    validationGroupUnsupported: "This group is not valid for the selected target type.",
    validationFirstStepType: "Step 1 of this target type must be a {type} step.",
    validationRejectUnsupported: "This target type does not support returning to an earlier step; choose «Terminate workflow».",
    validationDynamicSourceUnsupported: "This dynamic assignee source is not supported by this target type.",
    validationStepKeyUnsupported: "This milestone is not declared by the target type.",
    condition: "Step condition",
    conditionText: {
      rolesNotIn: "requester has none of the roles: {roles}",
      rolesIn: "requester has any of the roles: {roles}",
      roleIs: "requester has role {role}",
      roleIsNot: "requester does not have role {role}",
      and: "and",
      or: "or",
      not: "not",
    },
    conditionPlaceholder: "e.g. approvalCurrency != \"VND\" or approvalAmount > 5000000",
    conditionHint: "Empty = always applies; when false the step is skipped. Operators: == != > >= < <=, in [..], not in, and, or, not; text in double quotes.",
    conditionVariables: "Variables sent by this target type:",
    validationConditionLength: "The condition must be 1000 characters or fewer.",
    validationConditionVariableUnsupported: "The condition uses a variable this target type does not send.",
    overrideRoles: "Override approver roles",
    overrideRolesHint: "Holders of these roles at any pending approval step: Approve = completes the whole workflow (later steps are skipped), Reject = ends the workflow. E.g. CEO, CTO, CHO, CMO, Director. Empty = nobody may override.",
    overrideCondition: "Override condition",
    overrideConditionHint: "Empty = override always allowed; same syntax as step conditions, e.g. approvalAmount < 50000000.",
    overrideConditionPlaceholder: "e.g. approvalAmount < 50000000",
    overrideNone: "No override",
    overrideInherit: "Same as definition",
    overrideUseDefinition: "Use the definition value",
    skipCovered: "Skip steps the initiator is entitled to approve",
    skipCoveredHint: "On submit/resubmit or whenever the workflow reaches consecutive Approval steps: find the highest step the initiator is assigned to (assigned role, named assignee, or a dynamic approver confirmed by the owning module); that step and every step before it are skipped automatically. The initiator step is kept.",
    requireIndependent: "Always require at least one approver other than the initiator",
    requireIndependentHint: "If every remaining Approval step would be skipped, the last Approval step is kept. Off = the request is approved immediately without a final approver.",
    requireIndependentOn: "always requires an approver other than the initiator",
    requireIndependentOff: "may complete automatically when every step is skipped",
    stepSkip: "Skip when the initiator may approve",
    stepSkipHint: "Overrides the definition option for this step. A step that is not skipped blocks the skip region: later steps are only evaluated once the workflow passes it.",
    stepSkipInheritOn: "Follow the definition (on)",
    stepSkipInheritOff: "Follow the definition (off)",
    stepSkipOn: "May be skipped",
    stepSkipOff: "Never skipped",
    stepOverrideRoles: "Step override approver roles",
    stepOverrideHint: "Empty = use the definition-level override roles; choose roles = only these roles may override at this step (with its own condition if any); clear all = no override at this step.",
    validationOverrideConditionRoles: "An override condition needs at least one override approver role.",
    substituteRoles: "Substitute roles",
    substituteHint: "Roles that may view, approve and return this step in place of the assignees (e.g. Accounting for Chief Accountant).",
    allowAdminException: "Allow administrator exception",
    allowAdminExceptionHint: "Full-access administrators may approve this step as an audited exception when no eligible approver remains.",
    validationStepKeyDuplicate: "Each milestone can be assigned to one step only.",
    stepKey: "Business milestone",
    stepKeyNone: "— No milestone —",
    stepKeyHint: "The owning module records intermediate sign-offs by the milestone of the approved step; the record status never depends on step order.",
    stepKeyNames: {
      DepartmentHead: "Department head",
      ChiefAccountant: "Chief accountant",
      Director: "Director",
      Pic: "Person in charge",
      Confirm: "Confirmation",
      Approval: "Approval",
      Quote: "Quotation",
    },
    ownerUnavailable: "owner not responding",
    ownerUnavailableNotice: "The owning module of this target type did not return its capabilities: the definition can only be saved as Inactive and activated once the module is back.",
    capabilitiesUnavailable: "Workflow capabilities could not be loaded; the configuration is still checked on save.",
    structureLocked: "This target type has a fixed 3-step structure: only step names, SLA and notification recipients can change.",
    groupNone: "This target type has no groups.",
    groupProjectHelp: "Groups are project identifiers (GUID), comma-separated; leave empty for every project.",
    groupMaterialHelp: "Groups are material identifiers (GUID), comma-separated; leave empty for every material.",
    pickGroups: "— All groups —",
    definitionInUse:
      "This definition has {count} instance(s); only activation can be changed.",
    deleteConfirm: "Delete workflow definition “{name}”?",
    concurrency:
      "This workflow definition was changed by another user. Refresh and try again.",
    terminalFeatures: {
      wbs: "Activate WBS",
      timesheet: "Enable timesheets",
      leader: "Grant project leader access",
      owner: "The owning module records the document as approved",
    },
    allowAllUsers: "— Allow all users —",
    allowAllRoles: "— Allow all roles —",
    stepKinds: {
      Approval: "Approval",
      Activity: "Activity",
    },
    pickApprovers: "— Choose approvers —",
    pickApproverRoles: "— Choose approver roles —",
    initiatorsHelp: "Choose the users or roles allowed to start this workflow. Leave both empty to let every account that can create the record start it.",
  },
  approvalHistory: {
    tab: "Approval",
    loading: "Loading approval history…",
    empty: "This record has no approval workflow yet.",
    forbidden: "You are not allowed to view the approval history of this record.",
    error: "Could not load the approval history.",
    retry: "Reload",
    round: "Round {number}",
    version: "version {version}",
    unknownDefinition: "Workflow",
    assignee: "Assigned to",
    actor: "Handled by",
    onBehalfOf: "on behalf of {name}",
    reassignedFrom: "Reassigned from",
    assignedAt: "Assigned",
    actedAt: "Handled",
    due: "Due",
    overdue: "overdue",
    decisions: { Pending: "Pending", Approved: "Approved", Completed: "Completed", Returned: "Returned for changes", Rejected: "Rejected", Cancelled: "Cancelled", SkippedByOverride: "Skipped by override", SkippedByInitiator: "Skipped by initiator" },
    skippedByOverride: "Skipped — completed by override approver {name}",
    skippedByInitiator: "Skipped automatically — the initiator is {name}",
    skippedByInitiatorRole: "Skipped automatically — the initiator is {name} ({roles})",
    override: "Override",
    part: "Request part {number}",
    roundStatuses: { Pending: "Not started", InProgress: "In progress", Completed: "Completed", Rejected: "Rejected", Cancelled: "Cancelled" },
  },
  approvalInbox: {
    summaryLoading: "Loading source details…",
    summaryBorrowerUnavailable: "Borrower information is unavailable",
    summaryCurrentSource: "Current source data; not a snapshot at submission.",
    summaryPartial: "The permitted section is available; additional details are unavailable.",
    summaryRetry: "Reload source details",
    summaryOpenSource: "Open source record",
    summaryAllocations: "Allocations for this part",
    syncRetryReasonContext: "Enter a reason to resend revision {revision}; do not include credentials or record data.",
    syncRetryUnknown: "The result is uncertain. Look up this operation before proceeding.",
    syncRetryOutcome: "Revision {revision} synchronization: {state}",
    syncRetryLookup: "Look up result",
    syncApplicationEvidence: "Source application evidence: {state}",
    syncApplicationStates: { Verified: "Verified applied", Unverified: "Accepted; application unverified", Unknown: "Unknown", Pending: "Pending", NotRequired: "Synchronization not required" },
    syncRetryStates: { Requested: "Requested", Dispatching: "Dispatching", Succeeded: "Verified applied", RetryableFailure: "Retryable failure", Unknown: "Unknown", Superseded: "Superseded", Blocked: "Blocked" },
    summaryLines: "Document lines",
    summaryStates: {
      sync_pending: "The source is waiting to synchronize this workflow revision. Refresh later.",
      unverified_binding: "The source record could not be verified against this workflow instance.",
      restricted: "You do not have permission to read the source record.",
      missing: "The source record is missing or outside your read scope.",
      error: "Source details could not be loaded. You can retry.",
      stale: "The source instance or revision changed; open the source and refresh the inbox.",
      unsupported: "A verified source summary is not available for this record type. Check its source screen.",
    },
    summaryFields: {
      borrower: "Borrower",
      borrowDate: "Borrow date",
      expectedReturnDate: "Expected return date",
      returnedDate: "Returned date",
      noteTruncated: "Note shortened",
      quotationDueDate: "Quotation due date",
      deliveryDueDate: "Delivery due date",
      materialCode: "Material code",
      materialName: "Material name",
      model: "Model",
      category: "Category",
      maker: "Manufacturer",
      unit: "Unit",
      supplier: "Supplier",
      quantity: "Quantity",
      documentNumber: "Document number",
      approvalStatus: "Source approval status",
      type: "Type",
      status: "Source status",
      requester: "Requester",
      project: "Project",
      periodStart: "From",
      periodEnd: "To",
      minutes: "Requested duration (minutes)",
      reason: "Reason",
      workplace: "Workplace",
      attachmentCount: "Attachment count",
      appliedRevision: "Revision applied at source",
      revision: "Record revision",
      date: "Date",
      startTime: "Start time",
      endTime: "End time",
      customer: "Customer",
      objective: "Objective",
      scope: "Scope",
      requirements: "Requirements",
      total: "Total amount",
      amountToPay: "Amount to pay",
    },
    retryOriginalDecision: "Retry original decision",
    retryOriginalDecisionConfirm: "Resend the original decision and comment with the original version? The server will recheck permission and apply it at most once.",
    decisionResults: "Task results",
    decisionUnknown: "Outcome unknown. Check the result before trying again.",
    decisionProcessed: "The task was processed by another person or with another decision.",
    checkDecision: "Check outcome",
    delegatedFrom: "Reviewing on behalf of {name}",
    overrideApproval: "Override approval",
    overrideApprovalHint: "You see this task through the workflow's override approver role.",
    overrideApproveHint: "Override approval: approving completes the whole workflow; remaining steps are skipped.",
    overrideRejectHint: "Override approval: rejecting ends the workflow (final rejection, no return to an earlier step).",
    callbackRevision: "Workflow synchronization: {state} · revision {revision}",
    summaryReminded: "Reminded",
    summaryEscalated: "Escalated",
    reviewSelection:
      "Confirm {action} for these {count} records/parts:\n{items}",
    reopenPart: "Reopen part",
    reopenPartReason: "Enter a reason to reopen the approved part",
    timesheetPartReopened: "Part reopened for editing and resubmission.",
    bulkPartResults: "Per-part approval results",
    retryFailedParts: "Retry failed parts",
    bulkOutcomeUnknown: "Outcome not confirmed. Refresh before retrying.",
    selectActionableParts: "Select actionable parts",
    selectPart: "Select approval part",
    title: "Approval inbox",
    subtitle:
      "Review workflow tasks currently assigned to you or one of your roles.",
    target: "Target",
    targetType: "Target type",
    outcomeTitle: "Record outcome",
    outcomeNotYours: "The record is still in progress but the current step is no longer waiting for you (someone else in the same approver group may have handled it).",
    outcomeClosed: "The record has finished: {status}. Nothing is waiting for you.",
    outcomeUnavailable: "This item has already been handled or you can no longer view its details. Nothing is waiting for you.",
    outcomeStatus: {
      Pending: "Pending",
      InProgress: "In progress",
      Approved: "Approved",
      Completed: "Completed",
      Rejected: "Rejected",
      Cancelled: "Cancelled",
    },
    requestType: "Request type",
    requestTime: "Time",
    issue: {
      content: "Issue details",
      plan: "Handling plan",
      noActions: "No handling actions yet.",
      title: "Issue",
      description: "Description",
      cause: "Cause",
      handling: "Handling approach",
      severity: "Severity",
      impact: "Impact",
      requester: "Requester",
      receivedDate: "Received on",
      owner: "PIC",
      internalDeadline: "Internal deadline",
      customerDeadline: "Customer deadline",
      deliveryState: "Delivery state",
      plannedMandays: "Planned mandays",
      action: "Action",
      pic: "PIC",
      delivery: {
        Planned: "Planned",
        AtRisk: "At risk",
        Due: "Due",
        Overdue: "Overdue",
        Delivered: "Delivered",
      },
    },
    stepNames: {
      SubmitterActivity: "Submitter completes",
      LeaderApproval: "Leader approval",
      ManagerApproval: "Manager approval",
      ReviewerConfirm: "Reviewer confirmation",
      FinalApproval: "Final approval",
      ProcurementApproval: "Manager approves the slip",
      ProcurementReturnApproval: "Manager approves the return",
      DepartmentHeadApproval: "Department head approval",
      ChiefAccountantApproval: "Chief accountant approval",
      DirectorApproval: "Director approval",
    },
    person: "Full name",
    kind: "Type",
    project: "Project",
    content: "What to handle",
    targetTypes: {
      OperationalRequestPart: "Project request part",
      ProcurementPaymentRequest: "Payment request",
      ProcurementPurchaseRequest: "Purchase request",
      ProcurementPurchaseOrder: "Supplier purchase order (P/O)",
      ProcurementStockReceipt: "Business inventory receipt",
      ProcurementStockIssue: "Business inventory issue",
      ProjectIssue: "Project issue",
      ProjectRegistration: "Project registration",
      OperationalRequest: "Operational request",
      MaterialEnrollment: "Material registration",
      AssetMaterialEnrollment: "Asset registration",
      AssetMaterialReturnedEnrollment: "Asset return slip",
      MaterialMaster: "New material code",
      AssetMaterialReceipt: "Asset stock receipt",
    },
    workflow: "Workflow",
    step: "Step",
    waitingDays: "Waiting days",
    groupSize: "Requests",
    selectTask: "Select task {target}",
    bulkApprove: "Approve selected tasks",
    bulkReject: "Reject selected tasks",
    bulkSuccess: "Visible tasks processed.",
    bulkPartial: "{success} tasks processed; {failed} failed or changed.",
    requestedAt: "Requested time",
    assignment: "Assignment",
    visibility: "Visibility",
    specificUser: "Assigned directly",
    sharedRole: "Shared role: {roles}",
    operationalReviewer: "Line manager / Project Leader / HR",
    operationalRequests: "People requests",
    unassigned: "Unassigned",
    history: "History",
    historyTitle: "Workflow history",
    actor: "Handled by",
    comment: "Comment",
    approveTitle: "Approve task",
    rejectTitle: "Reject task",
    rejectCommentRequired: "A comment is required when rejecting.",
    approved: "Task approved.",
    rejected: "Task rejected.",
    targetSync: "Target synchronization",
    retrySync: "Retry synchronization",
    syncRetried: "Target synchronization retried.",
    syncBlocksDecision:
      "The previous workflow status must synchronize with the target before this task can be decided.",
    concurrency: "This task has already been handled by another user.",
    loadFailed: "Could not load approval tasks.",
    openProjectIssue: "Open project request tracking",
    timesheetTitle: "Timesheets awaiting approval",
    timesheetSubtitle:
      "Monitor submitted timesheets; decision capability remains assignment-bound.",
    employee: "Employee",
    workDate: "Work date",
    totalHours: "Total hours",
    approver: "Approver",
    submittedAt: "Submitted at",
    actionable: "Needs my decision",
    observer: "Observer",
    unknownPerson: "User unavailable",
    timesheetLoadFailed: "Could not load submitted timesheets.",
    timesheetApproved: "Timesheet approved.",
    timesheetRejected: "Timesheet rejected.",
    partTitle: "Timesheet part",
    partHours: "Part hours",
    bulkApproveParts: "Approve selected parts",
    noPartsSelected: "No parts selected for approval.",
    timesheetPartApproved: "Timesheet part approved.",
    timesheetPartRejected: "Timesheet part rejected.",
    pauseAutoRefresh: "Pause refresh",
    resumeAutoRefresh: "Resume refresh",
  },
  app: { name: "Q ONE CRM PM", environment: "Project operations" },
  nav: {
    dashboard: "Operations center",
    analytics: "Analytics",
    customers: "Customers",
    partners: "Partners",
    suppliers: "Suppliers",
    products: "Products",
    materials: "Materials & parts",
    projectRegistration: "Project management",
    projects: "Projects",
    quotations: "Quotations",
    approvalInbox: "Approval inbox",
    workInbox: "Work inbox",
    reports: "Reports",
    accountSettings: "Account settings",
    changePassword: "Change password",
    workCalendar: "Work calendar",
    workCalendarLegacy: "Work calendar (Legacy)",
    mandayCost: "Manday cost",
    attendanceAdministration: "Attendance administration",
    attendanceCorrections: "Work hour confirmation",
    leaveRequests: "Leave requests",
    overtimeRequests: "Overtime requests",
    onsiteRequests: "Onsite requests",
    businessTrips: "Business trips",
    vehicleRequests: "Vehicle & travel requests",
    companyVehicles: "Company vehicle fleet",
    mealRegistrations: "Meal registrations",
    materialRegistrations: "Material registrations",
    assetRegistrations: "Asset tracking & approval",
    adminReceipts: "Admin receipts",
    accountingReceipts: "Accounting receipts",
    employeeProfiles: "Employee profiles",
    skillMap: "Skill Map",
    controlledDocuments: "Controlled documents",
    financeReportCatalog: "Finance report catalog",
    workflowDefinitions: "Workflow Definitions",
    monitoring: "Project progress",
    purchaseRequests: "Quotation and purchase requests",
    purchaseOrders: "Supplier purchase orders",
    events: "Events",
    projectInvoices: "Invoice issuance status",
    materialStock: "Material stock",
    assetStock: "Asset stock",
    crmTrash: "Master data trash",
    externalCustomerProgress: "Customer progress",
    externalSubcontractorProgress: "Subcontractor progress",
    notifications: "Notifications",
    notificationRules: "Notification rules",
    notificationOccurrences: "Notification occurrences",
    advanceRequests: "Advance requests",
    paymentRequests: "Payment requests",
    advanceSettlements: "Advance settlements",
    expenseCategories: "Expense codes",
    cashBook: "Cash book",
    projectContracts: "Contracts & warranty",
    customerOrders: "Customer POs",
    financePeriodClose: "Month close",
    financeStatement: "Company financial statement",
    bankStatements: "Bank statements",
    amortizations: "Prepaid and tools",
    supplierInvoices: "Supplier invoices",
    projectFinance: "Project finance sheet",
  },
  workspace: {
    noAccess: "You do not have access to any section of this screen.",
  },
  common: {
    invalidDateRange: "The end date must not precede the start date.",
    moreActions: "More actions",
    none: "None",
    reason: "Reason",
    attachments: "Attachments",
    files: "Files",
    noAttachments: "No attachments yet.",
    confirmDelete: "Select again to delete",
    select: "Select",
    selectAll: "Select all",
    clearSelection: "Clear selection",
    year: "Year",
    month: "Month",
    update: "Update",
    search: "Search",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    back: "Back",
    help: "Help",
    clear: "Clear",
    apply: "Apply",
    status: "Status",
    actions: "Actions",
    loading: "Loading…",
    noData: "No data",
    loadMore: "Load more",
    all: "All",
    language: "Language",
    logout: "Sign out",
    error: "An error occurred",
    success: "Success",
    refresh: "Refresh",
    close: "Close",
    code: "Code",
    name: "Name",
    description: "Description",
    date: "Date",
    submit: "Submit",
    confirm: "Confirm",
    approve: "Approve",
    reject: "Reject",
    view: "View",
    type: "Type",
    version: "Version",
    sizeKb: "Size (KB)",
    cause: "Cause",
    pic: "PIC",
    deadline: "Deadline",
    actionCount: "Actions",
    upload: "Upload",
    download: "Download",
    import: "Import",
    export: "Export",
    exportExcel: "Export to Excel",
    exportCsv: "Export to CSV",
    exportPdf: "Export to PDF",
    edit: "Edit",
    delete: "Delete",
    createdBy: "Created by",
    createdAt: "Created at",
    forbidden: "You do not have permission to access this feature.",
    moveUp: "Move up",
    moveDown: "Move down",
    details: "Details",
    optional: "Optional",
    retry: "Retry",
    skipToContent: "Skip to main content",
    exportExcelNoTable: "No table found to export to Excel.",
    warning: "Warning",
    previous: "Previous",
    next: "Next",
    project: "Project",
    rejectReason: "Rejection reason",
  },
  workforceAdmin: {
    tripSourceRange: "Choose a valid date range of at most 366 days.",
    tabsLabel: "Request view",
    tabs: {
      overview: "Overview",
      mine: "Mine",
      registrationForm: "Registration form",
      manage: "Manage",
    },
    subtitle:
      "Operational people ledgers backed by submitted, confirmed and approved records.",
    sheetCode: "Workbook form {code}",
    saved: "Draft saved.",
    linkedRequest: "Request linked from the approval inbox",
    linkedRequestHint:
      "The information below is for reference only and does not open the edit form.",
    linkedRequestUnavailable:
      "The linked request cannot be opened, or you do not have permission to access it.",
    readOnly: "Read only",
    linkedFilesPreserved:
      "Linked files are preserved; this screen does not request technical IDs.",
    newRequest: "New operational request",
    createRequest: "New request",
    requestNo: "Request no.",
    panelTabs: { info: "Details", history: "Approval history" },
    noFiles: "This request has no attachments.",
    advanceFile: "Advance request",
    editRequest: "Edit operational request",
    myRequests: "My requests",
    reviewQueue: "Review queue",
    requestLedger: "All requests",
    groupRequest: "Grouped request",
    groupRequestHint:
      "One request can register several people and allocate time by project, date, and interval.",
    groupEditImpactHint:
      "Changing shared details sends the affected parts through review again; changing an allocation resubmits only that part.",
    addParticipant: "Add participant",
    selectParticipant: "Select a person",
    addAllocation: "Add allocation",
    copyAllocation: "Copy allocation",
    removeAllocation: "Remove allocation",
    removeParticipant: "Remove participant",
    allocationHint: "Each row is one person's time interval on one project.",
    approvedPartLocked: "Approved part is locked",
    unassignedApprover: "No approver assigned",
    unassignedReasons: {
      no_eligible_reviewer: "No eligible reviewer for this step (missing “Reports to”/project leader, or the reviewer is the requester, a participant or already confirmed the previous step). Ask HR to update “Reports to” or the system administrator for an exception approval.",
      reviewer_directory_unavailable: "The reviewer directory could not be reached (Identity is temporarily unavailable). Try again later; if it persists, contact the system administrator.",
    },
    unknownProject: "Unknown project",
    partHistory: "Part history",
    resubmitPart: "Resubmit this part",
    legacyValue: "legacy value",
    leaveClassificationHint:
      "Required. Paid leave is deducted from the annual leave ledger; without enough days the request cannot be created.",
    submissionStageAuto: "Set on submission: before the start date is before the event, otherwise after the event.",
    leavePeriods: {
      morning: "Morning (08:00–12:15)",
      afternoon: "Afternoon (13:15–17:00)",
      fullDay: "Full day",
    },
    leaveBalanceRemaining: "Annual leave left on {date}: {days} day(s) (pending paid leave not yet deducted).",
    leaveBalanceNotOpened: "The annual leave ledger is not opened: a paid leave may not be created. Contact HR or choose unpaid leave.",
    leavePlan: {
      toggle: "Recurring leave (study schedule)",
      hint: "Choose each date with its session; the whole plan is approved once. Paid leave needs enough annual leave for every session.",
      from: "From",
      to: "To",
      weekdays: "Weekdays",
      period: "Session",
      add: "Add sessions",
      addOne: "Add one date",
      or: "or",
      chooseFile: "Choose file",
      noFile: "No file chosen",
      remove: "Remove session",
      clear: "Clear all",
      date: "Date",
      empty: "No sessions yet.",
      summary: "{count} sessions · {from} → {to} · about {days} day(s)",
      sessionCount: "{count} sessions",
      schedule: "Study schedule (required)",
      scheduleAttached: "Study schedule attached",
      attachmentRequired: "Attach the study schedule before submitting the recurring leave plan.",
      tooMany: "At most 120 sessions.",
      sessions: "Leave sessions",
    },
    weekdayShort: {
      d0: "Sun",
      d1: "Mon",
      d2: "Tue",
      d3: "Wed",
      d4: "Thu",
      d5: "Fri",
      d6: "Sat",
    },
    receiptDone: "Received",
    overtimeAfterCutoff:
      "Overtime request submitted after 14:00 on the overtime day (NMI-AC-0001/03)",
    pendingLedger: "Awaiting approval",
    settledLedger: "Approved requests",
    syncing: "Syncing",
    syncingHint:
      "Approved already; the system is still writing the status back to the request. Refresh in a moment.",
    history: "History",
    historyFailed: "Could not load the request history.",
    requestInformation: "Request information",
    requestDetails: "{type} details",
    requestedPeriod: "Requested period",
    processingHistory: "Processing history",
    submittedAt: "Submitted at",
    decisionReason: "Decision reason",
    unknownValue: "Unknown",
    department: "Department",
    position: "Position",
    reviewQueueWorkflowHint:
      "Requests waiting on you carry an approve button in the table above. See every pending approval in",
    selectProject: "Select an approved project",
    fromBusinessTrip: "Base on a business trip",
    selectBusinessTrip: "Pick a registered business trip",
    prospectCustomerPlaceholder: "Company about to be surveyed",
    prospectCustomerHint:
      "Fill this in when no project exists yet, such as a survey visit to a new customer.",
    selectVehicle: "Pick an available vehicle",
    noVehicleAvailable: "No vehicle is free for these dates.",
    vehicleBusy: {
      booked: "Already booked",
      maintenance: "Under maintenance",
    },
    selectCompanions: "Search and pick fellow travellers",
    companionsHint:
      "Fellow travellers count the same as the person who registered.",
    rejectReasonFor: "Rejection reason for {name}",
    receiveAdmin: "Receive (Admin)",
    receiveAccounting: "Receive (Accounting)",
    retryWorkflow: "Retry workflow start",
    partPending: "Part awaiting approval",
    partActionUnavailable: "This request part cannot be acted on.",
    rejectReasonForPart: "Rejection reason for part {name}",
    nextApprover: "Next approver",
    submittedBy: "Submitted by",
    confirmedBy: "Confirmed by",
    approvedBy: "Approved by",
    rejectedBy: "Rejected by",
    processedBy: "Processed by",
    approvalRoute: "Planned approval route",
    step: "Step {number}",
    confirmation: "Confirmation",
    finalApproval: "Final approval",
    withdraw: "Withdraw request",
    withdrawConfirm: "Are you sure you want to withdraw this request?",
    withdrawn: "Request withdrawn successfully.",
    deleteDraft: "Delete draft",
    deleteDraftConfirm: "Are you sure you want to delete this draft?",
    draftDeleted: "Draft deleted successfully.",
    cancelApproved: "Cancel approved request",
    adminCancel: "Admin: cancel duplicate",
    adminApprove: "Admin: exceptional approval",
    adminCancelledBy: "Duplicate cancelled by administrator",
    adminApprovalSyncFailed: "Exceptional approval was recorded, but request status sync failed. Check the workflow; do not approve again.",
    adminApprovalUnavailable: "The approval step has changed. Refresh the list before approving an exception.",
    adminApprovalSyncPending: "Exceptional approval recorded; waiting for the request status to sync. Refresh to check.",
    submissionPending: "The request is still being processed; this page refreshes in a few seconds. If it is still not submitted, submit it again.",
    adminApprovalComplete: "Exceptional approval and request status sync completed.",
    cancelApprovedConfirm:
      "Are you sure you want to cancel this approved request?",
    cancelReason: "Cancellation reason",
    cancelReasonRequired: "Please enter a cancellation reason.",
    cancelled: "Request cancelled successfully.",
    types: {
      TimeCorrection: "Work hour confirmation",
      Leave: "Leave request",
      Overtime: "Overtime request",
      Onsite: "Onsite request",
      BusinessTrip: "Business trip",
      Vehicle: "Vehicle & travel request",
      Meal: "Meal registration",
    },
    leaveTypes: {
      ANNUAL: "Annual leave",
      BEREAVEMENT: "Bereavement leave",
      BUSINESS: "Business leave",
      SOCIAL_INSURANCE: "Social-insurance leave",
      MATERNITY: "Maternity leave",
      PERSONAL: "Personal leave",
      OTHER: "Other",
    },
    leaveClassifications: {
      PaidLeave: "Paid leave",
      UnpaidLeave: "Unpaid leave",
    },
    submissionStages: {
      PRE_EVENT: "Before the event",
      DURING_EVENT: "During the event",
      POST_EVENT: "After the event",
    },
    onsiteForms: {
      IN_DAY: "In-day",
      OVERNIGHT: "Overnight",
    },
    tripForms: {
      ONSITE: "Onsite",
      IN_DAY: "In-day",
      OVERNIGHT: "Overnight",
    },
    correctionReasons: {
      BUSINESS_TRIP: "Business trip",
      DEVICE_FAILURE: "Time clock out of order",
      FORGOT: "Forgot to clock",
      POWER_OUTAGE: "Power outage",
      LATE: "Late arrival",
      OTHER: "Other",
    },
    transportMethods: {
      COMPANY_CAR: "Company car",
      PERSONAL_VEHICLE: "Personal vehicle",
      TAXI: "Taxi",
      PARTNER_VEHICLE: "Partner vehicle",
      OTHER: "Other transport",
    },
    requestContent: "Request content",
    requester: {
      title: "Requester",
      employeeCode: "Employee code",
      department: "Department",
      position: "Position",
      manager: "Direct manager",
    },
    fields: {
      from: "From",
      to: "To",
      schedule: "Schedule",
      employee: "Full name",
      participants: "Participants",
      allocations: "Allocations",
      nextApprover: "Next approver",
      status: "Status",
      search: "Search",
      searchPlaceholder: "Request, person, or project",
      project: "Project",
      tripDestination: "Project / destination",
      tripArrangement: "Trip form / transport",
      duration: "Duration",
      startTime: "From",
      endTime: "To",
      minutes: "minutes",
      checkInTime: "Check-in time",
      checkOutTime: "Check-out time",
      departureTime: "Departure time",
      returnTime: "Return time",
      actualStartDate: "Actual start date",
      actualEndDate: "Actual end date",
      actualNights: "Actual nights",
      requestedHours: "Requested hours",
      reasonCode: "Reason code",
      leaveType: "Leave type",
      selectLeaveType: "Select leave type",
      selectLeaveClassification: "Select leave classification",
      reason: "Reason / details",
      workplace: "Workplace / destination",
      tripDistanceKm: "Trip distance (km)",
      tripDistanceRequired: "Enter a distance from 0 to 10,000 km with up to 2 decimal places before submitting. Drafts may leave this blank.",
      tripForm: "Trip form",
      onsiteForm: "Onsite form",
      selectOnsiteForm: "Select onsite form",
      selectTripForm: "Select trip form",
      selectReasonCode: "Select a reason code",
      autoFromSchedule: "computed from departure and return",
      submissionMethod: "Submission stage",
      selectSubmissionMethod: "Select submission stage",
      transportMethod: "Transport method",
      selectTransportMethod: "Select transport",
      vehicleCode: "Vehicle code",
      prospectCustomer: "Prospect customer",
      companions: "Companions",
      attachmentId: "System attachment",
      advanceAttachmentId: "System advance attachment",
      mealRequired: "Use meal (clear = cancel meal)",
      unexpectedMeal: "Unexpected same-day request",
      guestCount: "Guest count",
      mealQuantity: "Meal quantity",
      leaveClassification: "Leave pay type",
      submittedDate: "Submission date",
      leavePeriod: "Leave period",
      selectLeavePeriod: "Choose the leave period",
      confirmationDate: "Date to confirm",
      overtimeDate: "Overtime date",
    },
    attendance: {
      tripDistanceMissing: "Legacy trip distance is missing: temporarily count one trip day for at least four hours in a day. Review before issuing payroll.",
      title: "Attendance administration",
      subtitle:
        "Reconcile clock records, presence, approved effort and approved requests by month.",
      tabs: "Attendance tabs",
      summaryTab: "Attendance summary",
      inputTab: "Input and warnings",
      legacyUnknownLeaveWarning:
        "{minutes} legacy leave minutes are unclassified and excluded from paid credits.",
      viewDetails: "View details",
      viewOverview: "View overview",
      employeeCount: "{count} employees",
      effectiveMinutes: "Effective minutes",
      summaryCalendarStandardDays: "Calendar standard days",
      summaryCreditedDays: "Credited workdays",
      summaryPendingEffort: "Pending effort",
      summaryLateEarlyMinutes: "Late + early leave",
      summaryWorkdayOvertime: "Workday overtime",
      summaryRestDayOvertime: "Rest-day overtime",
      summaryHolidayOvertime: "Holiday overtime",
      summaryPaidLeave: "Paid leave",
      summaryBusinessTrip: "Business trip",
      summaryActualNights: "Actual nights",
      summaryCalendarStandardDaysShort: "Calendar",
      summaryCreditedDaysShort: "Credited",
      summaryPendingEffortShort: "Pending",
      summaryLateEarlyMinutesShort: "Late+early",
      summaryWorkdayOvertimeShort: "OT workday",
      summaryRestDayOvertimeShort: "OT rest day",
      summaryHolidayOvertimeShort: "OT holiday",
      summaryPaidLeaveShort: "Paid leave",
      summaryBusinessTripShort: "Business trip",
      summaryActualNightsShort: "Actual nights",
      unitDays: "days",
      unitMinutes: "minutes",
      unitNights: "nights",
      month: "Month",
      present: "Presence",
      effort: "Approved effort",
      overtime: "Overtime",
      corrected: "Correction",
      lateDeduction: "Late deduction",
      leave: "Leave",
      onsite: "Onsite",
      businessTrip: "Business trip",
      businessTripNight: "Overnight trip",
      meals: "Meals",
      monthlyTotals: "Monthly attendance totals",
      ledger: "Attendance summary ledger",
      matrix: "Attendance summary",
      matrixHint:
        "One row per employee: each day shows worked minutes; V means approved leave. Cell colors follow the status legend.",
      presence_indirect: "Indirect",
      presence_indirectHint: "Employees with an approved business-trip or onsite interval and no direct attendance that day.",
      presence_direct: "Direct",
      presence_directHint: "Employees with a clock interval or approved attendance correction that day.",
      presence_total: "Total",
      presence_totalHint: "Employees represented in attendance for the day; each employee is counted once.",
      presenceMonthlyTotal: "Monthly employee-day total",
      presenceEmployeeDays: "employee-days",
      matrixCaption: "Attendance matrix for {month}",
      legend: "Attendance matrix legend",
      completeClock: "Complete check-in / check-out",
      incompleteClock: "Missing check-in or check-out",
      approvedLeave: "Approved leave",
      calendarRestDay: "Scheduled day off",
      approvedRequest: "Approved request",
      weekend: "Weekend",
      sequence: "No.",
      department: "Department",
      metricColumn: "Metric",
      absenceMinutes: "Total absence minutes",
      onsiteHoursSummary: "Onsite minutes",
      expandMetrics: "Expand all metrics",
      collapseMetrics: "Collapse to one row",
      weekdayShort: {
        "0": "Su",
        "1": "Mo",
        "2": "Tu",
        "3": "We",
        "4": "Th",
        "5": "Fr",
        "6": "Sa",
      },
      metric_checkIn: "Check-in time",
      metric_lateIn: "Late arrival",
      metric_checkOut: "Check-out time",
      metric_earlyOut: "Early leave",
      metric_workedHours: "Worked minutes",
      metric_onsiteHours: "Onsite minutes",
      metric_absenceHours: "Absence minutes",
      metric_overtimeWorkday: "Workday overtime",
      metric_overtimeRestDay: "Rest day overtime",
      metric_overtimeHoliday: "Holiday overtime",
      workDays: "Workdays",
      overtimeShort: "OT (hours)",
      lateMinutes: "Late (min)",
      sourceLateMinutes: "Source late minutes",
      calculatedLateMinutes: "Late minutes from clock-in / clock-out",
      calendarDayType: "Calendar day type",
      overtimeCategory: "Overtime category",
      overtimeCategory_WORKDAY: "Workday",
      overtimeCategory_REST_DAY: "Rest day",
      overtimeCategory_HOLIDAY: "Holiday",
      leaveShort: "Leave",
      onsiteShort: "Onsite",
      businessTripShort: "Trip",
      symbol: "Mark",
      sourceWorkday: "Source workday",
      sourceWorkedHours: "Source worked hours",
      workLocation: "Work location",
      totalWorkDays: "TOTAL WORKDAYS",
      standardWorkDays: "Standard workdays",
      overtimeHours: "OVERTIME MINUTES",
      totalLateMinutes: "Total late minutes",
      officePresence: "Office presence",
      halfDay: "Half day",
      customerOnsite: "Customer onsite",
      overnightOnsite: "Overnight customer onsite",
      onlineWork: "Online work",
      workdayOvertime: "Workday overtime",
      restDayOvertime: "Rest-day overtime",
      holidayOvertime: "Holiday overtime",
      excusedAbsence: "Excused absence",
      unexcusedAbsence: "Unexcused absence",
      leaveSummary: "Leave",
      noMonthlyAttendance:
        "No employee profiles or attendance data are available for this month.",
      checkIn: "Check-in",
      checkOut: "Check-out",
      source: "Source",
      sourceReference: "Source reference",
      note: "Note",
      rawEntry: "Source attendance record",
      rawLedger: "Clock-in / clock-out records",
      selectEmployee: "Select employee",
      importXml: "Import time-clock data",
      importHint:
        "Select an Excel 2003 XML file. The system previews it, matches time-clock codes to employee profiles and writes only after Admin confirms.",
      chooseXml: "Choose attendance .xml file (10 MB maximum)",
      previewFile: "Preview checks",
      importFile: "Confirm import",
      previewReady: "Checks complete — no data changed",
      importCompleted: "Import completed",
      matchedEmployees: "Employees matched",
      employeeMapping: "Time-clock code mapping",
      mappingHint:
        "Names from the file provide suggestions; Admin reviews and saves mappings for later imports.",
      attendanceCode: "Time-clock code",
      nameInFile: "Name in file",
      systemEmployee: "System employee",
      mappingStatus: "Result",
      mapAttendanceCode: "Select an employee for time-clock code {code}",
      saveMappings: "Save {count} mappings",
      suggestedByName: "Suggested by name — Admin confirmation required",
      mappingMapped: "Mapped",
      mappingReady: "Ready to save",
      mappingMissing: "Not mapped",
      created: "Created",
      updated: "Updated",
      skipped: "Matched, skipped",
      ignoredEmpty: "Days without clocks",
      issues: "Needs attention",
      xmlOnly: "Only files with the .xml extension are accepted.",
      xmlTooLarge: "The XML file cannot exceed 10 MB.",
      coverage: "Daily attendance coverage",
      attentionOnly: "Show only people needing attention",
      selectAllAttention: "Select all needing reminders",
      selected: "{count} selected",
      remindSelected: "Send reminders",
      selectToRemind: "Select to remind",
      selectEmployeeReminder: "Select reminder for {name}",
      employeeCode: "Employee code",
      status: "Status",
      lastReminder: "Last reminder",
      statusComplete: "Complete clocks",
      statusIncomplete: "One clock missing",
      statusExcused: "Approved request",
      statusMissing: "No attendance data",
      statusNonWorkday: "Non-workday",
      noAttention: "No employees need attention in the current scope.",
      reminderFeedback:
        "Queued {queued}; duplicate {duplicate}; opted out {optedOut}; ineligible {ineligible}.",
      manualEntry: "Manual entry or correction",
      issue_employee_not_found:
        "The time-clock code is not mapped to an employee profile, so its data was skipped.",
      issue_incomplete_punch_pair:
        "The source row is missing either check-in or check-out.",
      issue_multiple_punch_pairs:
        "Multiple clock pairs were collapsed to the first check-in and last check-out.",
      issue_duplicate_source_row: "A duplicate source row was skipped.",
      issue_invalid_clock_value: "An invalid clock value was ignored.",
      issue_invalid_clock_order:
        "Check-out must be later than check-in, so the row was not imported.",
    },
    receipts: {
      batchSelect: "Select for batch receipt",
      batchReceive: "Receive {count} records",
      batchConfirm: "Confirm receipt of {count} selected records:\n{items}",
      combinedTitle: "Received records",
      kind: "Receiving team",
      kinds: { admin: "HR", accounting: "Accounting" },
      pending: "Awaiting receipt",
      received: "Received",
      waitingSince: "Waiting since",
      receivedBy: "Received by",
      receivedAt: "Received at",
      startFrom: "Start from",
      startTo: "to",
      admin: {
        title: "Admin trip & vehicle receipts",
        subtitle:
          "A narrow queue after approval that does not depend on operational approval permission.",
        queue: "Waiting for Admin receipt",
        received: "Received by Admin",
        waitingSince: "Approved at",
      },
      accounting: {
        title: "Accounting trip & vehicle receipts",
        subtitle:
          "A separate queue after Admin receipt, without access to other HR review requests.",
        queue: "Waiting for Accounting receipt",
        received: "Received by Accounting",
        waitingSince: "Admin received at",
      },
    },
    profile: {
      completeness: "Completeness",
      missingFields: "Missing",
      copyPermanentAddress: "Same as permanent address",
      suggestProbationEnd: "Suggest: {date} (60 days)",
      alertsColumn: "Needs attention",
      person: "Employee",
      unit: "Department · Position",
      accountSection: "Login account",
      profileSection: "Employee profile",
      openAccess: "View & edit access",
      noAccountHint: "This person has no login account yet. Create one with \"New user\" above the table.",
      editProfileShort: "Edit profile",
      lockAccount: "Lock account",
      unlockAccount: "Unlock account",
      peopleLedger: "Employees & accounts",
      accountStatus: "Account",
      accountActive: "Active",
      accountLocked: "Locked",
      noAccount: "None",
      profileStatus: "Profile",
      noProfile: "No profile",
      searchPlaceholder: "Search name, code, account, phone, email, department…",
      allProfiles: "All",
      alerts: {
        contractExpired: "Contract expired",
        contractExpiring: "Contract ending soon",
        probationEnding: "Probation ending soon",
        birthdayThisMonth: "Birthday this month",
        pendingApproval: "Awaiting approval",
        incomplete: "Missing payroll/insurance data",
        accountStillActive: "Left but account still active",
        noAccount: "No login account",
        noProfile: "Account without a profile",
        accountMismatch: "Profile and account name/code differ",
        managerInactive: "Manager has left or is locked",
      },
      warnings: {
        dateOrder: "This date is earlier than the previous employment date.",
        nationalIdFormat: "A citizen ID has 12 digits (old ID cards have 9).",
        phoneFormat: "A phone number has 10 digits starting with 0 or +84.",
        emailFormat: "The email address is not valid.",
        bankAccountFormat: "A bank account number has 6–20 digits only.",
        tooYoung: "The birth date means the person is under 15.",
        duplicateCode: "This employee code is already used by another profile.",
        duplicateNationalId: "This citizen ID is already used by another profile.",
      },
      probationEndDate: "Probation end date",
      contractEndDate: "Contract end date",
      pageTitle: "Employee profiles",
      subtitle:
        "Employment lifecycle, personal, contact, financial and organization data.",
      viewDetails: "View details",
      viewAccount: "View account & permissions",
      approvalDetails: "Creation and review details",
      reviewedBy: "Reviewed by",
      reviewedAt: "Reviewed at",
      decisionReason: "Review reason",
      myProfile: "My profile",
      adminLedger: "Employee profile ledger",
      adminViews: "Employee information tables",
      contactAddress: "Contact address",
      organizationChart: "Organization chart",
      editProfile: "Edit profile · {name}",
      administrationSaved: "Employee profile updated.",
      correctionReason: "Approved-profile correction reason",
      correctionReasonPlaceholder: "Describe what changed and why",
      sensitiveValuesPreserved:
        "Masked national ID and bank-account values are preserved unless a new value is entered.",
      employment: "Contract & lifecycle",
      personal: "Personal & capability",
      contactFinance: "Address & finance",
      organization: "Organization placement",
      employeeCode: "Employee code",
      fullName: "Full name",
      hireDate: "Hire date",
      probationStartDate: "Probation start",
      officialContractDate: "Official contract date",
      contractNumber: "Contract number",
      contractType: "Contract type",
      classification: "Classification",
      employeeType: "Employee type",
      employmentStatus: "Employment status",
      employmentStatuses: {
        active: "Active",
        probation: "Probation",
        onboarding: "Onboarding",
        inactive: "Inactive",
        terminated: "Terminated",
      },
      terminationDate: "Termination date",
      returnDate: "Return date",
      birthDate: "Birth date",
      gender: "Gender",
      nationalId: "National ID",
      phone: "Phone",
      email: "Email",
      commuteDistanceKm: "Commute distance (km)",
      education: "Education",
      languages: "Languages",
      language1: "Language 1",
      language2: "Language 2",
      submittedAt: "Submitted date",
      cvAttachmentId: "Linked CV",
      photoAttachmentId: "Linked photo",
      permanentHouseNumber: "Permanent house no.",
      permanentStreet: "Permanent street",
      permanentWard: "Permanent ward",
      permanentProvince: "Permanent province",
      currentHouseNumber: "Current house no.",
      currentStreet: "Current street",
      currentWard: "Current ward",
      currentProvince: "Current province",
      bankName: "Bank",
      bankAccountNumber: "Bank account",
      department: "Department",
      departmentUnit: "Unit (department › team)",
      departmentUnitPlaceholder: "Pick a unit from the department tree",
      division: "Division",
      team: "Team",
      position: "Position",
      title: "Title",
      reportsTo: "Reports to",
      contactColumns: {
        hometownHouseNumber: "Hometown · House no.",
        hometownStreet: "Hometown · Street",
        hometownWard: "Hometown · Ward",
        hometownProvince: "Hometown · Province",
        currentHouseNumber: "Current address · House no.",
        currentStreet: "Current address · Street",
        currentWard: "Current address · Ward",
        currentProvince: "Current address · Province",
      },
    },
    skills: {
      title: "Skill Map",
      subtitle: "Current competency, target levels and next assessment cycle.",
      assessmentDate: "Assessment date",
      nextAssessmentDate: "Next assessment date",
      track: "Skill track",
      profile: "Evaluation profile",
      score: "Score",
      resultLevel: "Result level",
      staff: "Staff",
      leaderStaff: "Leader / Staff",
      thresholds: "API evaluation thresholds",
      category: "Category",
      competency: "Competency",
      currentLevel: "Current level",
      targetLevel: "Target level",
      note: "Note",
      newAssessment: "New assessment",
      editAssessment: "Edit assessment",
      matrixCaption: "{track} skill matrix",
      levelFor: "{field} for {skill}",
      noteFor: "Note for {skill}",
      myAssessments: "My assessments",
      reviewQueue: "Assessments awaiting review",
    },
  },
  mealMatrix: {
    suggestCancellation:
      "Approved leave or business trip. Consider cancelling this meal before the cutoff.",
    pastDate: "Meal registrations for past dates cannot be changed.",
    historyQuantity: "Quantity",
    historyGuests: "Guests",
    historyNote: "Note",
    historyUnknown: "Historical value unavailable",
    title: "Meal registration",
    subtitle:
      "Employees by day. Everyone is registered by default; untick the days they skip.",
    selectAll: "Tick all",
    clearAll: "Clear all",
    clearRow: "Clear this row",
    pending: "{count} cells waiting to save",
    saved: "Meal registration saved.",
    saveProgress: "Saved {saved} cells; {remaining} cells remaining.",
    invalidPeriod:
      "Year must be an integer from 2020 to 2100 and month from 1 to 12.",
    unsavedChanges: "You have unsaved meal changes. Discard these changes?",
    noMealDays: "This month has no meal days.",
    rowTotal: "Days",
    dayTotal: "Portions",
    cutoffRule:
      "Once the kitchen cutoff passes the cell locks; only the period administrator can still change it and every change is recorded.",
    cutoffPassed:
      "The meal cutoff for this day has passed; ask the administrator to adjust it.",
    history: "Change history",
    historyEmpty: "No registration changes this month.",
    historyWhen: "When",
    historyChange: "Change",
    historyBy: "Changed by",
    historyDefault: "Default (registered)",
    registered: "Registered",
    notRegistered: "Not registered",
    afterCutoff: "After cutoff",
  },
  companyVehicles: {
    title: "Company vehicle fleet",
    subtitle:
      "Vehicle records, inspection and insurance expiry, and the maintenance log.",
    fleet: "Fleet",
    showRetired: "Include retired vehicles",
    platePlaceholder: "29A-12345",
    newVehicle: "Add a vehicle",
    editVehicle: "Edit vehicle",
    saved: "Vehicle saved.",
    removed: "Vehicle deleted.",
    maintenanceLog: "Maintenance log",
    history: "Vehicle information and log",
    vehicleInformation: "Vehicle information",
    maintenanceFor: "Maintenance · {code} — {name}",
    newMaintenance: "Log maintenance",
    editMaintenance: "Edit maintenance",
    maintenanceSaved: "Maintenance record saved.",
    maintenanceRemoved: "Maintenance record deleted.",
    removeMaintenanceConfirm:
      "Delete this maintenance record? System log entries cannot be deleted.",
    logEntry: "System log",
    correctOdometer: "Correct odometer",
    odometerPrompt: "Correct odometer reading for {code}",
    odometerInvalid: "The odometer must be a non-negative number.",
    odometerCorrected: "Odometer corrected and logged.",
    reasonPrompt: "Reason (required)",
    retire: "Retire",
    retirePrompt: "Reason for retiring vehicle {code}",
    retired: "Vehicle retired.",
    reactivate: "Reactivate",
    reactivatePrompt: "Reason for reactivating vehicle {code}",
    reactivated: "Vehicle reactivated.",
    status: {
      Active: "In service",
      UnderMaintenance: "Under maintenance",
      Retired: "Retired",
    },
    kind: {
      Service: "Scheduled service",
      Repair: "Repair",
      Inspection: "Inspection",
      Insurance: "Insurance",
      Registration: "Registration",
      OdometerCorrection: "Odometer correction",
      Retirement: "Retirement",
      Reactivation: "Reactivation",
    },
    maintenanceStatus: {
      Planned: "Planned",
      InProgress: "In progress",
      Completed: "Completed",
      Cancelled: "Cancelled",
    },
    alerts: {
      registration: "Inspection expiring",
      insurance: "Insurance expiring",
      service: "Service due",
      openMaintenance: "{count} maintenance records still open",
    },
    fields: {
      vehicleType: "Vehicle type",
      seatCount: "Seats",
      odometer: "Odometer",
      registrationExpiry: "Inspection expiry",
      insuranceExpiry: "Insurance expiry",
      nextServiceDue: "Next service due",
      nextServiceOdometer: "Next service odometer",
      note: "Note",
      kind: "Category",
      scheduledDate: "Scheduled",
      completedDate: "Completed",
      cost: "Cost",
      vendor: "Vendor",
      description: "Details",
    },
  },
  documentRegister: {
    departmentCode: "Department code",
    documentNumberAuto: "Allocated on save",
    title: "Controlled document register",
    subtitle:
      "Manage documents and records from draft through confirmation, approval or cancellation.",
    department: "Department",
    documentNumber: "Document No.",
    recordNumber: "Record No.",
    revision: "Rev No.",
    effectiveDate: "Effective date",
    newTitle: "New controlled document",
    editTitle: "Edit controlled document",
    saved: "Controlled document saved.",
    attachmentPreserved:
      "The linked file is preserved; this screen does not ask for a technical ID.",
    decisionNote: "Decision note / reason",
    noteRequiredForReject: "Required for rejection or cancellation",
    cancelDocument: "Cancel document",
    effective: "Effective",
    effectiveYes: "In effect",
    effectiveAt: "Effective on date",
    supersede: "Supersede",
    supersedeBy: "Supersede with an approved document",
    superseded: "Supersession recorded.",
    supersededBy: "Superseded by {number}",
    noReplacement:
      "No approved document of the same kind is available as a replacement.",
    auditTrail: "Document control audit trail",
    ledger: "Document & record register",
    searchPlaceholder: "Name, department or document number",
    kinds: { Document: "Document", Record: "Record" },
    audit: {
      created: "Created",
      submitted: "Submitted",
      confirmed: "Confirmed",
      approved: "Approved",
      rejected: "Rejected",
      cancelled: "Cancelled",
    },
  },
  financeCatalog: {
    title: "Finance report catalog",
    subtitle: "Finance menu scope merged from Update.xlsx and Version.xlsx.",
    menuOnly: "{count} active entries",
    entries: "menu entries",
    noContractTitle: "Every finance report has a screen",
    noContractBody:
      "Each entry opens its screen or report tab. Locked entries are ones you do not have read permission for; contact an administrator if you need them.",
    unavailable: "No approved data source.",
    openReport: "Open report",
    noDataContract: "No data contract",
    availableContract: "Active",
    inherited: "Inherited from Update.xlsx",
    footnote:
      "The two inherited reports are retained from Update.xlsx under the no-removal rule.",
    reports: {
      invoiceStatus: "Invoice issuance status",
      financial: "Financial report",
      revenue: "Revenue report",
      projectCost: "Project cost",
      inventory: "Inventory",
      costOfGoods: "Cost of goods",
      receivables: "Accounts receivable",
      payables: "Accounts payable",
      cashExpenses: "Cash expenses",
      officeExpenses: "Office expenses",
      cashFlow: "Cash flow report",
      payroll: "Payroll",
    },
  },
  projectContracts: {
    exportWord: "Export Word",
    panel: {
      info: "Details",
      new: {
        contracts: "New contract",
        acceptances: "New acceptance record",
        tickets: "New warranty ticket",
      },
    },
    saveForAttachments: "Save or select a contract / acceptance record to upload attachments.",
    title: "Contracts, acceptance and warranty",
    projectGroup: "Project",
    contractGroup: "Contract",
    termsGroup: "Value & warranty",
    acceptanceGroup: "Acceptance record",
    ticketGroup: "New ticket",
    pickProject:
      "Pick a project to see its contracts, acceptance records and warranty tickets.",
    openTickets: "Open tickets",
    allProjects: "All projects",
    directorySearch: "Contract no., title, project code…",
    openInProject: "Open in project",
    directoryHint: "Read-only list. Click «Open in project» to edit, export Word/PDF, record acceptance or warranty tickets.",
    latestContract: "Latest contract",
    activate: "Activate",
    complete: "Complete",
    terminate: "Terminate",
    terminateTitle: "Terminate contract {number}",
    void: "Void",
    voided: "Void",
    voidTitle: "Void record {number}",
    createTicket: "Create ticket",
    takeTicket: "Take ticket",
    reopenTicket: "Reopen",
    resolveTicket: "Mark resolved",
    closeTicket: "Close ticket",
    rejectTitle: "Reject ticket {number}",
    inWarranty: "In warranty",
    outOfWarranty: "Out of warranty",
    tabs: {
      contracts: "Contracts",
      acceptances: "Acceptance records",
      tickets: "Warranty tickets",
    },
    status: {
      Draft: "Draft",
      Active: "Active",
      Completed: "Completed",
      Terminated: "Terminated",
    },
    ticketStatus: {
      Open: "Open",
      InProgress: "In progress",
      Resolved: "Resolved",
      Closed: "Closed",
      Rejected: "Rejected",
    },
    results: {
      Accepted: "Accepted",
      AcceptedWithRemarks: "Accepted with remarks",
      Rejected: "Rejected",
    },
    severities: {
      Low: "Low",
      Medium: "Medium",
      High: "High",
      Critical: "Critical",
    },
    fields: {
      project: "Project",
      customer: "Customer",
      contractNumber: "Contract no.",
      title: "Contract title",
      customerSigner: "Customer signer",
      signedDate: "PO date",
      effectiveFrom: "Effective from",
      effectiveTo: "Effective to",
      value: "Value",
      currency: "Currency",
      warrantyMonths: "Warranty (months)",
      warrantyStart: "Warranty start",
      warrantyEnd: "Warranty end",
      inWarranty: "Warranty",
      paymentTerms: "Payment terms",
      note: "Note",
      recordNumber: "Record no.",
      acceptanceDate: "Acceptance date",
      scope: "Acceptance scope",
      result: "Result",
      remarks: "Remarks",
      ticketNumber: "Ticket no.",
      reportedDate: "Reported",
      reportedBy: "Reported by",
      ticketTitle: "Title",
      description: "Description",
      severity: "Severity",
      resolution: "Resolution",
    },
  },
  customerOrders: {
    title: "Customer purchase orders",
    newManual: "New customer PO",
    newFromQuotation: "Create from quotation",
    source: "Source",
    sourceManual: "Manual entry",
    sourceQuotation: "From quotation",
    pickProject: "Pick a project to record a customer PO.",
    noQuotation: "The project has no issued quotation that is still open.",
    notInList: "The PO is not in the current list; pick its project in the filter.",
    linesFromQuotation: "Lines are copied from the quotation (group rows skipped); the currency follows the quotation, and empty payment terms take the quotation terms.",
    confirm: "Confirm PO",
    confirmHint: "Confirming a PO created from a quotation records the quotation outcome as «Accepted».",
    cancel: "Cancel PO",
    cancelTitle: "Cancel customer PO {number}",
    linkContract: "Link contract",
    saveLink: "Save link",
    noLinkedContract: "— No linked contract —",
    noContract: "The project has no open contract to link.",
    headerGroup: "PO details",
    linesGroup: "Order lines",
    addLine: "Add line",
    removeLine: "Remove line",
    noLines: "No order lines yet.",
    fields: {
      project: "Project",
      customer: "Customer",
      orderNumber: "Customer PO no.",
      orderDate: "PO date",
      requestedDeliveryDate: "Requested delivery",
      currency: "Currency",
      paymentTerms: "Payment terms",
      customerSigner: "Customer signer",
      note: "Note",
      quotation: "Quotation",
      contract: "Contract",
      subtotal: "Subtotal",
      vatAmount: "VAT amount",
      total: "Total",
      cancelReason: "Cancellation reason",
      code: "Item code",
      description: "Description",
      unit: "Unit",
      quantity: "Quantity",
      unitPrice: "Unit price",
      vatPercent: "VAT %",
      amount: "Amount",
    },
    status: {
      Draft: "Draft",
      Confirmed: "Confirmed",
      Cancelled: "Cancelled",
    },
  },
  financeClose: {
    title: "Month close",
    periodGroup: "Accounting period",
    period: "Period",
    currency: "Reporting currency",
    range: "Date range",
    version: "Data version",
    notClosed: "Not closed",
    statusOpen: "Open",
    statusClosed: "Closed v{version}",
    close: "Close period",
    reopen: "Reopen period",
    reopenTitle: "Reopen period {period}",
    reopenContext:
      "The snapshot of the close is kept. Explain why the period is reopened (at least 10 characters).",
    reason: "Reason",
    blocked:
      "Cannot close yet: {count} “Blocking” items remain. “Warning” items do not block but are recorded in the close minutes.",
    notEnded:
      "The period has not ended: it can be closed only after the last day of the month.",
    checklist: "Checklist",
    history: "Close / reopen history",
    noHistory: "This period has never been closed.",
    closedEvent: "closed",
    reopenedEvent: "reopened",
    warningsRecorded: "{count} warnings recorded",
    snapshotNote:
      "Every close keeps a versioned snapshot; reopening needs a reason and a separate permission.",
    passed: "Passed",
    open: "Open",
    review: "Review",
    resolve: "Resolve",
    columns: {
      item: "Check",
      level: "Level",
      count: "Remaining",
      amount: "Amount",
      action: "Action",
    },
    levels: {
      Blocking: "Blocking",
      Warning: "Warning",
    },
    checks: {
      bank_unclassified: "Unclassified statement lines",
      payment_disbursing: "Payments being disbursed, not yet confirmed paid",
      bank_default_classified: "Statement lines still default-classified",
      bank_unmatched_trade: "Sales receipts / supplier payments not reconciled",
      payment_approved_unpaid: "Approved payment requests not yet paid",
      advance_overdue: "Advances overdue for settlement",
      cash_opening_missing: "No certified opening cash balance",
      amortization_changed: "Amortization items changed in the period",
      payroll_unpublished: "Payroll for the period is not published",
    },
  },
  financeStatement: {
    turnoverBasis: "Average balance basis",
    turnoverBases: { "openingClosing": "Average opening and closing balances", "monthlyClosing": "Average monthly closing balances" },
    turnoverPeriodNote: "Ratios cover the selected period and are not annualized.",
    plan: {
      title: "Plan (accepted quotations) versus actual",
      hint: "The plan comes from each project's accepted quotation, booked in the project month (ADR-050/051) and filtered by the quotation affiliation. Actual figures are the statement above; actual net profit is not split by project, so only the plan is shown.",
      variance: "Variance actual − plan",
      projectMonth: "Project month",
      quotation: "Quotation",
      actualRevenue: "Actual revenue in period",
      rows: {
        revenue: "Revenue",
        cogs: "Cost of goods sold",
        grossProfit: "Gross profit",
        netProfit: "Net profit (after corporate tax)",
      },
    },
    matrix: {"party": "Party", "project": "Project / Commercial PO", "document": "Document", "source": "Source", "status": "Status", "contract": "Contract", "invoiced": "Invoiced", "paid": "Paid", "outstanding": "Outstanding", "references": "Invoice/payment references", "invoiceBasis": "Invoice-based costs with unlinked direct expenses included separately.", "cashBasis": "Cash disbursements", "empty": "No data for this period."},
    scopeIncomplete: "Affiliation scope lacks allocated payroll, opening capital and fund balances; totals are incomplete.",
    affiliation: "Affiliation code",
    incompleteBalance: "Missing opening balance",
    title: "Company financial statement",
    subtitle:
      "Income statement by fiscal month, quarter and year (BCTCCRM.xlsx) combined from issued invoices, the cash book, payment requests, stock and published payroll.",
    invalidRange:
      "Choose both dates; the end date cannot be before the start date.",
    exportCsv: "Download CSV",
    tabs: { revenue: "Revenue by project", costs: "Project costs", flows: "Cash flow", statement: "Statement", analysis: "Analysis", detail: "Detail" },
    modes: { month: "Month", quarter: "Quarter", year: "Year" },
    filters: { mode: "Columns" },
    kinds: { balance: "closing balance", cumulative: "cumulative" },
    columns: {
      variance: "Variance",
      indicator: "Indicator",
      formula: "Formula",
      total: "Period",
      kpi: "KPI",
      plan: "Plan",
      actual: "Actual",
      range: "Threshold",
      verdict: "Result",
      line: "Line",
    },
    sections: {
      statement: "I. Summary indicators",
      analysis: "II. Analysis",
      personnel: "III. Personnel cost",
      office: "III. Office management expenses",
      provisions: "Estimated expenses",
      flows: "Cash flow report",
      extras: "Payables and accrual cost of goods",
    },
    extras: {
      cogsCash: "Cash cost disbursements",
      projectPending: "Project costs awaiting payment (view only, not in cost of goods)",
      collected: "Collections on issued invoices",
      receivablesClosing: "Accounts receivable at period end",
      cogsAccrual: "Supplier-invoice cost (project items by project month)",
      revenueInvoiced: "Invoiced revenue",
      cogsLabor: "Of which project overtime/travel",
      payablesClosing: "Accounts payable at period end",
    },
    estimatedExpenses: {
      officeVat: "VAT",
      projectEntertainment: "Project entertainment",
      displayOnly: "Display only, not added to totals; includes amounts awaiting payment, as in the project report.",
    },
    indicators: {
      capital: "Paid-in capital",
      revenue: "Contract revenue",
      receivables: "Accounts receivable",
      cogs: "Cost of goods",
      payables: "Accounts payable",
      personnel: "Personnel cost",
      office: "Office management expenses",
      officeWithInvoice: "Of which with invoice",
      officeNoInvoice: "Expenses without invoice",
      provisions: "Estimated expenses (VAT)",
      grossProfit: "Gross profit",
      profitBeforeTax: "Profit before tax",
      cumulativeProfit: "Cumulative profit",
      profitAfterTax: "Profit after tax",
      inventory: "Inventory",
      cashPosition: "Cash position",
      cashRemaining: "Cash remaining",
    },
    personnel: {
      headcount: "Headcount",
      insurance: "Social insurance, union fee (employer)",
      salary: "Salary",
      overtime: "Overtime pay",
      trip: "Business trip allowance",
      meal: "Mid-shift meals",
      otherAllowance: "Other allowances",
      holidayBonus: "Holiday bonus",
      attitudeBonus: "Attitude bonus",
    },
    flows: {
      flowSales: "I. Cash from sales",
      flowFinancialIn: "II. Financial income",
      flowSuppliers: "III. Payments to suppliers",
      flowPersonnel: "IV. Payments to employees, insurance",
      flowTax: "V. Taxes paid",
      flowFinancialOut: "VI. Financial expenses",
      cashClosing: "Cash box balance",
      bankClosing: "Bank balance",
    },
    kpis: {
      revenue: "Revenue",
      salary: "Salary",
      headcount: "Headcount",
      personnelCost: "Personnel cost",
      officeCost: "Office cost",
      costPerHead: "Cost per head",
      revenuePerHead: "Revenue per head",
      receivableTurnover: "Receivable turnover",
      inventoryTurnover: "Inventory turnover",
      ros: "ROS (profit before tax / revenue)",
    },
    verdicts: {
      Fail: "Below target",
      Pass: "On target",
      Good: "Good",
      None: "n/a",
    },
    notes: {
      cashBasis:
        "Cost of goods follows invoices; unlinked direct expenses are included separately without counting invoice payments again. Profit after tax = cumulative profit × (1 − {rate}%). Balances are closing figures.",
      targets:
        "Plans and thresholds come from the Procurement:FinanceTargets configuration (Config Center); 0 means no plan set.",
      unpublished:
        "Months without published payroll (personnel cost is meals only): {months}",
      noPayrollAccess:
        "You cannot read payroll, so personnel cost only includes mid-shift meals from the cash book.",
      payrollUnavailable:
        "Payroll cost could not be loaded; personnel lines only include mid-shift meals.",
      bankFromStatement:
        "Bank balances use statements by month. Automatically created transactions keep their source request classification and are counted once; months without actual statements use cash-book movements.",
      amortized: "incl. allocation",
      otherAllocation: "Prepaid/tool allocation without a target line",
    },
    recognition: {
      basis: "Each contract recognizes revenue in its PO month. Project costs use the earliest PO month, or the project creation month without a contract. Receivables, collections and cash flow follow invoices.",
      partial: "Partial data: {sources}.",
      laborMismatch: "Project overtime/travel computed from requests exceeds the published payroll in: {months}. The excess is not deducted from personnel cost.",
      shiftsTitle: "{count} items moved to an open month because their recognition period is closed",
      series: "Indicator",
      projectPeriod: "Project month",
      recognizedPeriod: "Recognized in",
      amount: "Amount",
      seriesNames: {
        revenue: "Contract revenue",
        cogs: "Cost of goods",
      },
      sources: {
        project: "project contracts could not be loaded; contract revenue is incomplete and is not replaced with invoiced revenue",
        contractAffiliationUnavailable: "contracts have no assigned affiliation, so their revenue is excluded from the selected unit; select All to view total contract revenue",
        projectScope: "you can see only some projects (missing read-all projects permission)",
        projectUnresolved: "some project contracts could not be resolved, so their contract revenue is not recognized",
        projectPlan: "quotations could not be read (missing quotation read permission), so there is no plan",
        projectPlanCost: "quotation costs are hidden (missing permission), so planned cost and profit are empty",
        labor: "project overtime/travel could not be loaded (payroll read permission required)",
        laborRates: "some overtime lacks an hourly rate (no salary profile) and is not priced",
        stockCost: "some project stock issues have no FIFO cost yet (receipt without unit cost), so project costs are incomplete",
      },
    },
    projectRevenue: {
      title: "Contract revenue by project",
      hint: "Signed contract value against cumulative invoicing up to the period end. Invoices track billing progress and never replace contract value.",
      basis: "Basis",
      recognitionDate: "Recognition date",
      contractValue: "Contract value",
      invoiced: "Invoiced",
      remaining: "Left to invoice",
      recognized: "Revenue in period",
      unallocated: "Invoices without project/PO",
      bases: {
        NoContract: "No eligible contract",
        Contract: "Signed contract",
        InvoiceFallback: "No contract yet — invoices used",
        CommercialPo: "Commercial order — invoices",
        Unallocated: "Invoice month",
        Unresolved: "Project contract unavailable",
      },
    },
  },
  bankStatements: {
    allocation: {
      fromMatch: "From the matched document",
      matchedLocked: "This line is matched, so its project and expense code come from the matched document. Unmatch it first to set its own.",
      duplicateHint: "The bank cash book already has a manual entry with the same date and amount. Confirm if this is a different expense.",
      confirmDuplicate: "This is a different expense, save anyway",
    },
    record: {
      hint: "Record a bank movement and select an invoice to settle its balance. Do not record a movement already in the statement.",
      direction: "Movement",
      currency: "Currency",
      invoice: "Customer / supplier · invoice",
      other: "Other movement (no invoice settlement)",
      amount: "Amount",
      supplierPayment: "Supplier invoice payment",
    },
    title: "Bank statements",
    subtitle:
      "Bank ledger (account 112) imported from Internet Banking CSV; classify cash flows (sales, suppliers, payroll, financial income/expense) and reconcile with payment requests and invoice collections. When present, the financial statement takes bank balances from here (ADR-028).",
    invalidRange:
      "Choose both dates; the end date cannot be before the start date.",
    tabs: { lines: "Statement lines", summary: "Cash-flow summary" },
    filters: {
      account: "Account number",
      flowCode: "Flow code",
      all: "All",
      unmatched: "Unmatched only",
      defaultOnly: "Default-classified only",
    },
    columns: {
      date: "Date",
      month: "Month",
      document: "Doc no.",
      description: "Description",
      credit: "Credit",
      debit: "Debit",
      balance: "Balance",
      flowCode: "Flow code",
      source: "Source",
      matched: "Reconciled",
      allocation: "Project · expense code",
    },
    flowCodes: {
      Unclassified: "Unclassified",
      Sales: "Sales receipts",
      Supplier: "Supplier payments",
      Payroll: "Payroll, insurance",
      FinancialIncome: "Financial income",
      FinancialExpense: "Financial expense",
      Tax: "Taxes paid",
      Capital: "Capital contribution",
      InternalTransfer: "Internal transfer",
      Other: "Other",
    },
    sources: { Default: "Default", Rule: "Keyword", Manual: "Accountant" },
    import: {
      encoding: "CSV file encoding",
      tooLarge: "Import file must not exceed 10 MB.",
      button: "Import CSV / XLSX",
      title: "Import a statement from CSV",
      hint: "Export the statement from Internet Banking as CSV (date, description, debit/credit, balance). Duplicate lines are skipped, so the same file can be imported again.",
      account: "Account number",
      currency: "Currency",
      file: "CSV file",
      missing: "Enter the account number and choose a CSV file.",
      submit: "Import",
      result:
        "{imported} new lines, {skipped} duplicates skipped, {matchedRequests} matched payment requests, {matchedPayments} matched invoice collections, {defaults} default-classified lines to review.",
    },
    batch: {
      selected: "{count} lines selected",
      selectPage: "Select page",
      clear: "Clear selection",
      flowCode: "Classify as…",
      classify: "Classify {count} lines",
      match: "Match lines with exactly one suggestion",
      result: "{succeeded} done · {skipped} skipped · {failed} failed.",
      selectRow: "Select statement line",
    },
    match: {
      button: "Reconcile",
      unmatch: "Unlink",
      title: "Choose the document matching this statement line",
      none: "Not reconciled",
      noCandidates:
        "No payment request or invoice collection with the same amount within ±15 days.",
      kind: "Kind",
      reference: "Document",
      amount: "Amount",
      pick: "Pick",
      kindPaymentRequest: "Payment request",
      kindInvoicePayment: "Invoice collection",
    },
    summary: {
      title: "Bank cash flow by month",
      counts:
        "{lines} lines in range · {defaults} default-classified · {unmatched} unreconciled",
      credit: "Credit",
      debit: "Debit",
      balances: "Balances by account",
      account: "Account",
      lastDate: "Last date",
      credits: "Credits in range",
      debits: "Debits in range",
      balance: "Closing balance",
    },
  },
  amortizations: {
    title: "Prepaid expenses and tools",
    subtitle:
      "Straight-line monthly allocation (Depreciation sheet): amount ÷ periods, the last period takes the remainder. Allocations feed the target office line of the financial statement; the purchase itself is booked in the cash book with CPTT / CCDCPB.",
    invalidRange:
      "Choose both dates; the end date cannot be before the start date.",
    kinds: {
      Prepaid: "Prepaid expenses (CPTT)",
      Tool: "Tools and equipment (CCDC)",
    },
    filters: { includeInactive: "Show inactive items" },
    createPrepaid: "Add prepaid",
    createTool: "Add tool",
    create: "Add allocation item",
    edit: "Edit allocation item",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    total: "Total allocation",
    columns: {
      code: "Code",
      name: "Name",
      quantity: "Qty",
      recognizedOn: "Recognized on",
      amount: "Amount",
      periods: "Periods",
      start: "Start",
      monthly: "Per period",
      category: "Expense line",
      allocated: "Allocated to period end",
      remaining: "Remaining",
    },
    form: {
      openingAllocatedAmount: "Opening allocated amount",
      openingAllocatedPeriods: "Opening allocated periods",
      openingHint: "Keep the original start month and total periods. Opening allocations are not posted again as monthly expenses.",
      debitAccount: "Debit account",
      creditAccount: "Credit account",

      purchaseSource: "Purchase source",
      purchaseSourceHint:
        "Select a tool or prepaid purchase to use its cost. Each expense category in a purchase can have one allocation schedule.",
      sourceLocked:
        "Cost, kind, currency and recognition date are fixed by the purchase source.",
      effectiveMonth: "Effective month",
      effectiveHint:
        "Amount is the lifetime total. Original start and periods define the end; only the remaining amount is redistributed from the effective month.",
      kind: "Kind",
      code: "Code",
      name: "Name",
      recognizedOn: "Recognized on",
      amount: "Amount",
      currency: "Currency",
      periods: "Periods (months)",
      startYear: "Start year",
      startMonth: "Start month",
      category: "Target expense code",
      line: "line {line}",
      quantity: "Quantity",
      unit: "Unit",
      note: "Note",
    },
  },
  supplierInvoices: {
    paidEditHelp: "Payment history is retained. The revised total cannot be less than the amount already paid; the currency stays unchanged.",
    landedCost: {
      open: "Allocate to material cost",
      title: "Allocate import taxes and fees to stock cost",
      summary: "Invoice {invoice}, line {line}: {description} · code {category} · {amount} (before VAT)",
      basis: "Basis",
      bases: { Value: "By goods value", Quantity: "By quantity" },
      goodsInvoice: "Shipment receiving the fee",
      goodsSupplier: "Find the goods invoice by supplier",
      byCustoms: "By customs declaration {customs}",
      noReceipts: "No approved stock receipt was found for this shipment. Check the customs declaration number, or choose the goods invoice.",
      columns: { material: "Material", date: "Receipt date", quantity: "Received", issued: "Issued", purchaseValue: "Purchase value", landedSoFar: "Fees allocated", amount: "This allocation", stocked: "Into stock cost", expensed: "Share of issued goods" },
      total: "Total allocated",
      difference: "The allocated total must equal {amount}; it is off by {difference}.",
      issuedHint: "Part of this shipment has been issued. The fee share of issued goods does not enter stock cost; the fee is already a cost through its invoice.",
      propose: "Use proposed amounts",
      save: "Save allocation",
      replace: "Replace current allocation",
      replaceReason: "Reason for replacing",
      current: "Active allocation",
      cancel: "Cancel allocation",
      cancelReason: "Reason for cancelling",
      history: "Cancelled allocations ({count})",
      ineligible: { category: "This line is not an import tax or fee, so it cannot be allocated to material cost. VAT is never allocated.", void: "The invoice is voided." },
    },
    descriptiveOnly: "This invoice has payments: only the due date, responsible person, end user and note can change. Remove the payments to change amounts or lines.",
    stockReceipt: {"approved": "Received into stock (approved).", "open": "Open stock receipts", "material": "Stock material", "create": "Create / open receipt", "created": "Draft receipt; submit for approval before posting stock."},
    autoStock: {"received": "Automatically received {count} material line(s) into stock.", "skippedLine": "Line {line} was not received: {reason}", "deferred": "Invoice {id} was saved. {count} line(s) reached stock; remaining lines were deferred because {reason}. Retry after the project is unlocked.", "retry": "Retry remaining stock receipts"},
    matching: {
      held: "Payment held pending document matching",
      released: "Payment hold released with justification",
      releaseReason: "Payment release reason",
      release: "Release hold",
      purchase_order_missing: "Purchase order is missing",
      purchase_order_not_supplier: "Order is not a supplier purchase",
      purchase_order_not_approved: "Order is not approved",
      supplier_mismatch: "Supplier mismatch",
      project_mismatch: "Project mismatch",
      currency_mismatch: "Currency mismatch",
      purchase_order_line_missing: "Order line is missing",
      item_or_unit_mismatch: "Item or unit mismatch",
      price_mismatch: "Unit price mismatch",
      billed_quantity_exceeds_order: "Billed quantity exceeds order",
      billed_quantity_exceeds_approved_receipts:
        "Billed quantity exceeds approved receipts",
    },
    title: "Supplier invoices",
    subtitle:
      "Purchase vouchers with item lines (code, model, serial, name, group, quantity, unit, price, tax); multiple payments linked to paid payment requests; accounts payable by supplier and aging (Payables sheet).",
    invalidRange:
      "Choose both dates; the end date cannot be before the start date.",
    tabs: { invoices: "Supplier invoices", payables: "Accounts payable" },
    filters: { all: "All", outstandingOnly: "Outstanding only" },
    create: "New supplier invoice",
    edit: "Edit supplier invoice",
    overdueDays: "{days} days overdue",
    statuses: {
      Open: "Unpaid",
      PartiallyPaid: "Partially paid",
      Paid: "Paid",
      Void: "Voided",
    },
    columns: {
      number: "Invoice no.",
      date: "Invoice date",
      supplier: "Supplier",
      project: "Project",
      total: "Total",
      paid: "Paid",
      outstanding: "Outstanding",
      due: "Due date",
    },
    form: {
      invoiceOrCustomsNumber: "Invoice / customs declaration number",
      commercialPo: "Commercial PO",
      commercialPoHint: "Commercial order without a project code: choose the PO here; it applies to every line without a project.",
      legacyCustomsNumber: "Saved customs declaration",
      responsibleName: "Responsible person",

      purchaseOrder: "Supplier PO",
      addOrderLines: "Add order lines",
      exchangeRateSource: "Rate source",
      exchangeRateEffectiveDate: "Rate effective date",
      lookupRate: "Look up rate",

      endUser: "End user",
      category: "Expense category",
      currency: "Currency",
      exchangeRate: "Exchange rate",
      customs: "Customs declaration",
      note: "Note",
    },
    lines: {
      add: "Add line",
      allocation: "Project / Commercial PO",
      project: "Line project",
      commercialPo: "External commercial PO code",
      commercialPoNew: "This code has not been used before. Check it before saving.",
      categoryFromHeader: "Same as header ({code})",
      lineMode: "Allocating by line; select a project or enter a commercial PO for every line.",
      allocationRequired: "Each line needs exactly one project or external commercial PO code.",
      itemCode: "Item code",
      model: "Model",
      serial: "Serial",
      description: "Item / service",
      itemGroup: "Group",
      classification: "Classification",
      quantity: "Qty",
      unit: "Unit",
      unitPrice: "Unit price",
      tax: "Tax %",
      total: "Amount",
      subTotal: "Before tax",
      taxAmount: "Tax",
      groups: { goods: "Goods", services: "Services" },
      removeLine: "Remove line",
    },
    payment: {
      button: "Record payment",
      title: "Record a supplier invoice payment",
      createRequest: "Create payment request",
      noOutstanding: "The invoice has no outstanding amount.",
      history: "Payment history",
      none: "No payments yet.",
      date: "Payment date",
      amount: "Amount",
      reference: "Reference / transfer",
      paymentRequest: "Payment request",
      purpose: "Purpose",
      candidates:
        "Paid payment requests to suppliers in the same currency not yet linked (pick one to fill amount and date):",
      submit: "Record",
    },
    void: {
      button: "Void invoice",
      title: "Void supplier invoice",
      reason: "Reason",
    },
    payables: {
      title: "Accounts payable",
      line: "Line",
      invoiced: "Invoiced in month",
      paid: "Paid in month",
      closing: "Outstanding at month end",
      aging: "Aging at end date",
      current: "Current",
      bySupplier: "By supplier",
      outstanding: "Outstanding",
      openInvoices: "Open invoices",
      overdue: "Overdue",
    },
  },
  procurement: {
    salesInvoices: {
      contractTotal: "Total contract value",
      contractTotalHint: "Value from the project contract; repeated across invoice installments and not added to invoice revenue.",
      contractTotalUnavailable: "Contract values could not be loaded; the total contract column is temporarily blank.",
      title: "Sales invoice status",
      subtitle: "Customer sales invoices: project order, commercial order or undetermined; the system assigns the issue number.",
      create: "Issue invoice",
      tabInvoices: "Invoices",
      tabReceivables: "Receivables and collections",
      orderKind: "Order type",
      kindProject: "Project order",
      kindCommercial: "Commercial order",
      kindUndetermined: "Undetermined",
      internalPo: "Internal P/O (optional)",
      commercialPoCode: "Commercial PO code",
      commercialHelp: "This PO code applies to every line without its own destination.",
      lineOverrideHelp: "Each line can still choose its own project or commercial PO code; blank lines follow the invoice header.",
      sequenceAuto: "Assigned on save",
      customerFromProject: "The customer comes from the project or P/O.",
      numberRequired: "Enter the invoice number and issue date.",
      customerRequired: "Choose a customer.",
      projectRequired: "Choose a project or internal P/O for a project order.",
      commercialRequired: "Enter the commercial PO code.",
      linesRequired: "Enter at least one valid line or the invoice amount.",
      destination: "Project / PO",
      customerName: "Customer name",
      search: "Search invoice number, customer, project/PO",
      allStatuses: "All statuses",
      paymentTitle: "Collect invoice payment",
      amountTitle: "Update invoice amount",
      detailLines: "Lines",
      stockIssued: "Automatically issued stock for {count} material line(s).",
      stockSkippedLine: "Line {line} was not issued from stock: {reason}",
    },
    supplierDocument: {
      rfq: "RFQ from template",
      order: "Supplier purchase order",
      supplier: "Supplier receiving the RFQ",
      contact: "Recipient",
      template: "Document template",
      defaultTemplate: "Default template",
      excel: "Download Excel from the document template",
      pdf: "Download PDF from the document template",
      failed: "The document could not be exported from the template.",
    },
    poForm: {
      title: "PO form (sheet PO)",
      quotation: "Project quotation (QT No)",
      noQuotation: "— No quotation —",
      quotationsUnavailable: "Could not load project quotations (quotation read permission required).",
      endUser: "End user (EU)",
      nmiPercent: "NMI %",
      endUserCommissionPercent: "End user commission %",
      endUserTaxPercent: "Tax %",
      dealerCommissionPercent: "Dealer commission %",
      paymentTerm: "Payment term",
      warrantyTerm: "Warranty",
      help: "PO unit price = ROUND(Input price ÷ (1 − NMI%) × (1 + EU commission% × (1 + Tax%)), −3); dealer commission is for reconciliation only, not added to the price.",
      export: "Export PO (Form)",
      template: "PO template",
      templateAuto: "From quotation",
      exportFailed: "Could not export the PO file.",
    },
    monthlyStock: {"title": "Monthly inventory", "load": "Show inventory", "month": "Month", "value": "Inventory value", "unvalued": "No eligible receipt cost", "invalidFilters": "Choose a valid date range and a three-letter currency code.", "valuationHelp": "Only approved ledger entries count; valuation uses the latest receipt cost in the selected currency and affiliation.", "loadFailed": "Could not load inventory. Please try again."},
    sales: {"lines": "Sales invoice lines", "optionalLines": "Add lines to calculate invoice amount and tax; legacy invoices may use a header amount.", "previewTotal": "Estimated total", "responsibleName": "Responsible person", "affiliation": "Affiliation", "poHelp": "Select a P/O or project at the invoice level when it applies to every line.", "openOrders": "Open orders", "linesImmutable": "Issued lines are immutable; issue a replacement invoice to change them.", "lineMode": "Allocating by line; select a project or external commercial PO for each line. Projects must share one customer.", "allocationRequired": "Each line needs exactly one project or external commercial PO code.", "customer": "Customer", "customerRequired": "Select a customer for an invoice containing only external commercial PO codes.", "customerPermissionRequired": "Customer read access is required to select one.", "stockMaterial": "Stock material", "internalAsset": "Internal asset", "source": "Source", "stockAvailable": "Available: {quantity} {unit}"},
    stockSubmitted: "The stock transaction was submitted for approval.",
    stockType: "Transaction type",
    quantity: "Quantity",
    unit: "Unit",
    inventory: {
      title: "Business inventory counts and issues",
      subtitle:
        "Business inventory; counts and issues affect stock only after approval.",
      operation: "Operation",
      count: "Physical count",
      projectIssue: "Project issue",
      material: "Material",
      project: "Project",
      counted: "Counted quantity",
      date: "Document date",
      unitCost: "Unit cost",
      fifoCost: "FIFO cost",
      landed: "Purchase {purchase} · allocated fees {fees} · actual unit cost {actual}",
      fifoCostMissing: "No cost yet",
      createDraft: "Create draft stocktake/issue",
      reason: "Description / reason",
    },
    receipts: {
      title: "Purchase order receipts",
      part: "Order line",
      ordered: "Ordered",
      approved: "Approved receipts",
      remaining: "Remaining",
      reason: "Receipt reason",
      materialRequired:
        "Select goods, materials or parts before creating a business inventory receipt.",
      createDraft: "Create draft business inventory receipt",
      draftCreated:
        "Draft business inventory receipt created; submit for approval to update stock.",
    },
    requests: {
      title: "Quotation and purchase requests",
      subtitle:
        "Create requests, capture supplier quotes and follow Workflow approval",
    },
    orders: {
      title: "Supplier purchase orders",
      subtitle: "Raise purchase orders to suppliers from approved purchase requests, track approval and delivery",
    },
    invoices: {
      title: "Invoice issuance status",
      subtitle: "Sales invoices; the system assigns the issue number per project or PO",
    },
    stock: {
      title: "Business inventory receipts, issues and balance",
      subtitle: "Immutable transaction ledger with server-calculated balance",
    },
    newRecord: "New record",
    deleteConfirm: "Delete this draft?",
    reasonPrompt: "Enter the required reason",
    quoteRequired:
      "Select a supplier, enter a quote total greater than zero, and provide the currency.",
    quotes: {
      title: "Recorded supplier quotes",
      selected: "Selected",
      select: "Select this quote",
    },
    amountRequired: "Enter the invoice amount, currency and due date.",
    paymentRequired: "Payment amount must be greater than zero.",
    overdue: "Past due",
    payment: {
      date: "Paid date",
      amount: "Payment amount",
      reference: "Reference (optional)",
    },
    slot: "Issue",
    lines: "Lines",
    freeText: "Free text",
    receipt: "Stock In",
    issue: "Stock Out",
    stockQuantityRequired: "Quantity must be greater than 0.",
    stockDateRequired: "Select a transaction date.",
    stockReasonRequired: "Enter a reason for the stock transaction.",
    stockSerialAlreadyExists: "This serial already exists.",
    stockSerialQuantityMustBeOne: "A serialized item must have a quantity of 1.",
    stockSerialNotAvailable: "This serial is no longer in stock.",
    stockSerialNone: "No serial tracking",
    borrow: "Borrow",
    currentBalance: "Current balance",
    internalMaterials: "Internal material stock",
    materialEntry: "Business inventory receipt",
    assetEntry: "Asset receipt",
    borrowingList: "Material borrowing list",
    borrowSlip: "Material borrowing slip",
    borrowAsset: "Borrow asset",
    backendPending: "This function is not supported yet.",
    submitForApproval: "Submit for approval",
    startBorrowing: "Start borrowing",
    returnMaterial: "Return goods/materials to business inventory",
    receiptRequired:
      "Enter the goods category, model/code, description, unit, and business inventory receipt quantity.",
    belowSafety: "Below safety stock",
    safetyStock: "Safety stock",
    stockStatus: "Stock status",
    stockAvailable: "Sufficient stock",
    empty: "No data",
    actions: {
      submit: "Submit",
      quote: "Record quote",
      adminReceive: "Admin receive",
      accountingReceive: "Accounting receive",
      revise: "Create revision",
      deliver: "Confirm delivery",
      void: "Void invoice",
      reverse: "Reverse transaction",
      updateAmount: "Update amount",
      recordPayment: "Record payment",
      withdraw: "Withdraw",
      cancelRequest: "Cancel request",
      cancelOrder: "Cancel purchase order",
    },
    decisionReason: "Reason",
    quoteComparison: {
      title: "Supplier quote comparison",
      hint: "Only quotes of the current request revision; difference against the lowest price in the same currency.",
      quotedOn: "Recorded on",
      file: "Quote file",
      difference: "Difference",
      selection: "Selected",
      lowest: "Lowest",
      hasFile: "File attached",
      attach: "Attach quote file",
      mixedCurrency: "Several currencies: differences compare within one currency only, no conversion.",
      olderRevisions: "{count} quotes of older revisions are hidden.",
    },
    stockPanel: {
      title: "Stock receipt/issue",
      types: {
        receipt: "Receipt",
        issue: "Issue",
        reversal: "Reversal",
      },
      customs: "Customs declaration",
      book: "book",
      workflowStep: "Workflow step",
      lines: "Material lines",
      unit: "Unit",
      amount: "Amount",
    },
    fields: {
      project: "Project",
      department: "Department",
      requestedDate: "Requested date",
      quotationDueDate: "Quotation due",
      deliveryDueDate: "Delivery due",
      endUser: "End user",
      partCode: "Part code",
      modelCode: "Model",
      description: "Description",
      supplier: "Supplier",
      quoteTotal: "Quote total",
      currency: "Currency",
      purchaseRequest: "Purchase request",
      receivedDate: "Received date",
      revision: "Revision",
      deliveryDate: "Delivery date",
      deliveredDate: "Actual delivery date",
      deliveryTerm: "Delivery term",
      moduleCode: "Module",
      issueDate: "Issue date",
      invoiceNumber: "Invoice number",
      amount: "Invoice amount",
      dueDate: "Due date",
      paid: "Collected",
      outstanding: "Outstanding",
      transactionType: "Transaction type",
      material: "Material",
      quantity: "Quantity",
      unit: "Unit",
      transactionDate: "Transaction date",
      serial: "Serial",
      reason: "Reason",
      customs: "Customs declaration",
      unitCost: "Unit cost",
      slipCode: "Slip code",
      borrower: "Borrower",
      borrowDate: "Borrow date",
      expectedReturnDate: "Expected return date",
      materialName: "Material name",
      documentNumber: "Document number",
      category: "Material category",
      detailDescription: "Detailed description",
      receiptQuantity: "Receipt quantity",
      condition: "Condition",
      note: "Note",
      location: "Location",
      remark: "Remark",
      selectMaterial: "Select material",
      newMaterialOption: "— Create a new material —",
      modelOrCode: "Model / material code",
      materialCode: "Material code",
      internalModelOrCode: "Model / internal material code",
      availableShort: "In stock",
    },
    borrowStatuses: { draft: "Draft", borrowing: "Borrowing" },
    internalStatuses: { available: "Available", maintenance: "Maintenance" },
    conditions: { good: "Good", used: "Used", damaged: "Damaged" },
    placeholders: {
      reason: "Purchase order PO-2024-001",
      customs: "12345678900",
    },
  },
  payments: {
    payerSettings: { "title": "Payer settings", "help": "Accounting configures the accounts allowed to pay or collect money. Only configured active accounts appear when assigning a payer.", "accounts": "Eligible accounts", "inactive": "Inactive account — deselect before saving", "empty": "No eligible payers are configured. Open Payer settings to configure accounts before assigning payment." },
    advanceSettings: { title: "Advance settings", cashLimit: "Cash advance limit", bankAccount: "Company account", bankAccounts: "Company bank accounts", bankAccountsHint: "One account number per line, up to 50 accounts. Keep leading zeros.", invalid: "Enter a nonnegative limit and up to 50 accounts, with at most 50 characters per account." },
    allocations: {
      title: "Allocate to supplier invoices",
      allocated: "Allocated",
      remaining: "Remaining",
      invoice: "Invoice",
      invoiceDate: "Invoice date",
      dueDate: "Due date",
      outstanding: "Outstanding",
      amount: "Allocation",
      fill: "Fill max",
      held: "payment on hold",
      noCandidates:
        "No open invoices of this supplier in the same currency and project.",
      over: "The allocation exceeds what is left on the payment.",
      submit: "Allocate {amount}",
    },
    payrollLink: {
      title: "Link to payroll",
      hint: "Link to a draft payroll period; publication does not confirm this payment as paid.",
      linked: "Linked",
      year: "Year",
      period: "Payroll period",
      attach: "Add to payroll",
    },
    kinds: {
      Advance: "Advance request",
      Payment: "Payment request",
      AdvanceSettlement: "Advance settlement",
    },
    subtitle: {
      Advance:
        "Form NMI-AC-0001/01 — cash advances up to 10 million per request, settle within 10 days",
      Payment:
        "Form NMI-AC-0001/02 — attach invoices, a quotation from 3 million and a contract from 5 million",
      AdvanceSettlement:
        "Form NMI-AC-0001/04 — reconcile the advance with what was spent",
    },
    sections: { pending: "In progress", done: "Paid / closed" },
    columns: {
      nextApprover: "Awaiting approval",
      number: "Number",
      requestDate: "Request date",
      requester: "Requester",
      project: "Project",
      category: "Expense code",
      amount: "Amount",
      method: "Method",
      paidDate: "Paid on",
      warnings: "Warnings",
    },
    filters: {
      scope: "Scope",
      mine: "My requests",
      all: "All",
      from: "From",
      to: "To",
    },
    actions: {
      new: "New request",
      retry: "Retry workflow",
      disburse: "Choose payment method",
      editDisbursement: "Edit payment method",
      confirmPaid: "Confirm paid",
      closeSettlement: "Refund received",
      print: "Print",
    },
    dialogs: {
      approve: "Approve request",
      disburse: "Choose payment method",
      editDisbursement: "Edit payment method",
      confirm: "Confirm the payment",
      refund: "Confirm the refund",
      cancel: "Cancel request",
      plannedPayDate: "Planned pay date",
      lineCategories: "Expense codes per line",
      lineCategoriesHint: "Accounting can assign expense codes at any approval status. Reopen a closed financial period before changing posted classifications.",
      saveCategories: "Save expense codes",
      categoryMissing: "Not assigned",
      paidDate: "Paid on",
      reference: "Transfer reference",
      receivedDate: "Received on",
      cancelReason: "Reason",
      deleteConfirm: "Delete this draft?",
    },
    approval: {
      loadFailed: "Could not load approval access. Refresh the list and try again.",
      unavailable: "This request is no longer at a step you can approve. Refresh the list.",
      waitingLabel: "Next approval",
      waitingFor: "Waiting: {step} — {names}",
      waitingStep: "Waiting: {step}",
      noRecipient: "No one receives this step yet",
      directManager: "direct manager",
      lineManager: "level-{level} manager",
      steps: {
        DepartmentHeadApproval: "Manager approval",
        ChiefAccountantApproval: "Accounting approval",
        DirectorApproval: "Director approval",
        CeoApproval: "CEO approval",
      },
    },
    detail: {
      requester: "Requester",
      departmentHead: "Department head",
      chiefAccountant: "Chief accountant",
      director: "Director",
      rejected: "Rejected",
      requested: "requested",
      workflowFailed: "Workflow not started",
    },
    form: {
      affiliation: "Affiliation",
      keepAffiliation: "Keep current affiliation",
      noOpenAdvances:
        "You have no paid, unsettled advances. Unpaid advances or advances requested by another employee cannot be selected.",
      advanceLoadFailed:
        "Eligible advances could not be loaded. Retry before saving.",
      information: "Request information",
      project: "Project code",
      officeExpense: "Office expense (no project)",
      purpose: "Purpose",
      category: "Expense code",
      payeeType: "Payee",
      payeeName: "Payee name",
      requestDate: "Request date",
      requestedMethod: "Requested method",
      taskEndDate: "Task end date",
      contractValue: "Contract value",
      settlesAdvance: "Advance being settled",
      selectAdvance: "Choose a paid advance",
      directorOverrideNote: "Director note (exceptional case)",
      assignedPayer: "Assigned payer / collector",
      evidence: "Supporting images / documents",
      saveBeforeEvidence: "Choose the document type and file before creating the request. The draft and upload are completed in one action.",
      evidenceType: "Supporting document type",
      evidenceFile: "Attachment",
      evidenceRequired: "Choose a quotation, contract, voucher, or invoice attachment before creating the request.",
      evidenceDraftSaved: "The draft was saved. Retry the upload to finish creating the request.",
      evidenceUploadFailed: "The attachment could not be uploaded. The draft remains available for retry.",
      evidenceFileInvalid: "Choose a non-empty PDF, Office, image, TXT, CSV, or ZIP file up to 25 MB.",
      evidenceFiles: "Selected files (choose a type for each file)",
      evidenceRemove: "Remove file",
      evidenceFailed: "Files not uploaded yet",
      evidenceRetry: "Retry",
      categoryOptionalHint: "Expense codes may be left blank; accounting assigns a code to each line at payment.",
      advanceCategoryHint: "Expense codes on advances are optional and do not recognize an expense. Expense is recognized when the advance settlement is completed.",
      bankAccount: "Company bank account number",
      bankAccountHint: "Enter or choose the sending/receiving account. The transaction appears in bank statements after payment or receipt is confirmed.",
      evidencePermissionRequired: "Document upload permission is required to create this request.",
      attachmentsDeclared: "Declared attachments",
      quoteProvided: "Quotation attached",
      contractProvided: "Contract attached",
      lines: "Lines",
      lineDescription: "Description",
      documentKind: "Supporting document",
      documentNumber: "Invoice / declaration no.",
      documentDate: "Document date",
      amount: "Amount",
      addLine: "Add line",
      removeLine: "Remove line",
      total: "Total",
      advanceAmount: "I. Advance amount",
      spentAmount: "II. Amount spent",
      difference: "III. Difference",
      refundDue: "(advance refund)",
      extraDue: "(paid by the company)",
      amountToPay: "Amount to pay",
      requester: "Full name",
      employeeCode: "Employee code",
      department: "Department",
      requesterHint:
        "Employee code, name and department are copied from your employee profile when saved.",
    },
    methods: {
      Cash: "Cash",
      Transfer: "Bank transfer",
      Payroll: "Via payroll",
    },
    payees: { Employee: "Employee", Supplier: "Supplier" },
    documentKinds: {
      NoInvoice: "No invoice",
      Invoice: "Invoice",
      Declaration: "Customs declaration",
      Other: "Other document",
    },
    evidenceCategories: {
      Quotation: "Quotation",
      Contract: "Contract",
      PaymentProof: "Voucher",
      Invoice: "Invoice",
    },
    compliance: {
      advance_unsettled:
        "This paid advance has not been settled. Create an advance settlement.",
      title: "NMI-AC-0001 checks",
      clean: "No warnings.",
      cash_advance_limit_exceeded:
        "Cash advance exceeds 10,000,000 per request — a director note is required (§IV.1a).",
      cash_advance_limit_overridden:
        "Cash advance exceeds 10,000,000; director note provided.",
      open_advance_exists:
        "A previous advance is still open — settle it before requesting another.",
      open_advance_overridden:
        "A previous advance is still open; director note provided.",
      transfer_advance_exceeds_contract_share:
        "Advance by transfer exceeds 30% of the contract value.",
      invoice_required:
        "A line of 200,000 or more has no financial invoice (§III.3).",
      quote_required: "From 3,000,000 a supplier quotation is required.",
      contract_required: "From 5,000,000 a supply contract is required.",
      settlement_overdue:
        "Settlement filed more than 10 days after the task ended.",
      cash_limit_exceeded:
        "Cash payment exceeds the limit of this expense group (purchases < 3 million, hospitality < 5 million).",
    },
    print: {
      print: "Print",
      requester: "Requester",
      departmentHead: "PD manager",
      chiefAccountant: "Chief accountant",
      director: "Director",
      project: "Project code:",
      employeeCode: "Employee code:",
      fullName: "Full name:",
      department: "Department:",
      requestDate: "Request date:",
      content: {
        Advance: "Advance details",
        Payment: "Payment details",
        AdvanceSettlement: "Settlement details",
      },
      documents: "Supporting documents",
      amount: "Amount",
      total: "Total:",
      noInvoice: "No invoice",
      advanceSection: "Advance amount",
      spentSection: "Amount spent",
      differenceSection: "Difference",
      attachments: "(Attached: invoices and payment documents)",
      issuedOn: "Issued on",
    },
    cashBook: {
      unverified: "Opening balance has not been verified",
      negativeReason: "Reason for proceeding with a negative cash balance",
      openingCertificate: {
        title: "Verify opening balance",
        hint: "The balance applies before all entries on the selected date. Each verification and its evidence are appended without overwriting history.",
        evidence: "Balance verification evidence",
      },
      invalidRange:
        "Choose a start and end date; the end date must not precede the start date.",
      title: "Cash book",
      subtitle:
        "Track receipts and payments by fund; make corrections with reversal entries.",
      tabs: {
        ledger: "Cash book",
        office: "Office expenses",
        cash: "Cash expenses",
        flow: "Cash flow",
      },
      fund: { CashBox: "Cash box", Bank: "Bank" },
      filters: { fund: "Fund" },
      columns: {
        month: "Month",
        description: "Description",
        receipt: "Receipt",
        disbursement: "Disbursement",
        date: "Date",
        project: "Project",
        document: "Document",
        category: "Expense code",
        payee: "Payee",
        unit: "Unit",
        balance: "Balance",
      },
      opening: "Opening balance",
      closing: "Closing balance",
      record: "Record receipt / payment",
      side: "Entry type",
      reverse: "Reverse",
      reverseReason: "Reason",
      reversed: "Reversed",
      reversal: "Reversal",
      total: "Total",
      office: {
        title: "Office expenses",
        subtitle: "Expenses by category and fiscal month, excluding projects",
        line: "Detail",
      },
      cash: {
        title: "Cash expenses",
        subtitle: "Cash box disbursements by expense code (projects included)",
      },
      flow: {
        title: "Cash flow",
        subtitle:
          "Receipts, disbursements and running balance per month for one fund",
        net: "Net",
      },
    },
    categories: {
      title: "Expense codes",
      subtitle: "Expense categories for office and project finance reports",
      new: "New code",
      group: "Report group",
      groups: {
        OfficeExpense: "Office expense",
        ProjectCogs: "Project cost of goods",
        ProjectIncidental: "Project incidental",
        Personnel: "Personnel",
        Financial: "Financial, tax",
        Equity: "Equity",
        Deferred: "Deferred (prepaid, tools)",
      },
      officeLine: "Office report line",
      sheetLine: "Project sheet line",
      sheetLines: {
        NhaCungCap: "Supplier",
        PhiMoToKhai: "Customs filing fee",
        PhiThongQuan: "Clearance fee",
        LePhiToKhai: "Declaration fee",
        PhiLamHang: "Handling fee",
        ThueNK: "Import duty",
        ThueGTGT: "VAT",
        CuocCPN: "Express freight",
        PhiBaoHiem: "Insurance",
        PhiVanChuyen: "Transport",
        PhiNganHang: "Bank fee",
        LuongNhanSu: "Staff cost",
        TangCa: "Overtime",
        PhuCapXang: "Fuel allowance",
        PhuCapXe: "Vehicle allowance",
        PhuCapKhachSan: "Hotel allowance",
        PhuCapAn: "Meal allowance",
        PhuCapCongTac: "Travel allowance",
        Ship: "Shipping, mail",
        TiepKhach: "Hospitality",
          TiepKhachDuAn: "Project entertainment",
        MuaHang: "Purchases",
      },
      sortOrder: "Order",
      active: "Active",
      inactive: "Inactive",
      deactivate: "Deactivate",
      activate: "Activate",
    },
  },
  projectFinance: {
    profitWarningsTitle: "Projects below planned profit",
    profitWarningsUnavailable: "Data or source permissions are insufficient to compare profit for every project.",
    profitWarningsEmpty: "No projects require a profit decline warning.",
    profitDecline: "Decline",
    warningYellow: "Yellow",
    warningRed: "Red",

    profitChartUnavailable: {
      limitedAccess: "The chart is unavailable because access to financial sources is limited.",
      noPlan: "The chart is unavailable because planned profit is missing.",
      incomplete: "Dated data is insufficient to reconcile the chart with the financial sheet.",
    },
    entertainment: "Entertainment",
    profitWarningYellow: "Yellow warning: actual profit is {decline} below plan.",
    profitWarningRed: "Red warning: actual profit is {decline} below plan.",
    profitChartTitle: "Cumulative profit and costs by month",
    profitChartPlanned: "Planned profit",
    profitChartCosts: "Costs",
    profitChartActual: "Actual profit",
    profitChartMonth: "Month",

    projectEntertainment: "Project entertainment",
    contractRevenueUnavailable: "No eligible contract value is available, or access is unavailable. Planned revenue is undetermined.",
    contractPlanSource: "Planned revenue comes from active or completed contracts in the same currency. Planned costs remain based on the accepted quotation.",
    stock: {
      row: "Stock issued (FIFO cost)",
      issue: "{material} × {quantity}: issued to the project",
      transferOut: "{material} × {quantity}: this project's stock issued to {project}",
      outsideStatement: "outside the financial statements (opening or manual stock without a supplier invoice)",
      missing: "{count} stock issue part(s) for the project have no cost yet (receipt without unit cost or issued before FIFO) and are not priced.",
      outsideHint: "{count} stock issue part(s) come from opening or manual stock without a supplier invoice: shown here but not in the financial statements.",
      unavailable: "Project stock issue costs could not be loaded; the Stock issued row has no figures.",
    },
    labor: {
      unavailable: "Project overtime/travel could not be loaded from payroll; the Overtime and Travel allowance lines only include payment requests.",
      noAccess: "Payroll read permission is required to show project overtime/travel and the calculation rules.",
      missing: "{count} overtime items have no hourly rate (no salary profile) and are not priced.",
      missingRate: "hourly rate missing",
      rulesTitle: "Overtime and travel calculation rules (effective payroll policy)",
      formulaOvertime: "Overtime pay = hours × multiplier (weekday/rest day/holiday, day/night; night is before 06:00 or from 22:00) × hourly rate; hourly rate = (base salary + position allowance + skill allowance) / (standard days × hours per day).",
      formulaTrip: "Same-day trip/onsite earns one daily allowance at 100 km or more with at least 4 hours, or below 100 km with at least 6 hours. Legacy requests without distance use minutes and show a warning. Overnight = nights × night rate. Only approved requests linked to this project count.",
      sourceTypes: {
        Overtime: "Overtime",
        BusinessTrip: "Business trip",
        Onsite: "Onsite",
      },
      detail: {
        Overtime: "{employee} · {type}: {quantity} h × {multiplier} × {rate}/h",
        TripDay: "{employee} · {type} same day: {quantity} day × {rate}",
        TripNight: "{employee} · {type} overnight: {quantity} night × {rate}",
      },
      rules: {
        month: "Month",
        source: "Policy source",
        period: "Payroll revision {revision} ({status})",
        default: "Default (no payroll period yet)",
        weekday: "Weekday multiplier (day/night)",
        restDay: "Rest day multiplier (day/night)",
        holiday: "Holiday multiplier (day/night)",
        tripDay: "Same-day trip",
        tripNight: "Overnight trip",
        hoursPerDay: "Hours per day",
        minimumOvertime: "Minimum overtime (minutes)",
        onsite: "Onsite counted",
        onsiteIncluded: "Yes",
        onsiteExcluded: "No",
      },
    },
    supplierCommitments:
      "Unbilled purchase order commitments: {amount}. Excluded from actual costs.",
    profitComparisonUnavailable:
      "Profit comparison is unavailable because planned profit is not positive or data is missing.",
    loadFailed:
      "Financial data could not be loaded completely. Refresh before reviewing or exporting the report.",
    limitedAccess:
      "The report includes only the data sources you are permitted to view.",
    title: "Project finance sheet",
    subtitle:
      "Compare quotation and planned work with actual costs and revenue.",
    pickProject: "Choose a project",
    head: {
      code: "Project code",
      customer: "Customer",
      content: "Project content",
      leader: "Project leader",
      totalDays: "Total days",
      remainingDays: "Days remaining",
      staff: "Staff (mandays)",
      costHidden: " · no permission to see unit cost",
    },
    milestones: {
      Receipt: "Received",
      Survey: "Survey",
      SolutionProposal: "Solution proposal",
      Demo: "Demo",
      Quotation: "Quotation",
      PurchaseOrder: "P/O received",
      GoLive: "Go-live",
    },
    collection: { title: "Collection progress" },
    columns: {
      percent: "%",
      item: "Item",
      planned: "Planned",
      actual: "Actual",
      paid: "Paid",
      unpaid: "Unpaid",
      variance: "Variance plan − actual",
      verdict: "Verdict",
    },
    revenue: "Revenue",
    cogs: "Cost of goods",
    incidental: "Incidental costs",
    profit: "Profit",
    verdict: { Saving: "Saving", Over: "Over", Neutral: "—" },
    tabs: {
      sheet: "Finance sheet",
      plan: "Plan (quotation)",
    },
    plan: {
      title: "Plan from the accepted quotation",
      none: "The project has no quotation accepted by the customer, so there is no plan yet.",
      noAccess: "Quotation read permission is required to show the plan.",
      costHidden: "You cannot see quotation costs: planned cost, commission, fees and profit are hidden and profit cannot be compared.",
      source: "Quotation {number} revision {revision} · pricing {model} · form {template} · affiliation {affiliation} · accepted on {date}",
      projectMonth: "Project month: {month} ({basis})",
      bases: {
        Contract: "earliest PO date",
        ProjectCreated: "project creation date",
      },
      lines: {
        revenue: "Planned revenue (before VAT, after discount)",
        cost: "Planned cost (acquisition × qty)",
        endUserCommission: "End-user commission",
        endUserTax: "End-user tax",
        inPriceVat: "VAT in price",
        contingency: "Contingency",
        grossProfit: "Planned gross profit",
        corporateTax: "Corporate income tax",
        netProfit: "Planned net profit",
      },
      summary: {
        title: "SUMMARY — totals by quotation group",
        group: "Group",
        subtotal: "Amount",
        share: "Share",
      },
    },
    profitVerdict: { Profit: "Profit", Loss: "Loss", Neutral: "—" },
    otherCurrencies:
      "Amounts in other currencies ({currencies}) are not converted and are not shown on this sheet.",
    sources:
      "Plan: latest quotation revision (price, cost) and manday cost; Actual: P/O, collected invoices (ADR-025), approved payment requests by expense code (ADR-027). * = planned date, no actual date yet.",
  },
  accounting: {
    overview: "Accounting overview",
    paymentVouchers: "Payment vouchers",
    paymentSteps: {
      Submitted: "Awaiting approval",
      Approved: "Awaiting payment",
      Disbursing: "Paying",
    },
    receivables: "Receivables",
    payables: "Payables",
    outstanding: "Outstanding",
    overdue: "Overdue",
    current: "Current",
    noData: "No data yet.",
  },
  hr: {
    overview: "HR overview",
    myRequests: "My requests (this year)",
    ledgerPending: "Leave & overtime ledger",
    pendingRequests: "Pending requests",
    shortcuts: "Shortcuts",
  },
  crm: {
    overview: "CRM overview",
    activeCustomers: "Active",
    inactiveCustomers: "Inactive",
    allCustomers: "All",
    myFollowUps: "My follow-ups",
    openFollowUps: "Open",
  },
  purchasing: {
    overview: "Purchasing overview",
    openList: "Open list",
    openStock: "Open material stock",
    pending: "Documents waiting for action",
    nothingPending: "Nothing is waiting.",
    queues: {
      label: "Queues by status",
      all: "All",
      draft: "Draft",
      inProgress: "In progress",
      awaitingApproval: "Awaiting approval",
      approved: "Approved",
      received: "Received",
      delivered: "Delivered",
      closed: "Closed",
      rejected: "Rejected",
      cancelled: "Cancelled",
    },
  },
  help: {
    title: "Help center",
    search: "Search help…",
    empty: "No matching topic.",
    noTopic: "The screen you came from has no dedicated topic yet; pick the closest one below.",
    steps: "Steps",
    tips: "Notes",
    openScreen: "Open screen",
    groupStart: "Getting started",
    shortcut: "Help (F1)",
    groupProcesses: "Cross-module processes",
    groupRoles: "By role",
    filterRole: "Filter by role",
    allRoles: "All roles",
    print: "Print / Save as PDF",
    onThisPage: "On this page",
    quickStart: "Quick start",
    detailPending: "The detailed guide (process, diagrams, use cases) for this group is being written; use the Quick start above for now.",
    sections: { purpose: "Purpose and who uses it", prerequisites: "Before you start", anatomy: "Screen areas", tasks: "Step-by-step tasks", statuses: "Statuses", flows: "Process diagrams", useCases: "Use cases", troubleshooting: "Common problems and tips" },
    when: "When to use",
    roles: "Roles",
    permissions: "Required permissions",
    permission: "Permission code",
    meaning: "Meaning",
    result: "Result",
    check: "Check",
    status: "Status",
    by: "Changed by",
    next: "Moves to",
    notApplicable: "Not applicable",
    legend: { normal: "next step", reject: "rejected / invalid", return: "returned / redo" },
    actor: "Actor",
    goal: "Goal",
    preconditions: "Preconditions",
    mainFlow: "Main flow",
    alternatives: "Alternative / error flows",
    outcome: "Outcome",
    problem: "Problem",
    message: "System message",
    fix: "How to fix",
    related: "Related topics",
  },
  legal: {
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    links: "Policies and terms",
    language: "Language",
    contents: "Contents",
    effectiveDate: "Effective {date}",
    backToLogin: "Back to sign in",
  },
  login: {
    title: "Sign in",
    subtitle: "One data flow from opportunity to go-live.",
    email: "Email",
    password: "Password",
    action: "Sign in",
    invalid: "Invalid credentials",
    unavailable:
      "Cannot connect to the server. Please check the service and try again.",
    failed: "Sign-in could not be completed. Please try again.",
    mustChangePassword:
      "You are using a temporary password set by an administrator. Set a new password before using the system.",
    devQuickLogin: "Quick sign-in by role (DEV)",
    devQuickLoginPlaceholder: "Choose a role account…",
    devQuickLoginHint: "Development only: seeded accounts (deploy/dev/config.js); never available in production.",
    platformAction: "Sign in with Q One",
    platformDivider: "or",
    platformContinuing: "Signing in with Q One…",
    platformNotLinked: "This Q One account has no active CRM account with the same email. Contact your CRM administrator.",
    platformFailed: "Sign-in with Q One failed. Try again or sign in with your password.",
    backToLogin: "Back to sign-in",
  },
  sso: {
    title: "Single sign-on",
    continuing: "Taking you to the system that shares this sign-in…",
    failed: "The shared sign-in session could not be established. Try again or contact the system administrator.",
    invalidReturn: "The return address is not valid.",
    retry: "Try again",
    home: "Back to CRM home",
  },
  dashboardPeriod: {
    reports: "SUMMARY 4 · Reports",
    requests: "Operational requests",
    teamHub: "Timesheet approvals",
    users: "User directory",
    stock: "Material stock",
    invoices: "Invoices",
    customers: "Customers",
    from: "From",
    to: "To",
    generated: "Updated {at}",
    loadingRows: "Loading {loaded}/{total} projects",
    registration: "Registration totals",
    charts: "SUMMARY 1 · Project metrics",
    delivery: "SUMMARY 1 · Delivery",
    resources: "SUMMARY 2 · Resources",
    issues: "SUMMARY 3 · Issues",
    approvals: "Approvals",
    capacity: "Capacity",
    approvalHistory: "Approval history (cycle)",
    purchaseRequests: "Purchase requests",
    purchaseOrders: "Purchase orders",
    costs: "Costs & margin",
    curve: "S-curve",
    milestones: "Milestones",
    stale: "Stale projects",
    workload: "People workload",
    documents: "Project documents",
    quality: "Delivery quality",
    qualityIssues: "Issues after go-live",
    receivables: "Receivables",
    surveys: "Satisfaction surveys",
    followUps: "My follow-ups",
    paymentQueues: "Payment vouchers by step",
    payables: "Payables",
    myRequests: "My requests",
  },
  dashboard: {
    viewMode: "View mode",
    viewChart: "Chart",
    viewTable: "Table",
    tableLabel: "Item",
    presetLabel: "Quick period",
    viewsLabel: "Dashboard views",
    views: {
      crm: "CRM",
      overview: "Overview",
      projects: "Projects",
      finance: "Finance",
      resources: "Resources",
      procurement: "Purchasing",
      quality: "Quality & issues",
      people: "People & approvals",
      untitled: "New view",
    },
    widgetGroups: {
      overview: "Overview",
      projects: "Projects",
      finance: "Finance",
      resources: "Resources",
      procurement: "Purchasing & stock",
      quality: "Quality",
      people: "People & approvals",
    },
    widget: {
      noTiles: "No tiles selected — choose Customize, then the gear icon.",
      retry: "Retry",
      partial: "{count} data sources could not be loaded.",
    },
    edit: {
      customize: "Customize",
      done: "Done",
      addWidget: "Add widget",
      searchWidgets: "Search widgets",
      viewFull: "This view already has 40 widgets.",
      added: "Added",
      add: "Add",
      settingsTitle: "Settings: {name}",
      limitDefault: "Dashboard default ({count})",
      detail: "Detail level",
      detailCompact: "Compact — key charts",
      detailFull: "Full — all analysis charts",
      comparePrevious: "Compare with the previous period (up/down arrow on tiles)",
      tiles: "Visible tiles ({count}/{max})",
      keys: "arrows to move, Shift + left/right arrow to resize, Delete to remove",
      move: "Drag to move",
      moveBefore: "Move earlier",
      moveAfter: "Move later",
      narrower: "Narrower",
      wider: "Wider",
      width: "Width {width}/12 columns",
      configure: "Settings",
      remove: "Remove widget",
      hint: "Drag the handle to move, −/+ to resize; changes are saved to your account.",
      emptyView: "This view has no widgets yet.",
      saving: "Saving layout…",
      saveFailed: "Layout not saved — try again later.",
    },
    manage: {
      open: "Views",
      title: "Manage views",
      hint: "Rename, reorder, hide or add your own views; each view is a set of widgets.",
      rename: "Rename {name}",
      widgetCount: "{count} widgets",
      up: "Up",
      down: "Down",
      show: "Show",
      hide: "Hide",
      delete: "Delete {name}",
      newName: "New view name",
      copyCurrent: "Copy widgets from the open view",
      add: "Add view",
      template: "Layout template",
      roleDefault: "role default",
      reset: "Restore template",
      resetConfirm: "Discard all customizations and use the selected template?",
    },
    templates: {
      executive: "Executive",
      project: "Project management",
      sales: "Sales",
      accounting: "Accounting",
      purchasing: "Purchasing & stock",
      hr: "Human resources",
    },
    widgets: {
      kpi: {
        title: "Key figures",
        description: "KPI tiles of your choice; click a tile to open the related list.",
      },
      attention: {
        title: "Needs attention",
        description: "Alerts, projects to act on, Go-lives in the next 30 days and silent projects.",
      },
      portfolio: {
        title: "Project portfolio",
        description: "Status, schedule health, lifecycle and remaining time of projects.",
      },
      pipeline: {
        title: "Project pipeline",
        description: "Stage funnel, type, priority and responsible Leader.",
      },
      progress: {
        title: "Progress & milestones",
        description: "S-curve against the plan and slipped milestones.",
      },
      attachments: {
        title: "Project documents",
        description: "Files by category, files awaiting scan and projects missing required documents.",
      },
      finance: {
        title: "Cost & margin",
        description: "Planned/actual cost and expected margin by project.",
      },
      receivables: {
        title: "Receivables",
        description: "Collected, outstanding and overdue by currency and customer.",
      },
      resources: {
        title: "Resources & capacity",
        description: "Planned/actual Manday by project and timesheet capacity.",
      },
      workload: {
        title: "Workload by person",
        description: "Heatmap of overload, idle days and cross-project conflicts.",
      },
      procurement: {
        title: "Purchasing & stock",
        description: "Purchase requests, purchase orders, stock movements and invoices in the period.",
      },
      issues: {
        title: "Issues & incidents",
        description: "Active issues by status, severity and project.",
      },
      quality: {
        title: "Delivery quality",
        description: "On-time delivery, acceptance and customer incidents after Go-live.",
      },
      satisfaction: {
        title: "Customer satisfaction",
        description: "Survey scores, NPS and survey coverage.",
      },
      approvals: {
        title: "Approvals",
        description: "Pending approvals by age, document type and approval cycle.",
      },
      progressOverview: {
        title: "Progress overview",
        description: "Three-year Gantt of operational projects: plan from the PO date to the end date, actual, PO, open/late requests, late work.",
      },
      governance: {
        title: "Reports & requests",
        description: "Reports awaiting review and requests by type and status.",
      },
      payables: {
        title: "Payables",
        description: "Supplier payables year to date: totals, aging and top suppliers owed.",
      },
    },
    presets: {
      thisMonth: "This month",
      thisQuarter: "This quarter",
      thisYear: "This year",
      last30: "Last 30 days",
      custom: "Custom",
    },
    lastUpdated: "Updated {at}",
    sourcesOk: "{count} sources ready",
    sourcesError: "{count} sources failed",
    kpiTitle: "Executive indicators",
    kpiGroups: {
      crm: "Customers & follow-ups",
      projects: "Projects",
      mandays: "Mandays",
      finance: "Finance",
      issues: "Issues",
      approvals: "Approvals & reports",
      procurement: "Procurement",
      documents: "Documents",
      quality: "Quality & satisfaction",
      people: "Workforce & customers",
    },
    kpi: {
      total: "Total projects",
      active: "Running",
      late: "Behind schedule",
      pastGoLive: "Past go-live",
      completed: "Completed",
      planned: "Planned MD",
      actual: "Actual MD",
      mandayRatio: "Actual / planned",
      plannedCost: "Planned cost",
      actualCost: "Actual cost",
      expectedMargin: "Avg expected margin",
      negativeMargins: "Negative-margin projects",
      attachmentFiles: "Clean-scanned files",
      attachmentPendingScan: "Pending scan",
      attachmentMissing: "Projects missing documents",
      receivableCollected: "Collected in period",
      receivableOutstanding: "Outstanding",
      receivableOverdue: "Overdue",
      satisfactionAverage: "Average satisfaction",
      satisfactionNps: "NPS",
      surveyCoverage: "Closed projects surveyed",
      workloadOverload: "Overloaded person-days",
      workloadIdle: "Idle person-days",
      workloadConflicts: "Multi-project conflicts",
      openIssues: "Open",
      overdueIssues: "Overdue",
      criticalIssues: "Critical",
      pendingApprovals: "Pending approvals",
      overdueApprovals: "Past SLA",
      slaRate: "On-time SLA",
      pendingReports: "Reports awaiting review",
      pendingRequests: "Requests awaiting review",
      pendingTimesheets: "Timesheets awaiting approval",
      openPurchaseRequests: "PR in progress",
      undeliveredOrders: "PO undelivered",
      overdueOrders: "PO past delivery date",
      invoicesIssued: "Invoices in period",
      utilization: "Capacity utilization",
      overloadedDays: "Overloaded workdays",
      customersActive: "Active customers",
      customersInactive: "Inactive customers",
      openFollowUps: "Open follow-ups",
      paymentQueues: "Payment vouchers",
      payablesOutstanding: "Payables outstanding",
      openInvoices: "{count} open invoices",
      vsPrevious: "vs previous period",
      previousValue: "Previous period ({from} – {to}): {value}",
      myRequests: "My requests",
    },
    tone: {
      good: "Stable",
      warning: "Watch",
      critical: "Act now",
    },
    alertsTitle: "Executive alerts",
    alertsHint: "Items needing action now; click to jump to the section.",
    alerts: {
      lateProjects: "projects behind schedule",
      pastGoLive: "projects past go-live",
      overdueIssues: "overdue issues",
      overdueApprovals: "approvals past SLA",
      overdueOrders: "orders past delivery date",
      overloadedDays: "overloaded workdays",
      pendingReports: "reports awaiting review",
      pendingRequests: "requests awaiting review",
      silentProjects: "stale projects",
      overdueMilestones: "overdue milestones",
      overdueInvoices: "invoices past due",
      workloadOverload: "overloaded person-days",
      workloadIdle: "idle person-days",
      workloadConflicts: "multi-project conflicts",
    },
    attentionTitle: "Projects needing attention",
    attentionHint:
      "Ranked by risk: behind schedule, past go-live, overdue / critical issues, manday overrun.",
    attentionEmpty: "No project needs attention in this period.",
    colProject: "Project",
    colCustomer: "Customer",
    colReasons: "Reasons",
    colProgress: "Progress",
    colRemaining: "Remaining",
    colIssues: "Open issues",
    colVariance: "MD variance",
    colGoLive: "Go-live",
    overdueShort: "{count} overdue",
    reasons: {
      late: "Behind schedule",
      pastGoLive: "Past go-live",
      overdueIssues: "Overdue issues",
      criticalIssues: "Critical issues",
      mandayOver: "Manday overrun",
      silent: "Stale",
      milestoneOverdue: "Overdue milestone",
    },
    daysLeft: "{count} days",
    daysOver: "{count} days over",
    sectionFinance: "Project finance",
    financeHint:
      "Manday cost at the active profile and margin against submitted quotations.",
    sectionProgress: "Trends & milestones",
    progressHint:
      "Planned/actual S-curve, slipped milestones and stale projects.",
    sectionWorkload: "People workload",
    workloadHint:
      "Running work items by person and day; click a cell for detail.",
    sectionAttachments: "Project documents",
    attachmentsHint:
      "Files by project and category, summarized by the Document service within your read scope.",
    sectionQuality: "Delivery quality",
    qualityHint:
      "On-time go-live, acceptance slip, rework mandays and customer issues after delivery.",
    sectionPayables: "Payables",
    payablesHint:
      "Supplier invoices from the start of the year to today: outstanding, aging and the suppliers owed the most.",
    payables: {
      totals: "Payables ({currency})",
      totalsHint: "Year to date.",
      outstanding: "Outstanding",
      openInvoices: "Open invoices",
      overdue: "Overdue",
      agingTitle: "Payables aging ({currency})",
      agingHint: "Outstanding amount by days past due.",
      bySupplier: "Suppliers owed the most",
      aging: {
        current: "Not yet due",
        days1To30: "1–30 days",
        days31To60: "31–60 days",
        days61To90: "61–90 days",
        daysOver90: "Over 90 days",
      },
    },
    sectionReceivables: "Receivables and collections",
    receivablesHint:
      "Issued invoice amounts, collections, outstanding and overdue aging by currency.",
    sectionSatisfaction: "Customer satisfaction",
    satisfactionHint:
      "Survey scores by criterion, score distribution, NPS by quarter/customer and closed-project coverage.",
    finance: {
      title: "Project finance",
      hidden: "You are not allowed to view manday costs.",
      hiddenDetail:
        "Contact an administrator if you need cost and margin visibility.",
      totalsTitle: "Total cost in period",
      totalsHint: "At the active manday cost profile",
      noProfile: "No active manday cost profile.",
      planned: "Planned",
      actual: "Actual",
      averageMargin: "Avg expected margin",
      negativeMargins: "Negative-margin projects",
      byProject: "Cost by project",
      margin: "Expected margin",
      marginHint:
        "Ascending; only projects comparable in the same currency (VND)",
      expectedMargin: "Margin %",
      mandays: "Mandays by project",
      mandaysHint: "Planned and actual for the same project set",
    },
    progressCurve: {
      planFromWbs: "The plan line uses the current WBS.",
      plannedEnd: "Planned end {end}; the plan line uses the current WBS.",
      curve: "Portfolio S-curve",
      milestones: "Milestones in period",
      milestonesHint: "On-time rate and currently overdue milestones",
      onTimeRate: "On-time rate",
      overdueCount: "Overdue milestones",
      currentPlannedEnd: "Planned end",
      noOverdue: "No overdue milestone.",
      colMilestone: "Milestone",
      colSlip: "Slip (days)",
      slipChart: "Milestone slip days",
      slipHint: "Positive is late, negative is early; settled milestones only",
      slipDays: "Slip days",
    },
    stale: {
      title: "Stale projects",
      hint: "No progress update in 7 working days",
      colSilentDays: "Silent days",
      colWarnings: "Warnings",
      warningTypes: {
        Late: "Late",
        AtRisk: "Not started",
        OverMandays: "Over mandays",
        MissingUpdate: "Missing update",
      },
    },
    workload: {
      hint: "Person/day workload for operational projects.",
      heatmap: "Workload heatmap",
      heatmapHint:
        "Darker means more work; red border at ≥ 3 tasks or > 1 MD/day.",
      heatmapCaption: "Person by day workload grid",
      metricLabel: "Metric",
      metricTasks: "Tasks",
      metricMandays: "Mandays",
      empty: "No assigned work item in the period.",
      unitTasks: "tasks",
      colPerson: "Person",
      colTotal: "Total",
      rowUnassigned: "Unassigned",
      rowTotal: "Day total",
      loadTitle: "Workload hotspots",
      loadHint: "On working days, against 1 MD/day",
      overloaded: "Overloaded person-days",
      idle: "Idle person-days",
      conflicts: "Multi-project conflicts",
      stack: "Work by day and person",
      stackHint: 'Up to 8 people, the rest fold into "Other"',
      planVsActual: "Plan vs timesheets",
      planVsActualHint: "Planned MD vs approved minutes / 480",
      planned: "Planned",
      actual: "Approved",
      dialogNoPermission: "You are not allowed to view WBS detail.",
      dialogEmpty:
        "No assigned work item found for this person in these projects.",
    },
    goLiveTitle: "Upcoming go-live (30 days)",
    goLiveHint: "Unfinished projects, nearest first",
    sectionPipeline: "Sales & pipeline",
    pipelineHint:
      "SUMMARY 1 stage funnel and distribution by type, priority and leader.",
    sectionGovernance: "Reports & requests",
    governanceHint:
      "Project reports in the period and the operational request queue (current state).",
    total: "Total projects",
    completed: "Completed",
    mandayRatio: "Actual / planned MD",
    openIssues: "Open issues",
    overdueIssues: "Overdue issues",
    pendingApprovals: "Pending approvals",
    overdueApprovals: "Overdue approvals",
    utilization: "Capacity utilization",
    topN: "Top {count}",
    topNLabel: "Projects per chart",
    asOf: "As of {date}",
    sectionNav: "Jump to section",
    sectionPortfolio: "Project portfolio",
    sectionResources: "Resources & capacity",
    sectionIssues: "Issues & incidents",
    sectionApprovals: "Approvals",
    sectionProcurement: "Procurement",
    portfolioHint:
      "For the selected planning period; click a bar to open the project.",
    resourcesHint:
      "Approved mandays per project and timesheet capacity within the period.",
    issuesHint:
      "Issues active within the period on operational projects you can see.",
    approvalsHint:
      "Current state across the system, not period-scoped; click a bar to open the inbox.",
    procurementHint:
      "Current state of visible PR/PO records, not period-scoped.",
    title: "Operations center",
    subtitle: "Overview and analysis from approved data; choose your views and widgets",
    active: "Active projects",
    late: "Late projects",
    planned: "Planned MD",
    actual: "Actual MD",
    summary1: "SUMMARY 1 · Delivery",
    summary2: "SUMMARY 2 · Resources",
    progress: "Progress",
    variance: "Variance",
  },
  analytics: {
    title: "Executive analytics",
    subtitle: "Deep-dive charts split out of Overview, grouped by domain",
    tabsLabel: "Analytics domain",
    tabs: {
      projects: "Projects",
      finance: "Finance",
      resources: "Resources",
      issues: "Issues",
      approvals: "Approvals",
      procurement: "Procurement",
      quality: "Quality",
      people: "People",
    },
    empty: "No data for this domain in the period.",
  },
  charts: {
    acceptanceMappingMissing:
      "{count} projects have missing or ambiguous acceptance stage mappings.",
    acceptanceMappingLegacy:
      "{count} projects use explicitly configured legacy acceptance mappings.",

    stageCompletion: "Completion by 16 stages",
    stageN: "S{n}",
    salesFunnel: "Project stage funnel",
    salesFunnelHint: "Projects that reached each stage milestone",
    stages: {
      Receipt: "Receipt",
      Survey: "Survey",
      SolutionProposal: "Solution proposal",
      Demo: "Demo",
      Quotation: "Quotation",
      PurchaseOrder: "P/O received",
      GoLive: "Go-live",
    },
    byLeader: "Projects by leader",
    unassigned: "Unassigned",
    byType: "Projects by type",
    byPriority: "Projects by priority",
    priorities: {
      Low: "Low",
      Normal: "Normal",
      High: "High",
      Critical: "Critical",
    },
    reportStatus: "Reports by status",
    reportStatusHint: "Reports whose period overlaps the filter",
    reportStatuses: {
      Draft: "Draft",
      Submitted: "Submitted",
      Reviewed: "Reviewed",
      Approved: "Approved",
      Returned: "Returned",
      Rejected: "Rejected",
    },
    reportType: "Reports by type",
    reportTypes: {
      Daily: "Daily",
      Weekly: "Weekly",
    },
    axisReports: "Reports",
    inPeriodHint: "Raised within the period",
    currentStateHint: "Current state, not period-scoped",
    requestsPendingByType: "Pending requests by type",
    requestsPendingHint: "Submitted / confirmed, not yet decided",
    requestTypes: {
      TimeCorrection: "Work hour confirmation",
      Leave: "Leave",
      Overtime: "Overtime",
      Onsite: "Onsite",
      BusinessTrip: "Business trip",
      Vehicle: "Vehicle",
      Meal: "Meal",
    },
    requestsByStatus: "Requests by status",
    requestStatuses: {
      Draft: "Draft",
      Submitted: "Submitted",
      Confirmed: "Confirmed",
      Approved: "Approved",
      Rejected: "Rejected",
      Returned: "Returned",
      AdminReceived: "Admin received",
      AccountingReceived: "Accounting received",
      Withdrawn: "Withdrawn",
      Cancelled: "Cancelled",
    },
    stockByType: "Stock transactions by type",
    stockTypes: {
      Receipt: "Receipt",
      Issue: "Issue",
      Reversal: "Reversal",
    },
    stockByStatus: "Stock transactions by status",
    stockStatuses: {
      Draft: "Draft",
      Submitted: "Submitted",
      Confirmed: "Confirmed",
      Approved: "Approved",
      Rejected: "Rejected",
      Reversed: "Reversed",
    },
    stockMovement: "Approved receipts / issues by material",
    stockReceipt: "Receipt",
    stockIssue: "Issue",
    axisTransactions: "Transactions",
    axisQuantity: "Quantity",
    invoiceStatus: "Invoices by status",
    invoiceStatuses: {
      Issued: "Issued",
      Voided: "Voided",
    },
    axisInvoices: "Invoices",
    capacityHealthUnit: "Person × day",
    axisProjects: "Projects",
    axisPercent: "Share (%)",
    axisProgress: "% complete",
    axisStage: "Stage",
    axisDays: "Days",
    axisMandays: "Mandays (MD)",
    axisHours: "Hours",
    axisDate: "Date",
    axisIssues: "Issues",
    axisTasks: "Pending tasks",
    axisRequests: "Requests",
    axisOrders: "Orders",
    axisAmount: "Amount",
    axisCurrency: "Currency",
    unitMd: "MD",
    unitDays: "days",
    unitHours: "h",
    scheduleHealthShare: "Portfolio schedule health",
    lifecycle: "Project lifecycle",
    lifecycleRegistration: "Registration",
    lifecycleExecuting: "Executing",
    lifecycleFinished: "Finished",
    progressBuckets: "Completion distribution",
    progressBucket0: "0%",
    progressBucket1To25: "1–25%",
    progressBucket26To50: "26–50%",
    progressBucket51To75: "51–75%",
    progressBucket76To99: "76–99%",
    progressBucket100: "100%",
    scheduleShareByProject: "Ahead / on time / late share by project",
    stageHint: "16 SUMMARY 1 stages, % of projects done",
    remainingDayBuckets: "Days remaining to go-live",
    remainingOverdue: "Past go-live",
    remainingWithin7: "≤ 7 days",
    remainingWithin30: "8–30 days",
    remainingWithin90: "31–90 days",
    remainingOver90: "> 90 days",
    byCustomer: "Projects by customer",
    mandayVariance: "Manday variance (actual minus planned)",
    mandayEfficiency: "Manday efficiency by project",
    efficiencyHint: "{count} lowest projects",
    capacityDaily: "Daily capacity",
    capacityAvailable: "Available",
    capacityApproved: "Approved",
    capacityDraft: "Draft",
    capacityHealth: "Workday health",
    capacityHealthHint: "Per person and day in the period",
    capacityNormal: "Normal",
    capacityOverloaded: "Overloaded",
    capacityMissing: "Missing timesheet",
    issueStatus: "Issues by status",
    issueSeverity: "Issues by severity",
    issueDelivery: "Issues by delivery state",
    issueSource: "Issue source",
    issuesByProject: "Open issues by project",
    issueOpen: "Open",
    issueInProgress: "In progress",
    issueResolved: "Resolved",
    issueClosed: "Closed",
    issueOpenOnTime: "Open, within deadline",
    severityLow: "Low",
    severityMedium: "Medium",
    severityHigh: "High",
    severityCritical: "Critical",
    deliveryPlanned: "Planned",
    deliveryAtRisk: "At risk",
    deliveryDue: "Due",
    deliveryOverdue: "Overdue",
    deliveryDelivered: "Delivered",
    sourceCustomer: "Customer",
    sourceInternal: "Internal",
    approvalsByType: "Pending approvals by type",
    approvalsByTypeHint: "Overdue by step SLA",
    approvalPending: "Within SLA",
    approvalOverdue: "Overdue",
    approvalAge: "Approval waiting age",
    approvalAgeHint: "Since assignment",
    approvalCycleByType: "Approval cycle by type",
    approvalCycleByTypeHint: "Hours from assignment to decision",
    approvalCycleByStep: "Approval cycle by step",
    approvalCycleByStepHint: "Slowest first, up to 10",
    approvalThroughput: "Decisions per day",
    approvalThroughputHint: "Tasks decided each day in period",
    approvalAvgCycle: "Avg (h)",
    approvalMedianCycle: "Median (h)",
    approvalApproved: "Approved",
    approvalRejected: "Rejected",
    approvalCancelled: "Cancelled",
    attachmentStack: "Files by project",
    attachmentStackHint:
      "Top {count} projects by file count, stacked by category",
    attachmentMatrix: "Document density by project",
    attachmentMatrixHint: "Darker cells hold more files within a category",
    attachmentMatrixCaption:
      "Attachment table by project and document category",
    attachmentTotals: "Documents & scan status",
    attachmentTotalsHint:
      "Clean-scanned files only; pending and rejected files are tracked separately",
    attachmentFiles: "Clean-scanned files",
    attachmentPendingScan: "Pending scan",
    attachmentRejected: "Rejected files",
    attachmentMissingProjects: "Projects missing required documents",
    attachmentMissingExample: "Example projects missing",
    attachmentOwners: "Projects readable",
    attachmentProject: "Project",
    attachmentRowTotal: "Project total",
    attachmentColumnTotal: "Category total",
    attachmentCategoryTotals: "Files by document category",
    attachmentCategoryTotalsHint: "All projects within read scope",
    attachmentCategories: {
      Survey: "Survey",
      Drawing: "Drawing",
      Contract: "Contract",
      Report: "Report",
      Other: "Other",
    },
    qualityTotals: "Delivery quality",
    qualityTotalsHint:
      "Projects that went live in and 90 days before the period",
    qualityOnTimeRate: "On-time go-live",
    qualityAverageSlip: "Avg go-live slip (days)",
    qualityRework: "Rework mandays after go-live",
    qualityProjects: "Projects live",
    goLiveOnTimeByQuarter: "On-time go-live by quarter",
    goLiveOnTimeByQuarterHint: "On time / late by go-live quarter",
    goLiveOnTime: "On time",
    goLiveLate: "Late",
    goLiveSlip: "Go-live slip",
    goLiveSlipHint: "Actual minus planned; positive means late",
    acceptanceSlip: "Acceptance slip days",
    acceptanceSlipHint: "Only projects with an actual acceptance date",
    customerIssuesAfterGoLive: "Customer issues after go-live (90 days)",
    customerIssuesAfterGoLiveHint:
      "Customer issues received within 90 days of go-live",
    qualityCustomerIssues: "Customer issues",
    reworkMandays: "Rework mandays after go-live",
    reworkMandaysHint:
      "Work items whose actual start is after the go-live date",
    receivableTotals: "Receivables {currency}",
    receivableTotalsHint:
      "Collected and balance for the period; overdue measured against the due date",
    receivableInvoiced: "Invoiced",
    receivableCollected: "Collected",
    receivableOutstanding: "Outstanding",
    receivableOverdue: "Overdue",
    receivableOverdueInvoices: "Overdue invoices",
    receivableAging: "Overdue aging {currency}",
    receivableAgingHint: "Days past due against today (Vietnam time)",
    "receivableAging0-30": "0–30 days",
    "receivableAging31-60": "31–60 days",
    "receivableAging61-90": "61–90 days",
    receivableAgingOver90: "> 90 days",
    receivableMonth: "Invoiced vs collected {currency}",
    receivableMonthHint:
      "By invoice issue month and payment month within the period",
    receivableByProject: "Receivables by project {currency}",
    receivableByProjectHint:
      "Top {count} projects by outstanding, with the overdue part",
    satisfactionTotals: "Surveys in period",
    satisfactionTotalsHint: "Score 1–5; NPS = %(9–10) − %(0–6)",
    satisfactionSurveys: "Surveys",
    satisfactionProjects: "projects",
    satisfactionAverage: "Avg overall",
    satisfactionNps: "NPS",
    satisfactionCoverage: "Closed-project coverage",
    satisfactionBreakdown: "Promoters / passives / detractors",
    satisfactionCriteriaTitle: "Scores by criterion",
    satisfactionCriteriaHint: "1–5 scale, Overall is the headline score",
    satisfactionDistributionTitle: "Overall score distribution",
    satisfactionDistributionHint: "Survey count by level 1–5",
    satisfactionNpsQuarter: "NPS by quarter",
    satisfactionNpsQuarterHint: "Negative means more detractors than promoters",
    satisfactionNpsCustomer: "NPS by customer",
    satisfactionNpsCustomerHint: "Top {count} customers by survey count",
    axisPoints: "Score (1–5)",
    axisSurveys: "Surveys",
    satisfactionCriteria: {
      schedule: "Schedule",
      quality: "Quality",
      communication: "Communication",
      support: "Support",
      overall: "Overall",
    },
    ageUnder1Day: "< 1 day",
    ageOneToThreeDays: "1–3 days",
    ageThreeToSevenDays: "3–7 days",
    ageOverSevenDays: "> 7 days",
    targetTypes: {
      ProjectRegistration: "Project registration",
      ProjectIssue: "Project issue",
      Timesheet: "Timesheet",
      MealDayRegistration: "Meal registration",
      PurchaseRequest: "Purchase request",
      PurchaseOrder: "Purchase order",
    },
    prStatus: "Purchase requests by status",
    poStatus: "Purchase orders by status",
    poOutlook: "Undelivered orders by due date",
    poOutlookHint: "Submitted/approved orders, by delivery date",
    poValue: "Open purchase order value",
    poValueHint: "Submitted/approved orders, by currency",
    outlookOverdue: "Past delivery date",
    outlookWithin7: "≤ 7 days",
    outlookWithin30: "8–30 days",
    outlookOver30: "> 30 days",
    prStatuses: {
      Draft: "Draft",
      Submitted: "Submitted",
      Quoted: "Quoted",
      Confirmed: "Confirmed",
      Approved: "Approved",
      AdminReceived: "Admin received",
      AccountingReceived: "Accounting received",
      Rejected: "Rejected",
      Cancelled: "Cancelled",
    },
    poStatuses: {
      Draft: "Draft",
      Submitted: "Submitted",
      Approved: "Approved",
      Rejected: "Rejected",
      Delivered: "Delivered",
      Cancelled: "Cancelled",
    },
    projectStatus: "Project status",
    completionProgress: "Completion progress",
    scheduleStatus: "Schedule status",
    executionDays: "Execution day tracking",
    mandays: "Manday tracking",
    resourceStatus: "Resource status",
    running: "Running",
    pause: "Pause",
    cancelled: "Cancelled",
    completed: "Completed",
    inProgress: "In progress",
    notStarted: "Not started",
    notCompleted: "Not completed",
    ahead: "Ahead",
    onTrack: "On track",
    late: "Late",
    elapsed: "Elapsed",
    remaining: "Remaining",
    planned: "Planned",
    actual: "Actual",
    enough: "Enough",
    shortage: "Shortage",
    over: "Over",
    filtered: "Chart filter is active",
    clearFilter: "Clear filter",
    other: "Other",
  },
  summary1: {
    totalExecutionDays: "Total execution days",
    remainingDays: "Total remaining days",
    done: "Done",
    pending: "Pending",
    manday: "Man day",
    efficiency: "Efficiency",
    projectStatus: "Project status",
    stageStatus: "Status",
    link: "Link",
    openProject: "Open project {code}",
  },
  summary1Stages: {
    survey: "Survey",
    solutionProposal: "Solution proposal",
    demo: "Demo",
    quotation: "Quotation",
    purchaseOrder: "Purchase order received",
    implementation: "Project implementation",
    supplierPurchaseOrder: "Supplier P/O",
    subcontractorPurchaseOrder: "Subcontractor P/O",
    commissioningTest: "Commissioning test",
    delivery: "Delivery",
    installation: "Installation",
    operationTest: "Operation test",
    massProduction: "Mass production",
    training: "Training",
    acceptance: "Acceptance",
    payment: "Payment",
  },
  inlineGrid: {
    addRow: "Add row",
    removed: "Row removed.",
    undo: "Undo",
  },
  saveStatus: {
    pending: "Unsaved changes",
    saving: "Saving…",
    saved: "Saved",
    invalid: "Not saved",
    error: "Save failed",
  },
  recordPanel: {
    fullscreen: "Full screen",
    exitFullscreen: "Back to panel",
    previous: "Previous record",
    next: "Next record",
    discardChanges: "You have unsaved changes. Discard them?",
  },
  customers: {
    panel: {
      tabs: {
        info: "Details",
        contacts: "Contacts & sites",
        projects: "Projects",
        activities: "Activities",
        followUps: "Follow-ups",
        finance: "Finance",
        commercial: "Quotes & POs",
      },
      financialTerms: "Payment terms",
      commercialQuotations: "Customer quotations",
      commercialOrders: "Customer POs",
      newQuotation: "New quotation",
      commercialHint: "Quotations and POs of the customer projects you can see. Click a row to open it in Quotes & contracts.",
      audit: "Change tracking",
      noContacts: "No contacts yet. Choose Edit to add one.",
      noSites: "No sites yet.",
      defaultSite: "Default",
      activitiesHint: "Calls, e-mails and meetings logged with this customer.",
      logActivity: "Log activity",
      scheduleFollowUp: "Schedule follow-up",
      noActivities: "No activities yet.",
      noFollowUps: "No follow-ups.",
      markDone: "Done",
    },
    projectsPageSummary: "Status counts for the loaded page",
    projectsForbidden: "You do not have permission to view this customer's projects.",
    title: "Customer Master",
    codeFromShortName: "Code derived from the short name",
    deleteConfirm: "Move customer {code} to the trash?",
    subtitle: "Legal profile, sites, contacts and commercial terms",
    legalName: "Legal name",
    shortName: "Short name",
    abbreviation: "Abbreviation",
    province: "Province / City",
    country: "Country",
    tax: "Tax ID",
    owner: "Sales owner",
    new: "New customer",
    duplicate: "Duplicate check",
    industry: "Industry",
    sector: "Sector",
    legalRep: "Legal representative",
    sites: "Sites / Plants",
    contacts: "Contacts",
    financial: "Financial",
    bank: "Bank",
    account: "Account number",
    paymentTerm: "Payment term",
    creditDays: "Credit days",
    paymentDay: "Recurring payment day",
    history: "Project history",
    addSite: "Add site",
    addContact: "Add person",
    siteName: "Site name",
    siteType: "Type",
    address: "Address",
    isDefault: "Default",
    fullName: "Full name",
    department: "Department",
    position: "Title",
    phone: "Phone",
    email: "Email",
    corporateEmail: "Company email",
    fax: "Fax",
    factoryCount: "Factory count",
    dupExact: "Tax code matches an existing customer — cannot create.",
    dupName: "Legal name is similar to an existing customer — please verify.",
    profile: "Profile",
    activate: "Activate",
    deactivate: "Deactivate",
    backToProjectHistory: "Back to Project history",
    historyChat: "Chat",
    historyTable: "PO",
    readOnlyLog: "Read-only activity log",
    customerSpeaker: "Customer",
    youProjectManager: "You (Project Manager)",
    internalSpeaker: "Internal team member",
    communicationLog: "Communication log",
    searchCommunicationLog: "Search the log...",
    selectSpeaker: "Speaking party",
    meSpeaker: "Internal (Me)",
    externalSpeaker: "Customer / partner representative",
    communicationPlaceholder: "Enter meeting minutes, technical agreements, or project exchange notes...",
    addCommunicationEntry: "New communication entry",
    saveCommunicationEntry: "Save to log",
    communicationEntryTitle: "Record project communication entry",
    communicationEntrySubtitle: "Preserve meeting minutes, technical discussions, or partner agreements",
    recordedBy: "Recorded by",
    ctrlEnterHint: "Press Ctrl + Enter to save quickly",
    attachedDocuments: "Attached documents & minutes",
    speakerLabel: "Speaker / Representative",
    allTimelineEntries: "Journal timeline",
    attachFile: "Attach file",
    documentFallback: "Document",
    communicationEmpty: "No communication recorded",
    communicationEmptyHint:
      "Saved exchanges will appear here in chronological order.",
    projectHistoryUnavailable: "Project activity could not be loaded.",
    historyEntries: "entries",
    loadingOlderMessages: "Loading older entries...",
    loadOlderMessages: "Load older entries",
    startOfHistory: "Beginning of communication history",
    placeholders: {
      sector: "Manufacturing",
      corporateEmail: "contact{'@'}company.com",
      bank: "Vietcombank",
      account: "0123456789012",
      creditDays: "30",
      paymentDay: "15",
      siteName: "Head Office",
      siteType: "Headquarters",
      country: "VN",
      contactName: "Nguyen Van A",
      department: "Sales Department",
      position: "Sales Manager",
      phone: "0987654321",
      email: "contact{'@'}company.com",
    },
    unknownSpeaker: "Unknown sender",
  },
  products: {
    panel: {
      tabs: {
        info: "Details",
        components: "Components",
        revisions: "Revisions",
      },
      components: "Components",
      master: "Master data",
      activeRevision: "Active revision",
      allRevisions: "View {count} revisions",
      manageComponents: "Manage components",
      moreComponents: "Show {count} more components",
      pendingRevision: "Revision {code} is waiting for activation.",
      draftPending: "A draft revision is waiting for activation",
      pricing: "Prices & costs",
      editMaster: "Edit details",
      editDraft: "Edit draft revision {code}",
      newRevision: "New revision {code}",
    },
    listPrice: {
      button: "Import List price",
      title: "Import the List price sheet into the product catalogue",
      dryRun: "Dry run",
      commit: "Write to catalogue",
      summary: "{inserts} new products · {updates} updated products · {components} new components · {componentUpdates} updated components",
      committed: "Saved {inserts} new products, {updates} updated products, {components} components.",
      mappingNote: "No new column: component price = A&A cost + Mr Sang's cost (VND); A&A, Mr Sang, Standard/Option and NMI Price = ROUND(price/0.6, −5) are written in the feature description.",
      kindStandard: "Standard",
      kindOption: "Option",
      columns: {
        code: "Code",
        name: "Name",
        kind: "Type",
        aaCost: "A&A cost",
        sangCost: "Mr Sang's cost",
        unitPrice: "Unit price",
        nmiPrice: "NMI Price",
        action: "Action",
      },
      actions: {
        Insert: "Insert",
        Update: "Update",
        Error: "Error",
      },
      issues: {
        list_price_not_numeric: "Price is not a number",
        list_price_mismatch: "Excel price mismatch",
        list_price_kind_ambiguous: "Both Standard and Option",
        list_price_orphan_component: "Code above the first module",
        list_price_name_missing: "Module without name",
        duplicate_code_in_payload: "Duplicate module code",
        duplicate_product_component: "Duplicate component code",
        validation_failed: "Invalid data",
        record_in_trash: "Product is in the trash",
        list_price_empty: "No module row",
        list_price_sheet_missing: "List price sheet missing",
        list_price_header_missing: "Header row missing",
        invalid_workbook: "Unreadable file",
      },
    },
    exportCsv: "Export CSV",
    bom: {
      unknownCurrency: "Unspecified currency",
      partName: "Product",
      module: "Module",
      code: "Code",
      title: "Components of {code}",
      featureDescription: "Feature description",
      unitPrice: "Unit price",
      totalPrice: "Total price",
      currency: "Currency",
      componentCode: "Input code (supplier code)",
      outputCode: "Output code",
      outputCodePlaceholder: "Same as input code",
      price: "Price",
      addComponent: "Add component",
      updateComponent: "Update component",
      catalogAmbiguous:
        "The catalog has multiple values for this selection. Check and enter the appropriate code, description, price and currency.",
      empty: "No components declared yet.",
      invalid: "Every component needs its own code and a non-negative price.",
      saved: "Component list saved.",
      dragToReorder: "Drag to reorder",
      moveUp: "Move up",
      moveDown: "Move down",
    },
    placeholders: {
      code: "PN-00123",
      outputCode: "Leave blank to use the code",
      partName: "Bracket Assembly",
      model: "M-2024A",
      category: "Mechanical Parts",
      unit: "PCS",
      revision: "Rev. A",
      description: "Short description of the part",
      specification: "Steel, 2mm thickness",
      makerName: "ABC Manufacturing",
      currency: "USD",
      module: "MD-101",
    },
    title: "Product Master",
    subtitle: "Models, revisions and default WBS templates",
    code: "Code",
    outputCode: "Output code",
    outputCodeTooLong: "Output code must not exceed 50 characters.",
    model: "Model",
    module: "Module",
    category: "Category",
    partName: "Product",
    revision: "Revision",
    revisions: "Revisions",
    customers: "Linked customers",
    unit: "Unit",
    new: "New product",
    specification: "Specification",
    effective: "Effective from",
    import: "Import",
    importHelp:
      "CSV includes the standard headers and procurement columns: makerName,importQuantity,currency,inputPrice,fobPrice,importTax,cifCost,swiftFee,landedCost. The optional outputCode column preserves the current output code when omitted; an empty cell uses the input code.",
    importInvalid: "Row is missing required fields or has an invalid date",
    importReady: "valid rows",
    addRevision: "Add revision",
    activateRevision: "Activate",
    defaultTemplate: "Default WBS template",
    deactivate: "Deactivate",
    description: "Part Description",
    makerName: "Maker name",
    importQuantity: "Import quantity",
    currency: "Currency unit",
    inputPrice: "Input Price",
    fobPrice: "FOB Price",
    importTax: "Import Tax",
    cifCost: "CIF Cost",
    swiftFee: "SWIFT Fee",
    landedCost: "Landed cost",
    selectCustomer: "Select customer",
    customerModel: "Customer model",
    linkCustomer: "Link",
    endLink: "End link",
    customerReadRequired:
      "Customer read permission is required to create a link.",
  },
  organizations: {
    panel: {
      tabs: {
        info: "Details",
        contacts: "Contacts",
      },
    },
    deleteConfirm: "Move organization {code} to the trash?",
    cooperationHistory: "Cooperation history",
    relatedProjects: "Related projects",
    cooperationProject: "Cooperation project",
    purchaseOrders: "PO",
    supplierMaterials: "Parts list",
    partner: "Partner",
    supplier: "Supplier",
    partnerTitle: "Partner directory",
    supplierTitle: "Supplier directory",
    shortName: "Short name",
    country: "Country",
    category: "Company category",
    region: "Region",
    taxCode: "Tax ID",
    legalRepresentative: "Legal representative",
    address: "Address",
    industry: "Industry",
    factoryCount: "Factory count",
    salesOwner: "Sales owner",
    purchasingOwner: "Purchasing owner",
    currency: "Currency",
    vatRate: "VAT (%)",
    bank: "Bank",
    account: "Account number",
    creditDays: "Credit days",
    paymentDay: "Recurring payment day",
    contacts: "Contacts",
    addContact: "Add person",
    contactName: "Full name",
    department: "Department",
    title: "Title",
    phone: "Phone",
    email: "Email",
    activate: "Activate",
    deactivate: "Deactivate",
    sections: {
      profile: "Company profile",
      commercial: "Commercial & financial",
      contacts: "Contacts",
    },
    placeholders: {
      region: "Ho Chi Minh City",
      taxCode: "0123456789",
      category: "Manufacturer",
      factoryCount: "1",
      owner: "Select owner",
      currency: "USD",
      vatRate: "10",
      bank: "Vietcombank",
      account: "0123456789012",
      creditDays: "30",
      paymentDay: "15",
      contactName: "Nguyen Van A",
      department: "Sales Department",
      title: "Sales Manager",
      phone: "0987654321",
      email: "contact{'@'}company.com",
    },
  },
  materials: {
    stockTabs: "Business inventory directory and transactions",
    directoryTab: "Material directory",
    title: "Business goods, materials and parts",
    deleteConfirm: "Move material {code} to the trash?",
    new: "New material / part",
    selectRow: "Select",
    selectMaterial: "Select material {code}",
    partName: "Product",
    model: "Model",
    version: "Rev No.",
    category: "Category",
    description: "Part Description",
    maker: "Maker name",
    unit: "Unit",
    moq: "MOQ",
    leadTime: "Lead time (days)",
    unitPrice: "Unit price",
    currency: "Currency unit",
    packageBag: "Qty / Bag",
    packageBox: "Qty / Box",
    supplier: "Supplier Name",
    purchasingOwner: "Purchasing owner",
    activate: "Activate",
    submitApproval: "Submit for approval",
    deactivate: "Deactivate",
    sections: {
      identity: "Identity specification",
      procurement: "Procurement pricing",
      packaging: "Packaging",
    },
    placeholders: {
      partName: "Steel Bolt M6",
      model: "SB-M6-2024",
      category: "Raw Material",
      maker: "ABC Manufacturing",
      unit: "PCS",
      description: "Short description of the material",
      version: "Rev. A",
      currency: "USD",
      supplier: "Select supplier",
      purchasingOwner: "Select purchasing owner",
      code: "MAT-00123",
    },
  },
  materialEnrollment: {
    configDraftTitle: 'Material registration draft',
    sourceUnavailable: '{source} could not be read. The list is incomplete; refresh to read this source again.',
    configFieldsHint: 'Save the registration details first, then submit the draft for approval.',
    note: 'Request note', lockedHint: 'This revision cannot be edited. Use the available owner actions and refresh its current state.',
    discardChanges: 'Discard the unsaved registration changes?',
    recoverWorkflow: 'Reconcile workflow', revise: 'Create draft revision',
    reviseConfirm: 'Create a draft revision after the previous workflow is verified as closed?',
    withdrawConfirm: 'Request withdrawal? The record stays submitted until Workflow confirms withdrawal.',
    deleteDraftConfirm: 'Delete this draft? Submitted workflow history cannot be deleted.',
    bindingStates: { StartPending: 'Workflow start is pending', StartInFlight: 'Workflow start is in progress', StartUnknown: 'Workflow start outcome is unknown; reconcile before another action',
      AwaitingRequester: 'The requester must reconcile with their current access', Bound: 'Workflow instance verified', WithdrawPending: 'Withdrawal is pending confirmation',
      WithdrawInFlight: 'Withdrawal confirmation is in progress', WithdrawUnknown: 'Withdrawal outcome is unknown; the record is not confirmed withdrawn',
      Withdrawn: 'Withdrawal confirmed', Blocked: 'Workflow reconciliation is blocked', unavailable: 'Workflow binding status is unavailable' },
    myRequests: "Create operational request",
    kind: "Type",
    updatedAt: "Updated",
    tabsLabel: "Material registration categories",
    pendingSection: "Awaiting approval",
    approvedSection: "Fully approved",
    pageTitle: "Business materials and parts: tracking & approval",
    assetPageTitle: "Asset tracking & approval",
    pageSubtitle:
      "Register purchases and receipts for business goods, materials and parts",
    scopeHint:
      "A dedicated view for material, asset and related stock records; use the Approval inbox for other workflows.",
    project: "Project",
    tabs: {
      material: "Business materials and parts",
      procurement: "Assets",
      mine: "My records",
    },
    returnConfirm: "Report this material as returned?",
    returnAction: "Return",
    quickPick: "Quick pick from the material catalog:",
    quickPickPlaceholder: "-- Choose an existing material --",
    columns: {
      code: "Request code",
      borrower: "Borrower",
      borrowDate: "Borrow date",
      expectedReturnDate: "Expected return date",
      quantity: "Borrowed quantity",
      returnedDate: "Returned date",
    },
    history: {
      returnRejected: "Return rejected",
      returnWorkflowStarted: "Awaiting return approval",
      returnFailed: "Return workflow failed",
      ReturnRequested: "Return requested",
      ReturnWorkflowStarted: "Awaiting return approval",
      ReturnSubmitted: "Return request submitted",
      ReturnRejected: "Return rejected",
      Returned: "Material returned",
    },
    assetSubtitle: "Borrow and return internal assets and track approvals.",
  },
  crmTrash: {
    title: "CRM data trash",
    help: "Trashed records are hidden from active directories while their related history remains intact.",
    moveTitle: "Move {code} to the trash",
    move: "Move to trash",
    moveHelp: "The record can be restored from the CRM trash screen.",
    reason: "Deletion reason",
    reasonPlaceholder: "Enter a reason for audit and review",
    previousStatus: "Previous status",
    deletedAt: "Deleted at",
    restore: "Restore",
    empty: "The trash is empty.",
    open: "Open trash",
    types: {
      customers: "Customers",
      partners: "Partners",
      suppliers: "Suppliers",
      materials: "Materials",
      products: "Products",
    },
  },
  documentTemplates: {
    categories: { quotation: "Quotations", contract: "Contracts", rfq: "Supplier RFQs", "purchase-order": "Supplier purchase orders" },
    name: "Template name",
    code: "Template code",
    codeHint: "e.g. HD-NMI (same code = new version)",
    version: "Version",
    layout: "Layout",
    affiliation: "Legal entity",
    allAffiliations: "All entities",
    default: "Default",
    activatedAt: "Effective",
    format: "Format",
    notes: "Notes",
    system: "System template",
    systemHint: "System templates are read-only. Download, edit and upload it as your company template.",
    statuses: { Draft: "Draft", Active: "Active", Retired: "Retired" },
    upload: "Upload template",
    uploadFromSystem: "Upload an edited copy",
    newVersion: "Upload new version",
    file: "Template file (.{extension}, max 5 MB)",
    saveDraft: "Save as draft",
    uploaded: "Version v{version} uploaded as draft. Check it with Preview, then Activate.",
    saved: "Template details saved.",
    download: "Download",
    preview: "Preview",
    previewPdf: "Preview PDF",
    activate: "Activate",
    activated: "Activated. Older versions of this code are now retired.",
    makeDefault: "Set as default",
    defaultSet: "Set as the default template.",
    retire: "Retire",
    retireConfirm: "Retire this template? Later exports will use another default template.",
    retired: "Template retired.",
    info: "Details",
    versions: "Versions",
    fields: "Data fields",
    fieldsHint: "Click a field to copy it, then paste it into an Excel cell or a Word paragraph. Fields starting with lines. go on the line-item template row.",
    field: "Field",
    meaning: "Meaning",
    sample: "Example",
    copy: "Copy field",
    copied: "Copied {key}",
    lineField: "line item",
    guide: "Guide",
    guideSteps: {
      download: "Download the template in use (Download).",
      edit: "Edit layout, logo, text and terms in the .{extension} file. Insert data fields such as {example} where values go.",
      linesExcel: "Line table: put the lines. fields on one template row, e.g. {example}. The row is repeated per line item; row formulas and totals below grow automatically.",
      linesWord: "Line table: put the lines. fields in one Word table row, e.g. {example}. That row is repeated per line item.",
      upload: "Upload the file: unknown or missing fields are reported before it is saved as a draft.",
      activate: "Preview with sample data, Activate, then Set as default for the legal entity.",
    },
    validationOk: "Template is valid · {count} data fields.",
    validationFailed: "The template is not valid yet. Fix these issues and upload again:",
    quotationRows: "Quotation template: the row holding {leaf} is the item template row, {group} the group row (1), {child} the child row (1.1); the row holding {footer} starts the totals. Pricing formulas are written by the system per field column; layout, text, logo and field positions are yours to change.",
  },
  quotations: {
    new: "New quotation",
    issue: "Issue quotation",
    notFoundInList: "The quotation is not in the list; filter by its project.",
    pickProjectToImport: "Choose a project in the filter to import a Form file.",
    unsaved: "Unsaved changes",
    discard: "Discard changes",
    importForm: {
      button: "Import from Form file",
      title: "Import a quotation from a Form1/Form2/Form3 file",
      chooseFile: "Choose an .xlsx file (max 5 MB)",
      preview: "Preview",
      commit: "Create draft revision",
      detected: "Detected: {form} · legal entity {affiliation}",
      targetNew: "Will create a new quotation {number} rev {revision}",
      targetRevision: "Will create draft revision {number} rev {revision}; existing revisions stay unchanged",
      number: "Quote number / Rev",
      date: "Date",
      customer: "Customer",
      pic: "Contact",
      endUser: "End user",
      rate: "VND/USD rate",
      discount: "Discount",
      validity: "Validity (days)",
      total: "Subtotal (A)",
      grandTotal: "Grand total",
      rowRef: "Row {row}",
      errors: "Blocking errors ({count})",
      warnings: "Warnings ({count})",
      noIssues: "No warnings; Excel figures match the system.",
      columns: {
        row: "Excel row",
        no: "No.",
        description: "Description",
        quantity: "Qty",
        unit: "Unit",
        excelPrice: "Excel unit price",
        systemPrice: "System unit price",
        subtotal: "Subtotal",
        difference: "Difference",
      },
      file: {
        required: "Choose an .xlsx file.",
        type: "Only .xlsx files are accepted.",
        size: "The file exceeds 5 MB.",
      },
      issues: {
        ref_error: "#REF! cell",
        excel_engine_mismatch: "Excel vs system differs by more than 1 VND",
        excel_total_mismatch: "Grand total differs from the original form (Q10)",
        missing_exchange_rate: "Missing exchange rate",
        missing_quantity: "Line without quantity",
        quote_number_differs: "File quote number differs from the system",
        import_without_cost: "No permission to read costs",
        affiliation_unknown: "Legal entity not recognised",
        line_description_missing: "Line without description",
        line_number_missing: "Line without number",
        orphan_child_line: "Child line without parent",
        line_invalid: "Invalid line",
        line_price_missing: "Line without unit price",
        unknown_quotation_form: "Form not recognised",
        quote_sheet_missing: "QUOTE sheet missing",
        quote_footer_missing: "Subtotal (A) row missing",
        invalid_workbook: "Unreadable file",
        quotation_import_empty: "No quotation line",
        quotation_import_too_many_lines: "More than 200 lines",
        quotation_import_invalid: "Invalid quotation data",
      },
    },
    quantity: "Quantity",
    unitOfMeasure: "Unit",
    unitSellingPrice: "Selling unit price",
    calculatedPrice: "From costs and markup",
    saveForPrice: "Save to update price",
    discountPercent: "Discount (%)",
    vatPercent: "VAT (%)",
    addProduct: "Add catalog product",
    sourceRevision: "Source revision",
    sourceCurrencyMismatch:
      "The revision must have an input price in the quotation currency.",
    commercialOutcome: "Commercial outcome",
    outcomes: {
      None: "Not sent",
      Sent: "Sent",
      Accepted: "Accepted",
      Rejected: "Rejected",
      Expired: "Expired",
    },

    title: "Project quotations",
    project: "Project",
    number: "Project ID",
    revision: "Revision",
    currency: "Currency",
    installationMandays: "Installation mandays",
    travelMode: "Travel mode",
    travelerCount: "Traveler count",
    content: "Quotation lines",
    addLine: "Add line",
    history: "Quotation history",
    classification: "Classification",
    costBreakdown: "Cost breakdown",
    totalCost: "Total cost",
    totalPrice: "Output price",
    inputPrice: "Input price",
    customsCost: "Customs cost",
    transportCost: "Transport cost",
    packagingCost: "Packaging cost",
    managementCost: "Management cost",
    surveyCost: "Survey cost",
    solutionReportCost: "Solution report cost",
    demoCost: "Demo cost",
    travelCost: "Travel cost",
    hotelCost: "Hotel cost",
    mealCost: "Meal cost",
    movementCost: "Movement cost",
    overtimeCost: "Overtime cost",
    personnelCost: "Personnel cost",
    installationCost: "Installation & training cost",
    maintenanceCost: "Maintenance cost",
    commissionCost: "Commission cost",
    commissionTax: "Commission tax",
    profitPercent: "Profit percent",
    exportTemplate: "Export template",
    exportAudience: "Audience",
    audienceCustomer: "Customer",
    audienceInternal: "Internal",
    exportExcel: "Export Excel",
    exportPdf: "Export PDF",
    exportCsv: "Export CSV",
    exportFailed: "The quotation file could not be exported.",
    deliveryTerms: "Delivery terms",
    paymentTerms: "Payment terms",
    warrantyTerms: "Warranty terms",
    validUntil: "Valid until",
    cloneRevision: "Clone revision",
    pricingModel: "Pricing model",
    pricingModels: {
      Legacy: "Legacy: markup on cost (OP1–OP3)",
      NmiSheet: "NMI form: margin on selling price",
    },
    template: "Form",
    forms: {
      Form1: "OP1 · Projects/services",
      Form2: "OP3 · Goods",
      Form3: "NMIT · Solutions",
      OP1: "Cost-based layout 1 (legacy)",
      OP2: "Cost-based layout 2 (legacy)",
      OP3: "Cost-based layout 3 (legacy)",
    },
    formLayouts: {
      Form1: "NMI company · groups 1 → 1.1",
      Form2: "NMI company · flat list",
      Form3: "NMIT company · groups 1 → 1.1",
    },
    formDescriptions: {
      Form1: "Projects/services: groups 1, 1.1…; a group line sums its children; includes the \"Scope exclusions\" block.",
      Form2: "Goods sales: flat list 1, 2, 3…; existing group lines are kept and printed as summing rows.",
      Form3: "Solutions (software + devices): groups 1, 1.1…; NMIT company header.",
      OP1: "Legacy export for cost-based quotations.",
      OP2: "Legacy export with a code column.",
      OP3: "Legacy export with a classification column.",
    },
    sheet: {
      internalColumns: "Pricing columns",
      addGroup: "Add group",
      addChild: "Add child line",
      indent: "Move into the group above",
      outdent: "Move out of the group",
      moveUp: "Move up",
      moveDown: "Move down",
      applyToGroup: "Apply pricing to the whole group",
      applyToAll: "Apply pricing to top-level lines",
      pricingApplied: "Pricing inputs copied to {count} line(s).",
      removeGroup: "Delete group and child lines",
      flatWithGroups: "OP3 is a flat list: existing groups are kept and printed as summing rows.",
      bandQuote: "I. Quote",
      bandInput: "Input",
      bandOutput: "Output Price",
      no: "No.",
      description: "Part description",
      unitPrice: "Unit price ({currency})",
      subtotal: "Subtotal ({currency})",
      fromManday: "= manday × days",
      usdTimesRate: "= USD × quotation exchange rate",
      subtotalA: "Subtotal (A)",
      addProductGroup: "Add as a component group",
      productComponents: "Creates 1 group line and {count} child lines from the product components.",
      productSingle: "The product has no components: adds one line with the revision input price.",
    },
    nmi: {
      header: "Form details",
      pricing: "Internal pricing",
      summary: "Summary by group",
      affiliation: "Affiliation",
      exchangeRate: "VND/USD rate",
      corporateTaxPercent: "Corporate income tax (%)",
      validityDays: "Validity (days)",
      discountPercent: "Header discount (%)",
      customerPic: "Contact person (PIC)",
      customerEmail: "Contact email",
      customerPhone: "Contact phone",
      endUser: "End user (EU)",
      endUserPlaceholder: "Pick a customer from the directory (type a code or name)",
      scopeExclusions: "Scope exclusions",
      detailText: "II. Detail (not invoiced)",
      signPlace: "Place of signing",
      signDate: "Signing date",
      parentLine: "Group",
      topLevel: "— Top-level item —",
      groupLine: "Group line: unit price is the sum of its child subtotals.",
      maker: "Maker",
      leadtime: "Lead time",
      mandayUnitPrice: "Manday unit price (VND)",
      mandayUnitPriceUsd: "Manday unit price (USD)",
      mandayQuantity: "Mandays",
      inputNetPriceVnd: "Input NET price (VND)",
      inputNetHint: "Leave empty to use manday unit price × mandays.",
      fobPercent: "FOB (%)",
      importTaxPercent: "Import tax (%)",
      cifPercent: "CIF (%)",
      swiftFeeUsd: "SWIFT fee (USD)",
      marginPercent: "Margin on selling price (%)",
      endUserCommissionPercent: "End-user commission (%)",
      endUserTaxPercent: "EU tax on commission (%)",
      inPriceVatPercent: "VAT in price (%)",
      contingencyPercent: "Contingency (%)",
      acquisitionVnd: "Acquisition cost (VND)",
      unitPrice: "Unit price (6)",
      salesPrice: "Sales price (11)",
      customerUnitPrice: "Customer unit price",
      subtotal: "Subtotal",
      vatAmount: "VAT",
      grossProfit: "Gross profit",
      corporateTax: "Corporate tax",
      netProfit: "Net profit",
      total: "Total",
      discount: "Discount",
      amount: "After discount",
      vat: "VAT (after discount)",
      grandTotal: "Grand total",
      acquisitionTotal: "Total acquisition cost",
      group: "Group",
      description: "Description",
      share: "Share",
    },
    sections: {
      overview: "Quotation overview",
      materials: "Materials & logistics",
      services: "Services & labor",
      delivery: "Delivery & commercial",
    },
  },
  account: {
    profileSection: "Account settings",
    passwordSection: "Change password",
    profileHint:
      "You own your full name, user name and email. Employee code, department, position and roles are synced from the HR profile.",
    fullName: "Full name",
    userName: "User name",
    email: "Email",
    accountState: "Account state",
    employeeCode: "Employee code",
    department: "Department",
    position: "Position",
    employmentStatus: "Employment status",
    roles: "Roles",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Repeat new password",
    changePassword: "Change password",
    passwordHint:
      "The new password needs at least {min} characters. Changing it revokes every session, so you have to sign in again.",
    passwordTooShort: "The new password needs at least {min} characters.",
    passwordMismatch: "The two new passwords do not match.",
    passwordReused: "The new password must differ from the current one.",
    currentPasswordWrong: "The current password is not correct.",
    duplicate: "That user name or email is already taken.",
    validationFailed: "Some of the values are not valid.",
    profileSaved: "Account settings updated.",
    passwordChanged: "Password changed. Please sign in again.",
    loadFailed: "Could not load the account.",
    saveFailed: "Could not save the account.",
    passwordFailed: "Could not change the password.",
    profileInvalidBeforePassword:
      "Complete your full name, user name and email before changing the password.",
    pendingProfileNotice:
      "Your unsaved account settings are saved before the password changes.",
    profileAndPasswordChanged:
      "Account settings saved and password changed. Please sign in again.",
    unsavedConfirm: "Unsaved account settings will be lost. Leave this page?",
    changeAvatar: "Change avatar",
    chooseImage: "Choose image",
    chooseAnotherImage: "Choose another image",
    notificationSection: "Notification settings",
    channelWebTitle: "Web & Desktop notifications",
    channelWebDesc: "Receive instant bell notifications on CRM and push alerts on your desktop screen.",
    channelEmailTitle: "Email notifications",
    channelEmailDesc: "Deliver work updates and approval requests to",
    emailSyncActive: "Email linked",
    testNotification: "Test alert",
    testNotificationBody: "This is a test notification from Q ONE CRM PM.",
    testNotificationSent: "Test notification sent to your screen.",
    tabProfile: "Profile",
    tabSecurity: "Security",
    tabNotifications: "Notifications",
    tabConnections: "Connected apps",
    personalInfo: "Personal information",
    employmentInfo: "Employment information",
    employmentHint: "Synced from the HR profile; contact HR/Admin to change it.",
    readOnly: "Read only",
    uploadAvatar: "Upload photo",
    avatarHint: "Square image, at least 256×256 px. Saved when you click Save.",
    unsavedBar: "You have unsaved changes.",
    discard: "Discard changes",
    notificationHint: "Choose how you are notified about tasks, approvals and project updates.",
    showPassword: "Show passwords",
    hidePassword: "Hide passwords",
    passwordRequirements: "Password requirements",
    reqLength: "At least {min} characters",
    reqMixedCase: "Upper- and lowercase letters",
    reqDigit: "A number",
    reqSymbol: "A special character",
    reqDifferent: "Different from the current password",
    reqMatch: "Both new passwords match",
    strengthLabel: "Strength",
    strength: {
      weak: "Weak",
      fair: "Fair",
      good: "Good",
      strong: "Strong",
    },
    sessionNotice: "Changing your password signs you out on every device.",
    connectionsTitle: "Linked calendars",
    connectionsHint: "Connect Google Calendar or Microsoft 365 to sync events both ways and create Meet/Teams links.",
    openCalendar: "Open Calendar",
    providers: {
      google: "Google Calendar",
      microsoft: "Microsoft 365 / Outlook",
    },
    providerUnavailable: "Not configured by the administrator",
    notConnected: "No account connected yet.",
    lastSync: "Last synced: {at}",
    connect: "Connect",
    connectAnother: "Add account",
    disconnect: "Disconnect",
    disconnectConfirm: "Disconnect {account}? Events already synced to the external calendar are kept.",
  },
  notificationEmail: {
    title: "Email notifications",
    hint: "Every notification is also sent by email (with a button that opens the record). You can turn this off entirely or per type.",
    all: "Email me my notifications",
    type: "Notification type",
    inApp: "Notify me",
    email: "Email",
    received: "Received (180 days)",
    empty: "You have not received any notifications yet; types appear here once you do.",
    cadence: "Email cadence",
    cadenceHint: "Send each email immediately, or combine them into an hourly/daily digest. Calendar invitations are always sent immediately.",
    cadenceDefault: "System default ({value})",
    cadenceImmediate: "Send immediately",
    cadenceHourly: "Hourly digest",
    cadenceDaily: "Daily digest",
    types: {
      CalendarInvitation: "Event invitation",
      CalendarEventUpdated: "Event changed",
      CalendarEventCancelled: "Event cancelled",
      CalendarResponse: "Guest replied",
      CalendarReminder: "Calendar reminder",
      CalendarTaskDue: "Task due",
      CalendarShared: "Calendar shared with you",
      BusinessDeadline: "Business deadline",
      CustomerFollowUpDue: "Customer follow-up due",
      CustomerFollowUpOverdue: "Customer follow-up overdue",
      WorkflowStepAssigned: "New approval task",
      WorkflowTaskOverdue: "Approval task overdue",
      WorkflowTaskEscalated: "Approval task escalated",
    },
  },
  calendar: {
    mine: "{name} (me)",
    someone: "Someone else",
    eventsError: "Calendar events could not be loaded. Reload the page; if it keeps failing, tell your administrator.",
    ownedBy: "{name} (owned by {owner})",
    primaryOf: "{name}'s calendar",
    changeColor: "Change colour",
    title: "Calendar",
    tabs: {
      calendar: "Calendar",
      yearSettings: "Yearly calendar setup",
    },
    today: "Today",
    prev: "Previous",
    next: "Next",
    create: "Create",
    createEvent: "Event",
    createTask: "Task",
    views: {
      day: "Day",
      week: "Week",
      month: "Month",
      year: "Year",
      schedule: "Schedule",
      "4days": "4 days",
    },
    searchPlaceholder: "Search events",
    searchEmpty: "No events found",
    toggleSidebar: "Show/hide calendar menu",
    options: "Options",
    myCalendars: "My calendars",
    otherCalendars: "Other calendars",
    otherHint: "Type a colleague's name in “Meet with...” to see their free/busy calendar.",
    systemLayers: "System data",
    meetWith: "Meet with...",
    newCalendar: "Create new calendar",
    calendarSettings: "Settings and sharing",
    calendarName: "Calendar name",
    calendarDescription: "Description",
    color: "Colour",
    share: "Share",
    shareWith: "Share with specific people",
    chooseUser: "Choose a person",
    exportIcs: "Export .ics file",
    deleteCalendar: "Delete calendar",
    deleteCalendarConfirm: "Delete calendar “{name}”? Its events will no longer be shown.",
    removeOther: "Remove from list",
    onlyThis: "Display this only",
    openSource: "Open source page",
    access: {
      None: "Stop sharing",
      FreeBusy: "See only free/busy",
      ReadDetails: "See all event details",
      Edit: "Make changes to events",
      Manage: "Make changes and manage sharing",
      Owner: "Owner",
    },
    layers: {
      holidays: "Holidays / company days off",
      leave: "Leave",
      trip: "Business trips",
      onsite: "Onsite",
      overtime: "Overtime",
      vehicle: "Company vehicles",
      wbs: "WBS tasks",
      warranty: "Warranty tickets",
      followUp: "Customer follow-ups",
      approvals: "Waiting for my approval",
      deadlines: "Business deadlines",
      tasks: "Personal tasks",
    },
    dayTypes: {
      HOLIDAY: "Public holiday",
      OFF: "Company day off",
    },
    busyKind: {
      event: "Event",
      leave: "Leave",
      trip: "Business trip",
      onsite: "Onsite",
    },
    pending: "pending",
    busy: "Busy",
    noTitle: "(No title)",
    allDay: "All day",
    noEvents: "No events",
    layerError: "Some system data could not be loaded right now; the rest of the calendar is still shown.",
    event: {
      addMeet: "Add Google Meet",
      addTeams: "Add Microsoft Teams",
      meetPending: "A Google Meet link will be created when you save.",
      teamsPending: "A Microsoft Teams link will be created when you save.",
      new: "New event",
      edit: "Edit event",
      titlePlaceholder: "Add title",
      save: "Save",
      moreOptions: "More options",
      details: "Event details",
      findTime: "Find a time",
      findTimeHint: "Grey blocks are busy time; click an hour to pick it.",
      location: "Add location",
      meetingUrl: "Paste meeting link (Teams, Zoom, Meet...)",
      description: "Add description",
      busy: "Busy",
      free: "Free",
      visibilityDefault: "Default visibility",
      visibilityPublic: "Public",
      visibilityPrivate: "Private",
      calendarColor: "Calendar colour",
      reminderNotification: "Notification",
      reminderEmail: "Email",
      minutes: "minutes",
      hours: "hours",
      days: "days",
      weeks: "weeks",
      before: "before",
      addReminder: "Add notification",
      removeReminder: "Remove notification",
      reminderShort: "{n} minutes before",
      guests: "Guests",
      addGuests: "Add guests (name or email)",
      inviteEmail: "Invite {email}",
      organizer: "Organiser",
      optional: "Optional",
      markOptional: "Mark optional",
      removeGuest: "Remove guest",
      autoDeclined: "Declined automatically (on leave)",
      guestPermissions: "Guest permissions",
      canModify: "Modify event",
      canInvite: "Invite others",
      canSeeGuests: "See guest list",
      me: "Me",
      invalidRange: "The end must be after the start.",
      delete: "Delete event",
      duplicate: "Duplicate",
      joinMeeting: "Join meeting",
      copyLink: "Copy link",
      copied: "Copied",
      guestSummary: "{n} guests · {yes} yes, {no} no, {pending} awaiting",
      going: "Going?",
      saved: "Event saved",
      moved: "Event updated",
      deleted: "Event deleted",
      undo: "Undo",
    },
    rsvp: {
      Accepted: "Yes",
      Declined: "No",
      Tentative: "Maybe",
    },
    response: {
      NeedsAction: "Awaiting",
      Accepted: "Accepted",
      Declined: "Declined",
      Tentative: "Maybe",
    },
    recurrence: {
      none: "Does not repeat",
      daily: "Daily",
      weekly: "Weekly on {day}",
      monthlyNth: "Monthly on {day} of week {n}",
      monthlyLast: "Monthly on the last {day}",
      yearly: "Annually on {date}",
      weekdays: "Every weekday (Monday to Friday)",
      custom: "Custom...",
      repeatEvery: "Repeat every",
      ends: "Ends",
      never: "Never",
      onDate: "On",
      after: "After",
      occurrences: "occurrences",
      monthlyOnDay: "Monthly on day {day}",
      every: "Every {n} {unit}",
      on: "on {days}",
      onDay: "on day {day}",
      times: "{n} times",
      until: "until {date}",
      nthWeekday: "{day} of week {n}",
      lastWeekday: "the last {day}",
      base: {
        DAILY: "Daily",
        WEEKLY: "Weekly",
        MONTHLY: "Monthly",
        YEARLY: "Annually",
      },
      unit: {
        DAILY: "days",
        WEEKLY: "weeks",
        MONTHLY: "months",
        YEARLY: "years",
      },
      unitName: {
        DAILY: "day",
        WEEKLY: "week",
        MONTHLY: "month",
        YEARLY: "year",
      },
    },
    scope: {
      title: {
        edit: "Edit recurring event",
        move: "Reschedule recurring event",
        delete: "Delete recurring event",
        create: "Recurring event",
      },
      This: "This event",
      Following: "This and following events",
      All: "All events",
      notifyTitle: "Notify guests?",
      notifyGuests: "Send update notifications to guests",
      ok: "OK",
    },
    days: {
      SU: "Sunday",
      MO: "Monday",
      TU: "Tuesday",
      WE: "Wednesday",
      TH: "Thursday",
      FR: "Friday",
      SA: "Saturday",
    },
    daysShort: {
      SU: "Sun",
      MO: "Mon",
      TU: "Tue",
      WE: "Wed",
      TH: "Thu",
      FR: "Fri",
      SA: "Sat",
    },
    todo: {
      title: "To-do",
      addPlaceholder: "Add a task (Enter)",
      empty: "Nothing to do",
      filter: "Filter by source",
      filterAll: "All sources",
      showCompleted: "Show completed",
      noDue: "No due date",
      today: "Today",
      tomorrow: "Tomorrow",
      notes: "Notes",
      deleteTask: "Delete task",
      deleted: "Task deleted",
      completed: "Mark complete",
      markDone: "Mark complete",
      reopen: "Mark incomplete",
      overdueCount: "{n} overdue",
      sources: {
        task: "Personal task",
        wbs: "WBS",
        warranty: "Warranty",
        approval: "Approval",
        followUp: "Customer follow-up",
        deadline: "Deadline",
      },
    },
    settings: {
      title: "Calendar settings",
      general: "General",
      defaultView: "Default view",
      weekStartsOn: "Week starts on",
      defaultDuration: "Default event duration (minutes)",
      defaultReminders: "Default notifications (minutes before, comma separated)",
      hideWeekends: "Hide weekends",
      showWeekNumbers: "Show week numbers",
      showLunarDates: "Show lunar dates",
      showDeclinedEvents: "Show declined events",
      showPendingRequests: "Show requests awaiting approval",
      autoDeclineDuringLeave: "Automatically decline invitations during approved leave",
      shortcuts: "Keyboard shortcuts",
      shortcutList: "C create event · T today · D day · W week · M month · Y year · A schedule · X 4 days · J/N next · K/P previous · / search · Esc close",
    },
    external: {
      title: "Google / Outlook calendars",
      hint: "Connect a Google account to see all your calendars (including shared ones) inside the CRM.",
      filter: "Calendar source",
      source: { all: "All", crm: "CRM", external: "External" },
      syncedIntoCrm: "The sync account's primary calendar already syncs both ways into the CRM calendar.",
      readOnly: "Read-only: edit this event in Google.",
      openInGoogle: "Open in Google",
    },
    connections: {
      addAccount: "Add account",
      writeTarget: "CRM sync",
      writeTargetHint: "CRM events sync both ways with this account's primary calendar.",
      setWriteTarget: "Use for CRM sync",
      calendarsCount: "{n} calendars",
      title: "Connections",
      hint: "Connect a Google or Outlook account to sync both ways with your primary QOne calendar (every 5 minutes) and to create Google Meet / Microsoft Teams links. Leave, trips, WBS… are not exported.",
      Google: "Google Calendar",
      Microsoft: "Outlook / Microsoft 365",
      notConfigured: "Your administrator has not configured this connection.",
      notConnected: "Not connected",
      lastSync: "last synced",
      syncNow: "Sync now",
      connect: "Connect",
      reconnect: "Reconnect",
      disconnect: "Disconnect",
      status: {
        Active: "Active",
        Error: "Sync error",
        Revoked: "Needs reconnecting",
      },
      result: {
        connected: "Calendar account connected.",
        cancelled: "You cancelled the connection.",
        failed: "The connection failed; please try again.",
      },
    },
    trash: {
      title: "Trash",
      hint: "Deleted events are kept for 30 days.",
      empty: "Trash is empty",
      restore: "Restore",
      purge: "Delete forever",
      deletedAt: "deleted at",
    },
  },
  workCalendar: {
    title: "Work calendar & capacity",
    employee: "Employee",
    minutes: "available minutes",
    saved: "Work calendar saved.",
    year: "Year",
    calendar: "Calendar",
    selectionHelp:
      "Select one or multiple days, then apply available capacity (minutes):",
    selectedCount: "{count} days selected",
    applySelected: "Apply",
    companyMode: "Company Calendar",
    individualMode: "Individual Calendar",
    companyBadge: "Company Calendar",
    readOnlyNotice: "You are viewing in read-only mode. Only admins can edit.",
    nextYearPlanning:
      "Includes the first {count} months of {year} for cross-year planning.",
    nextYearLocked:
      "The {year} calendar is already approved, so next-year months are read-only.",
    batchSaveSuccess: "Company calendar saved successfully",
    working: "Working day",
    weekend: "Weekend",
    holiday: "Holiday",
    off: "Unpaid leave",
    clearSelection: "Clear selection",
    setWeekendOff: "Set Sat/Sun = 0",
    resetDefault: "Reset 480 mins (8h)",
    unsavedChanges: "You have unsaved changes. Are you sure you want to leave?",
    unsaved: "Unsaved",
    loadFailed: "Failed to load work calendar.",
    saveFailed: "Failed to save work calendar.",
    totalDays: "Total days",
    totalWorkingDays: "Working days",
    totalHours: "Total hours",
    capacityFull: "Full (480 mins / 8h)",
    capacityOff: "Off (0 mins)",
    capacityCustom: "Custom",
    bulkMinutes: "Minutes",
    documentNumber: "Document No.",
    revision: "Rev No.",
    headerSaved: "Annual calendar control header saved.",
    headerAudit: "Annual calendar approval audit",
    revisionHistory: "Revision history ({count})",
    reviewOnly:
      "You are reviewing the annual calendar control header; day data requires Capacity.Read.",
    audit: {
      submitted: "Submitted",
      confirmed: "Confirmed",
      approved: "Approved",
    },
    weekdays: {
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
    },
    customized: "Customized",
    minutesLabel: "Minutes:",
    syncCompanyCalendar: "Sync company calendar",
  },
  costing: {
    newProfile: "New cost profile",
    title: "Base cost & manday rate",
    effectiveFrom: "Effective from",
    staffCount: "Company staff count",
    workingDays: "Working days / month",
    costPerManday: "Cost per manday",
    formulaHelp:
      "Calculated from staff, benefits, company overhead and daily travel costs.",
    history: "Configuration history",
    saved: "Saved. Cost per manday: {value}",
    averageMonthlySalary: "Average monthly salary",
    driverAllowanceMonthly: "Driver allowance / month",
    socialInsuranceMonthly: "Social insurance / month",
    mealCostPerDay: "Shift meal / day",
    annualTravelCost: "Annual travel benefit",
    annualUniformCost: "Annual uniform cost",
    monthlyOfficeSupplies: "Office supplies / month",
    annualThirteenthMonthBonus: "13th-month bonus / year",
    annualCondolenceAllowance: "Condolence allowance / year",
    annualQuarterlyPartyCost: "Quarterly party cost / year",
    monthlyUtilities: "Utilities / month",
    annualEquipmentCost: "Equipment / year",
    annualPerformanceBonus: "Performance bonus / year",
    annualHealthCheckCost: "Employee health check / year",
    dailyTravelAllowance: "Travel allowance / day",
    dailyHotelCost: "Hotel cost / day",
    dailyMealAllowance: "Meal allowance / day",
    dailyMovementCost: "Movement cost / day",
    sections: {
      basis: "Calculation basis",
      people: "People costs",
      annual: "Annual & overhead costs",
      travel: "Daily travel costs",
    },
  },
  projectRegistration: {
    projectGroup: "Project",
    technicalGroup: "Technical Information",
    technicalInformation: "Project technical information",
    setupProject: "Setup Project",
    setupChoiceLabel: "Choose Setup Project content",
    sales: "Sales",
    pi: "PI",
    salesDetail: "Detail Project By Sales",
    piDetail: "Detail Project By PI",
    projectId: "Project ID",
    projectContent: "Project content",
    endUser: "Customer (End User)",
    summaryChoiceLabel: "Choose Project Summary status",
    all: "All",
    cancelled: "Cancelled",
    registration: "New",
    executing: "Executing",
    finished: "Completed",
    lifecycleStatus: "Lifecycle status",
    pendingApproval: "Pending approval",
    finishedPendingClose: "Completed · Pending close",
    finishedWithCancelled: "Completed with cancelled work · Pending close",
    closed: "Closed",
    closedWithCancelled: "Closed · Contains cancelled work",
    progressCompleteWithPendingWbs:
      "100% stages · Work items remain incomplete",
    pendingList: "Project Summary list pending approval",
    approvedList: "Project Summary list approved",
    addProject: "Add Project",
    selectRow: "Select",
    selectProject: "Select Project {code}",
    tabRegistration: "General information",
    overviewProject: "Project",
    overviewCustomer: "Customer & contacts",
    overviewBusiness: "Scope & sales",
    overviewAudit: "Audit",
    tabDocuments: "Documents",
  },
  piRegistration: {
    unassigned: "No leader",
    related: "Related projects",
    claimProject: "Claim project",
    claimSaved: "Project claimed.",
    saveLeader: "Save leader",
    salesInformation: "Sales information (read only)",
    selectProject: "Select a project from the registration inbox.",
    dynamicPicCount: "{count} PIC from WBS & Gantt",
    noWbsPic: "No PIC has been assigned from WBS & Gantt.",
    leaderAssignedBy: "Leader assigned by",
    leaderAssignedAt: "Leader assigned at",
    leaderSaved: "Project leader saved.",
    concurrency:
      "The leader assignment was changed by another request. Refresh and try again.",
    loadFailed: "Could not load the project registration inbox.",
    salesAssignmentInvalid:
      "At least one Sales member is required; the project leader is assigned from the PI view.",
  },
  projectWorkbook: {
    number: "No.",
    projectId: "Project ID",
    projectRevision: "Project ID Rev",
    receiptDate: "Receipt date",
    projectModel: "Project model",
    endUser: "Customer (End User)",
    customerShortName: "Customer short name",
    partnerName: "Partner name",
    projectContent: "Project content",
    shortProjectContent: "Short project content",
    projectName: "Project name",
    similarProject: "Similar project",
    attachedDocument: "Attached document",
    contactPerson: "Contact person",
    phoneNo: "Phone No",
    email: "Email",
    attachedSurvey: "Attached survey",
    feasibility: "Project feasibility",
    potential: "Project potential",
    competition: "Competition assessment",
    competitor: "Competitor (if any)",
    salesSubmittedAt: "Sales submitted date",
    salesCreatedBy: "Created by Sales",
    createdDate: "Created date",
    surveyDate: "Survey date (※1)",
    solutionTarget: "Solution target from (※1)",
    demoTarget: "Demo target from (※1)",
    quotationTarget: "Quotation target from (※1)",
    solutionProposalDate: "Solution proposal date",
    demoDate: "Demo date",
    quotationDate: "Quotation date",
    purchaseOrderDate: "Purchase order date",
    goLiveDate: "Go-live date",
    projectLeader: "Project leader",
    pic: "PIC",
    piSubmittedAt: "PI submitted date",
    piCreatedBy: "Created by PI",
    confirmBy: "Confirmed by",
    confirmDate: "Confirmed date",
    approvedBy: "Approved by",
    approvedDate: "Approved date",
  },
  projectDocumentNaming: {
    typesLoadFailed:
      "Could not load document types. Try again to choose a type and upload a file.",
    documentsLoadFailed: "Could not load project documents. Try again.",
    documentType: "Document type",
    maxFileSize: "Maximum file size per upload: 1 GiB.",
    uploadProgress: "Uploading: {percent}%",
    processingProgress: "Processing document: {percent}%",
    uploadCancel: "Cancel upload",
    uploadCancelled: "Upload cancelled; the Project was kept unchanged.",
    uploadFailed: "The document could not be uploaded. Try again.",
    noType: "Choose a document type first.",
    noFile: "Choose a file first.",
    invalidPrefix: "The filename is invalid. Expected prefix: {prefix}",
    duplicateConfirm:
      "A file with the same basename already exists. Replace the current file?",
    replacementSaved: "The current document was replaced.",
    filesystemNote:
      "Valid filenames are preserved; path separators are rejected and names are never silently rewritten.",
    standardGroupFolder: "Rev01 group (e.g. 02_KHAO_SAT_DE_XUAT)",
    standardTypeFolder: "Rev01 type (e.g. 01_BAO_CAO_KHAO_SAT)",
    standardCode: "Rev01 code (e.g. BCKS)",
    remoteSync: {
      Pending: "Waiting to sync to Q One Document",
      Synced: "Available in Q One Document",
      Failed: "Q One Document sync failed",
      Skipped: "Not synced to Q One Document",
      PendingDelete: "Waiting to remove from Q One Document",
      Deleted: "Removed from Q One Document",
      DeleteFailed: "Removing from Q One Document failed",
    },
    openInQOneDocument: "Open in Q One Document",
    typePlaceholder: "Choose a document type…",
    fileNamePreview: "File name",
    copyPrefix: "Copy prefix",
    prefixCopied: "Copied prefix {prefix}",
    uploadFile: "Upload file",
    dropHint: "Drop the file to upload",
    catalog: "Type catalog",
    catalogTitle: "Document type catalog",
    catalogSearch: "Search by code, name, folder…",
    catalogCount: "{count} types",
    catalogEmpty: "No matching document types.",
    addType: "Add document type",
    unmappedGroup: "Not mapped to Rev01 (legacy)",
    rev01Group00: "Project management",
    rev01Group01: "Customer & contracts",
    rev01Group02: "Survey & proposal",
    rev01Group03: "Technical design",
    rev01Group04: "Purchasing - suppliers - subcontractors",
    rev01Group05: "Deployment & logistics",
    rev01Group06: "QA/QC & testing",
    rev01Group07: "Changes & issue handling",
    rev01Group08: "Handover & acceptance",
    rev01Group09: "Commercial & finance",
    rev01Badge: "Rev01 standard",
    legacyBadge: "Legacy",
    exemptBadge: "Not required",
    ruleRev01: "Start with {prefix}_ followed by the subject in plain uppercase words joined by _. Revision and status are managed by Q One Document and are optional.",
    ruleLegacy: "This type is not mapped to the Rev01 standard yet, so the legacy pattern applies: the file name starts with {prefix}-.",
    ruleExempt: "This document type has no naming requirement; the original file name is kept.",
    ruleNone: "Choose a document type to see the NMI Rev01 file name: <PROJECT>_<DOCTYPE>_<SUBJECT>_<REV>_<STATUS>.",
    saveTo: "Saved to",
    segmentFixed: "Required, exactly as shown",
    segmentFree: "Your text: plain uppercase words joined by _",
    segmentOptional: "Optional, managed by Q One Document",
    placeholderProject: "PROJECT",
    placeholderType: "DOCTYPE",
    placeholderSubject: "SUBJECT",
    placeholderRevision: "R00",
    placeholderStatus: "STATUS",
    placeholderExtension: "pdf",
    keepOriginalName: "Original file name is kept",
    errors: {
      ...businessErrorsEn,
      unexpected_action_error:
        "The action failed. Check your draft and try again.",
      cash_advance_limit_exceeded:
        "Cash advance exceeds 10,000,000 per request; a director note is required.",
      open_advance_exists:
        "A previous advance is still open; settle it before requesting another.",
      employee_profile_missing:
        "You have no approved employee profile, so a request cannot be filed.",
      expense_category_invalid:
        "The expense code does not exist or is inactive.",
      expense_category_exists: "This expense code already exists.",
      payment_request_not_editable:
        "Only a draft or rejected request can be edited.",
      payment_request_not_deletable:
        "Only a draft that was never submitted can be deleted.",
      payment_request_lines_required: "The request needs at least one line.",
      document_number_required:
        "Lines with an invoice or declaration need the document number.",
      invalid_submitter: "Only the requester can submit this request.",
      self_approval_forbidden:
        "The requester cannot approve their own request.",
      advance_not_paid: "The referenced advance has not been paid.",
      advance_not_owned: "The advance belongs to another employee.",
      advance_already_settled: "This advance has already been settled.",
      advance_reference_required:
        "An advance settlement must reference a paid advance.",
      settlement_refund_expected:
        'This settlement returns money to the fund; use "Refund received".',
      settlement_payment_expected:
        "This settlement pays the employee; choose the payment method first.",
      payment_reference_required: "A transfer needs its reference number.",
      cash_entry_already_reversed: "This entry has already been reversed.",
      cash_entry_is_reversal: "A reversal entry cannot be reversed again.",
      invalid_delegation:
        "Choose another user and a valid delegation period that has not expired.",
      circular_delegation: "A circular delegation is not allowed.",
      workflow_amount_missing:
        "The record is missing a numeric value required for the approval condition.",
      workflow_amount_invalid:
        "The value used for the approval condition is invalid.",
      responsibility_not_owned:
        "This responsibility no longer belongs to the selected user. Reload before transferring.",
      duplicate_document_name:
        "A document with this name already exists; confirm replacement.",
      project_storage_party_mapping_missing:
        "The Customer storage-folder mapping is not configured.",
      project_storage_party_mapping_invalid:
        "Customer code, legal name, or Province / City is missing or invalid.",
      project_storage_party_folder_missing:
        "The provisioned Customer folder was not found.",
      project_storage_project_folder_missing:
        "No unique provisioned Project folder was found.",
      project_storage_project_folder_ambiguous:
        "Multiple folders match the Project code; operations review is required.",
      project_storage_document_type_folder_missing:
        "The provisioned document-type folder was not found.",
      project_storage_counterparty_unsupported:
        "This counterparty type is not yet supported for Project documents.",
      project_storage_not_writable:
        "The Project document storage is not writable.",
      project_storage_target_conflict:
        "The physical target already exists or does not match current metadata.",
      project_storage_path_too_long:
        "The document path exceeds the permitted limit.",
      unsafe_file: "The file is unsafe or was rejected by security scanning.",
      invalid_document_name:
        "The filename does not follow the Project document naming rule.",
      project_code_ambiguous:
        "The Project code is not unique; operations review is required.",
      project_storage_unavailable:
        "The Project document storage is temporarily unavailable.",
      request_entity_too_large: "The file exceeds the 1 GiB maximum size.",
      file_too_large: "The file exceeds the 1 GiB maximum size.",
      upload_timeout: "The upload timed out. Try again.",
      upload_cancelled:
        "The upload was cancelled; no success message was recorded.",
      network_error: "The upload connection failed. Try again.",
      unauthorized: "You are not allowed to upload documents to this project.",
    },
    managerOnly:
      "Only Managers can edit the catalogue; other roles have read-only access.",
    inactive: "Inactive",
    active: "Active",
    activate: "Activate",
    deactivate: "Deactivate",
  },
  progressUpdate: {
    openProject: "Open project details",
    pickProject: "Pick a project to update task progress.",
    scope: "Task scope",
    empty: "No tasks match the filter.",
    panel: "Update task progress",
    assignees: "Assignees",
    percent: "Progress",
    asOf: "As of",
    actualStart: "Actual start",
    actualEnd: "Actual end",
    reason: "Note / reason",
    reasonHint: "Required when late, paused or not applicable",
    confirm: "Save {percent}% progress for task {code}?",
    saved: "Progress saved for task {code}.",
    naCascadeHint: "Will also mark {count} child tasks N/A: {codes}",
    naUnassigned: "You are not assigned to child tasks {codes}. Only the Leader can mark this item N/A.",
    confirmNa: "Mark task {code} and {count} child tasks N/A?",
    parentBadge: "Parent · {count} child tasks",
    scopes: {
      mine: "My tasks",
      all: "Whole project",
      late: "Late",
      open: "Open",
    },
    blocked: {
      permission: "You do not have permission to update progress.",
      locked: "The project is locked or cancelled.",
      phase: "The project has not entered execution yet.",
      assignee: "Only the Leader or an assignee can update this task.",
    },
    statuses: {
      NotStarted: "Not started",
      InProgress: "In progress",
      Blocked: "Paused",
      Completed: "Completed",
      Cancelled: "Cancelled",
      NotApplicable: "Not applicable",
    },
    history: {
      title: "Update history",
      changedAt: "Updated at",
      changedBy: "Updated by",
      wbs: "WBS item",
      percent: "% before → after",
      status: "Status before → after",
      empty: "This project has no progress updates yet",
    },
  },
  progressBoard: {
    viewAs: "View as account",
    viewAsSelf: "My account",
    period: "Period",
    actual: "Actual",
    planned: "Planned",
    lateTasks: "Late tasks",
    nextMilestone: "Next milestone",
    filter: "Filter tasks",
    pickProject: "Pick a project to see its progress board.",
    noProjects: "This account is not on any project yet.",
    financialTitle: "Internal finance (latest quotation)",
    filters: {
      all: "All",
      late: "Late",
      inProgress: "In progress",
      notStarted: "Not started",
      completed: "Done",
    },
    internalTitle: "Project monitoring",
    customerTitle: "Customer progress",
    subcontractorTitle: "Subcontractor progress",
    internalHelp:
      "Shows the complete WBS and the internal financial summary from the latest quotation.",
    customerHelp:
      "Shows directly assigned projects only; the response contains no financial data.",
    subcontractorHelp:
      "Shows assigned work and its ancestors only; the response contains no financial data.",
    project: "Project",
    timeline: "Progress timeline",
    backToday: "Back today",
    assign: "Assign",
    assignHint: "Select a task on the timeline to assign it",
    inputPrice: "Input price",
    additionalCost: "Additional cost",
    salesPrice: "Sales price",
    profit: "Profit / loss",
    paymentProgress: "Payment progress",
    documents: "Project documents",
    fileName: "File name",
    category: "Category",
    version: "Version",
    size: "Size",
  },
  approvedRegistration: {
    codeHistory: "Project ID history (old → new)",
    requiredFields:
      "Check the required fields and the reason for change (up to 2,000 characters).",
    uncertain:
      "The result is unconfirmed. Retry the same request before editing or refreshing.",
    requestedBy: "Requested by",
    decidedBy: "Decided by",
    title: "Edit approved registration",
    reason: "Reason for change",
    reasonRequired: "Provide a reason for the change.",
    save: "Save information",
    requestApproval: "Request approval",
    planChangeNotice:
      "Schedule changes require approval. The current execution plan remains in effect until approval.",
    saved: "Project information updated.",
    requested: "Change request submitted for approval.",
    history: "Registration change history",
    before: "Before",
    after: "After",
    field: "Field",
    noChanges: "No registration changes.",
    decisionReason: "Decision reason",
    approve: "Approve",
    reject: "Reject",
    applied: "Applied",
    pending: "Pending approval",
    approved: "Approved",
    rejected: "Rejected",
    decided: "Decision saved.",
    invalidMembers:
      "Assign a Sales member and use valid, distinct member-role pairs.",
    refresh: "Refresh",
    lookupUnavailable: "Reference data could not be loaded. Refresh to retry.",
  },
  projects: {
    projectModelVision: "Vision",
    projectModelIt: "IT",
    projectModelCommercial: "Commercial",
    wbsModelDateHelp: "Only BOD can change planned dates for the Vision model.",
    wbsModelDatesOnly: "You can change planned dates; other fields follow the permissions for this row.",

    registrationOperationCompleted:
      "The request completed. The project is now {status}; its current information has been refreshed.",
    registrationEditReady:
      "Registration is ready to edit. Save your changes and submit again for approval.",
    registrationDeleted: "Project registration deleted.",
    withdrawRegistrationTitle: "Withdraw registration to edit",
    deleteRegistrationTitle: "Delete project registration",
    withdrawRegistrationHelp:
      "Return registration {code} to data entry. Pending approval tasks will stop; submit again after making changes.",
    deleteRegistrationHelp:
      "Delete registration {code} and stop its pending approval tasks. The action history will be retained. Confirm to remove this registration.",
    registrationReason: "Reason",
    registrationRetry: "Check and retry",
    registrationChangePending:
      "The result is unconfirmed or the workflow is still synchronizing. Check and retry to continue the same request before making further changes.",
    registrationConflict:
      "The project changed. Your entered data has been preserved; refresh the project before trying again.",
    saved: "Project saved successfully.",
    savedWithAttachmentErrors:
      "The project was saved, but these files were not written to the storage folder: {files}. Save again to retry only these files.",
    documentTypeUnavailable:
      "active document type {code} is missing or misconfigured; no fallback storage was used",
    replaceAttachmentConfirm:
      "{target} already exists in the Project folder with different content. Replace it with {file}? A new version will be created for this document slot.",
    attachmentReplacementCancelled:
      "{file} was not replaced; the selected file is still available for retry.",
    projectIdMissing:
      "Not enough input to allocate a Project ID yet — still missing {fields}.",
    projectIdPreview:
      "Preview from current data — the order letter (A, B, C…) is allocated officially on save; ? means the order could not be fetched from the server yet.",
    customerAbbreviationMissing:
      "This customer has no abbreviation yet — set it in CRM Data › Customers before a Project ID can be built.",
    title: "Project Registry",
    subtitle: "Registration, approval and lifecycle control",
    status: "Status",
    customer: "Customer",
    customerShortName: "Customer short name",
    type: "Project type",
    model: "Project model",
    shortContent: "Short content",
    content: "Full project content",
    partner: "Partner",
    contactName: "Contact name",
    contactPhone: "Contact phone",
    contactEmail: "Contact email",
    similarProject: "Similar project",
    restartDate: "Restart date",
    restartRequiresSimilar: "A restart date requires a similar project.",
    feasibility: "Feasibility",
    potential: "Potential",
    competition: "Competition assessment",
    competitor: "Competitor",
    subcontractor: "Subcontractor",
    documentCategory: "Document category",
    registrationDetails: "Q ONE registration details",
    registrationDetailsHelp:
      "Commercial, contact, assessment and source traceability details for this project.",
    priority: "Priority",
    leader: "Project Leader",
    start: "Start",
    end: "End",
    health: "Schedule health",
    new: "Register Project",
    objective: "Objective",
    scope: "Scope",
    requirements: "Requirements",
    workflow: "Approval flow",
    overview: "Overview",
    information: "Project information",
    execution: "WBS & Gantt",
    messages: "Messages",
    files: "Files",
    chatSaveToDocuments: "Add {file} to Project Documents",
    chatCopyingDocuments: "Adding sent files to Project Documents…",
    chatDocumentCopyFailed: "The message was sent, but these files could not be added to Project Documents:",
    projectGroup: "Project group",
    directMessages: "Direct messages",
    customGroups: "Custom groups",
    projectTopics: "Project topics",
    selectMember: "Select a member",
    newDirect: "New direct chat",
    newGroup: "New group",
    selectWbsTopic: "Select a WBS topic",
    newTopic: "New topic",
    groupName: "Group name",
    topicName: "Topic name",
    reply: "Reply",
    replyingTo: "Replying to",
    originalUnavailable: "Original message unavailable",
    deleteMessageConfirm: "Delete this message?",
    sendMessage: "Send",
    wbs: "WBS",
    documents: "Documents",
    issues: "Request tracking",
    lessons: "Lessons",
    reports: "Reports",
    timesheet: "Timesheet",
    member: "Member",
    role: "Role",
    addMember: "Add member",
    assignmentInvalid:
      "Exactly one Leader plus Sales, PI/PIC and Approver are required.",
    milestones: "Planned milestones",
    addMilestone: "Add milestone",
    sortByDate: "Sort by date",
    milestonesInvalid:
      "Milestone types must be unique and dates must be within the project.",
    lateOnly: "Late only",
    from: "From",
    to: "To",
    filters: "Filters",
    editDependency: "Edit dependency",
    deleteDependency: "Delete dependency",
    deleteDependencyConfirm: "Delete the dependency {from} → {to}?",
    quickStart: "Start",
    quickBlock: "Block",
    quickUnblock: "Unblock",
    quickComplete: "Done",
    quickReopen: "Reopen",
    quickCancel: "Cancel work",
    quickUnstart: "Undo start",
    cancelProject: "Cancel project",
    cancelTask: "Cancel from this task",
    cancelProjectConfirm: "Cancel all {count} tasks? {completed} completed tasks will also become Cancelled.",
    cancelTaskConfirm: "Cancel this task and all {count} following tasks? {completed} completed tasks will also become Cancelled.",
    cancelPreviewTitle: "Review project cancellation",
    cancelAffectedNodes: "Affected WBS tasks",
    cancelOperationId: "Operation ID",
    cancelOperationIdOnConfirm: "created when you confirm",
    confirmCancellation: "Confirm cancellation",
    cancelRecoveryPending: "A cancellation operation needs reconciliation.",
    cancelRefreshRequired: "Cancellation ended. Refresh the project before editing again.",
    reconcileCancellation: "Check cancellation outcome",
    retryCancellation: "Retry with the same operation",
    cancelOutcomeUnknown: "The cancellation outcome is unknown. Check the operation before retrying.",
    quickReasonPrompt: "Enter a reason (required):",
    pendingRequests: "Pending requests",
    decision: "Decision",
    approvedAt: "Approved at",
    approveKeepsWbs: "Approval keeps the current WBS",
    approvalOutcomeUnknown:
      "The approval result could not be confirmed. Refresh the project to check its current status before retrying.",
    updateProgress: "Update progress",
    percent: "Percent",
    asOfDate: "As-of date",
    actualStart: "Actual start",
    actualEnd: "Actual end",
    closeOutcomeUnknown:
      "The close outcome is unknown. Reconcile the operation before retrying.",
    closeRowVersionRequired:
      "The current project version is missing. Reload the page before closing.",
    reconcileClose: "Reconcile project close",
    newCloseAttempt: "Start a new close attempt",
    abortPendingClose: "Abort pending close attempt",
    actualDates: "Actual dates",
    plannedMd: "Planned MD",
    weight: "Weight",
    rejectReason: "Reject reason",
    statusReason: "Status reason",
    progressHistory: "Progress history",
    ganttScale: "Gantt scale",
    day: "Day",
    week: "Week",
    month: "Month",
    year: "Year",
    dependencies: "Dependencies",
    predecessor: "Predecessor",
    successor: "Successor",
    addDependency: "Add dependency",
    plan: "Plan",
    actual: "Actual",
    unassigned: "Unassigned",
    picHistory: "PIC assignment history",
    picFilter: "Filter by PIC",
    allPics: "All PICs",
    bulkNa: "N/A several items",
    bulkNaTitle: "Mark several WBS items N/A",
    bulkNaHint: "Pick the items that will not be done. Picking a parent marks every child N/A with it; no need to pick them separately.",
    bulkNaCovered: "with parent",
    bulkNaReason: "Reason (optional)",
    bulkNaApply: "Mark N/A ({count} items)",
    bulkNaDone: "Marked N/A",
    bulkNaFailed: "Failed — stopped here",
    bulkNaSkipped: "Not run",
    naCascadeHint: "Will also mark {count} child tasks N/A: {codes}",
    naUnassigned: "You are not assigned to child tasks {codes}. Only the Leader can mark this item N/A.",
    nodeDocuments: "Task documents",
    nodeDocumentUpload: "Upload a file for this task",
    addWbs: "Add WBS",
    editWbs: "Edit WBS",
    deleteWbsConfirm: "Delete WBS {code}?",
    deleteNodeImpact:
      "This task has {days} allocation day(s). Deleting it will remove all allocations. Continue?",
    concurrencyConflict:
      "Someone else just changed this WBS item. Reloaded the latest version, please re-apply your change.",
    parent: "Parent WBS",
    summaryNodeProgressLockedNotice:
      "Parent work item progress is calculated automatically from child tasks.",
    wbsCloneNotice:
      "Parent task [{parentCode}] already has actual progress ({percent}%). Its current progress will be automatically split into subtask [{cloneCode}], and your new task will have code [{newCode}].",
    reparentingNotAllowed:
      "Changing parent task is not allowed. Please delete and recreate under the new parent.",
    wbsChildDatesOutOfParentRange:
      "Child task dates ({start} - {end}) must be within parent task dates ({pStart} - {pEnd}).",
    wbsParentDatesMustEncloseChildren:
      "Parent task dates ({start} - {end}) must enclose all child tasks ({cStart} - {cEnd}).",
    sortOrder: "Sort order",
    milestoneSchedule: "Milestone schedule",
    stageTracker: "16-stage status",
    stageTrackerHelp:
      "A shared status view for projects initialized from the standard template.",
    stage: "Stage",
    stageHasActivity: "Done",
    stageNoActivity: "Not",
    projectProgress: "Project progress",
    totalProjectDays: "Total project days",
    remainingProjectDays: "Remaining project days",
    projectDocuments: "Project documents",
    scheduleEntry: "WBS schedule entry",
    scheduleEntryHelp:
      "Edit plan above and actual dates / mandays below, then save all rows once.",
    actualMandaysEntry:
      "Enter the current actual total; later approved timesheets continue adding to it.",
    resourceSchedule: "Daily resource schedule",
    resourceScheduleHelpCurrent:
      "Planned mandays are distributed by date when the WBS item is saved. Approved timesheets are added to manual actual values for the same cell.",
    resourceScheduleHelp:
      "Allocate people by WBS and date. Approved timesheets are added to manual actual values for the same cell.",
    chartResourceEdit: "Edit resources on chart",
    chartResourceHelp:
      "Enter people directly in each daily plan / actual cell.",
    chartResourceDayOnly: "Switch to Day view to edit resource allocations.",
    unsavedAllocations: "{count} unsaved cells",
    scale: "Scale",
    previousPeriod: "Previous period",
    nextPeriod: "Next period",
    today: "Today",
    people: "People",
    totalPeople: "Total people",
    variance: "Variance",
    timesheetLocked: "Approved timesheet presence is added to actual",
    approvedTimesheetIncluded:
      "Actual includes approved timesheet presence; manual input is added on top.",
    progressDetailsTitle: "Work item details",
    itemLogTitle: "Work item log",
    itemLogDate: "Date",
    itemLogHint: "%/status updates and approved timesheet hours for this item and all descendants, across all dates. Hours of a day attach to that person's last update on the same day.",
    progressTimesheetRestricted: "You do not have permission to view timesheet details for this item.",
    timesheetDetailsTitle: "Approved timesheet details",
    timesheetDetailsCurrentUser:
      "Showing approved daily-timesheet rows for this cell.",
    timesheetDetailsAssignee: "Member",
    timesheetDetailsOpenHint: "Click to view timesheet details.",
    timesheetDetailsEmpty:
      "No approved timesheet details were found for this cell.",
    planChangeReason: "Reason for the plan change",
    planChangeReasonHelp: "The project is in execution: changing planned dates, mandays or weight requires a reason; it is stored in the task's update history.",
    parentRollupHint: "This item has sub-items: percent, status and actual dates are derived from them (excluding N/A and Cancelled); only N/A can be set for the whole branch.",
    saveAllocations: "Save allocations",
    noAllocationChanges: "There are no allocation changes to save.",
    allocationSaved: "Resource allocations saved.",
    loadOlderMessages: "Load older messages",
    noMessages: "No messages yet.",
    you: "You",
    messageDeleted: "This message was deleted.",
    edited: "Edited",
    writeMessage: "Write a message…",
    search: "Search messages",
    searchResults: "Search results",
    export: "Export history",
    createIssue: "Create issue from message",
    linkedIssue: "Linked issue",
    quoteWbs: "Quote WBS",
    rateLimited: "You are sending too fast. Wait a few seconds and try again.",
    addChild: "Add child task",
    deleteChildrenFirst: "Delete or move child tasks first",
    childName: "Child task name",
    gantt: {
      nonWorkdayPlanned: "Planned people are not allowed on a non-workday.",
      overtimeRequired: "An approved overtime request is required for this project and date.",
      approvedOvertimePeople: "Approved overtime people: {count}",
    },
    documentTypeNameVi: "Vietnamese name",
    documentTypeNameEn: "English name",
    documentTypeAbbreviation: "Abbr.",
    documentTypeNumber: "No.",
  },
  projectMilestone: {
    addColumn: "Add milestone column",
    savePlan: "Save plan",
    name: "Milestone name",
    namePlaceholder: "Enter column name",
    invalidPlan:
      "Milestone names must be filled and unique; dates must be within the project and increase from left to right.",
  },
  notifications: {
    actionState: { actionable: "Needs your action", informational: "Information", unknown: "Action status unavailable" },
    openUnavailable: "This notification cannot be opened: it was deleted, belongs to another account or you no longer have access.",
    noTarget: "The notification was marked as read; there is no record to open.",
    whyReceived: "Why did I receive this?",
    receiptReasonUnknown: "No recorded receipt reason is available for this notification.",
    receiptReasons: {
      direct_user: "You were explicitly selected.",
      system_role: "Your system role at the time of delivery.",
      record_participant: "Your role in the record when the event occurred.",
      record_assignee: "The record assignment when the event occurred.",
      record_reviewer: "You belonged to the record review group when the event occurred.",
    },
    groupedView: "Group by record and event type",
    groupedPageHint: "Groups cover this page in fixed five-minute windows. Each notification keeps its own read state.",
    groupCount: "{count} notifications · {unread} unread",
    previewEmpty:
      "No matching notifications in this preview. Open history to see more.",
    ReportSubmitted: {
      title: "A report is awaiting review",
      message: "A report was submitted. Open it to review and decide.",
    },
    ReportDistributionSkipped: {
      title: "Report distribution was skipped",
      message:
        "No approved report was available for this period. Open distribution history for details.",
    },
    IssueOverdue: {
      title: "An issue is overdue",
      message:
        "An open issue has passed its deadline. Open the project to update its progress.",
    },
    WorkflowTaskOverdue: {
      title: "An approval task is overdue",
      message: "A task awaiting your action has passed its deadline.",
    },
    WorkflowTaskEscalated: {
      title: "An approval task was escalated",
      message: "An overdue task was escalated to the configured roles.",
    },
    WbsAssigned: {
      title: "You were assigned to a work item",
      message:
        "You are now a person in charge of this work item. Open the project to see the plan and update progress.",
    },
    WbsUnassigned: {
      title: "You are no longer in charge of a work item",
      message:
        "You were removed from this work item; further progress updates belong to the new person in charge.",
    },
    ProjectRegistrationInformationChanged: {
      title: "Project registration information changed",
      message:
        "Registration information was updated. Open the project to review the reason and before/after history.",
    },
    ProjectRegistrationChangeRequested: {
      title: "Project registration change requested",
      message:
        "A schedule change requires approval. The current plan remains in effect until approval.",
    },
    ProjectRegistrationChangeApproved: {
      title: "Project registration change approved",
      message: "The registration change was approved and applied.",
    },
    ProjectRegistrationChangeRejected: {
      title: "Project registration change rejected",
      message:
        "The registration change was rejected. Open the project to review the reason.",
    },
    title: "Notifications",
    empty: "No notifications yet.",
    emptyForFilter: "No matching notifications.",
    filterLabel: "Filter notifications",
    all: "All",
    unread: "Unread",
    read: "Read",
    markAllRead: "Mark all read",
    viewAll: "View all notifications",
    pageDescription: "Review, filter, and manage your notifications.",
    back: "Go back",
    showLess: "Show less",
    flagged: "Flagged",
    flag: "Flag notification",
    unflag: "Remove flag",
    delete: "Delete notification",
    deleteConfirm: "Delete this notification?",
    targetMissing:
      "The notification target no longer exists or you do not have access to it.",
    projectTarget: "Project: {project}",
    fallbackTitle: "New notification",
    projectFallbackTitle: "Project notification",
    fallbackMessage: "There is an update relevant to you.",
    targetTypes: {
      OperationsOutbox: "operations diagnostics",
      AssetMaterialReturnedEnrollment: "asset return slip",
      Project: "project",
      ProjectRegistration: "project registration",
      ProjectIssue: "project request",
      WbsNode: "WBS task",
      Report: "report",
      Timesheet: "timesheet",
      MaterialEnrollment: "material registration",
      AssetMaterialEnrollment: "asset registration",
      ProcurementMaterialEnrollment: "material registration",
      ProcurementMaterialReturnedEnrollment: "material return slip",
      ProcurementPaymentRequest: "payment request",
      ProcurementStockReceipt: "stock receipt",
      Default: "related record",
    },
    pagination: "Notification pagination",
    previousPage: "Previous page",
    nextPage: "Next page",
    workflow: "Workflow",
    windowsPush: {
      enable: "Enable desktop notifications",
      disable: "Disable desktop notifications",
      states: {
        checking: "Checking desktop notifications…",
        unsupported: "This browser does not support desktop notifications.",
        unavailable: "Desktop notifications are not configured on the server.",
        denied:
          "The browser blocked notifications. Allow them in browser settings.",
        disabled: "Desktop notifications are off.",
        enabled: "Desktop notifications are on.",
        error: "Desktop notifications could not be set up.",
      },
    },
    WorkflowStarted: {
      title: "Workflow started",
      message: "The record was created and its approval workflow has started.",
    },
    WorkflowStepAssigned: {
      title: "New workflow step assigned",
      message: "You were assigned to handle the {target}.",
    },
  },
  chat: {
    title: "Messages",
    minimize: "Minimize",
    mute: "Mute notifications",
    unmute: "Unmute",
    searchConversations: "Search conversations",
    searchMessages: "Search messages",
    search: "Search",
    searchResults: "Search results",
    newChat: "New conversation",
    newDirect: "Direct chat",
    newGroup: "New group",
    selectPeople: "Select people",
    groupName: "Group name",
    directFallback: "Direct chat",
    you: "You",
    noConversations: "No conversations yet.",
    pickConversation: "Pick a conversation to start.",
    noMessages: "No messages yet.",
    writeMessage: "Write a message…",
    send: "Send",
    attach: "Attach a file",
    react: "React",
    reply: "Reply",
    replyingTo: "Replying to",
    originalUnavailable: "Original message unavailable",
    edited: "Edited",
    messageDeleted: "This message was deleted.",
    deleteConfirm: "Delete this message?",
    loadOlder: "Load older messages",
    typing: "Typing…",
    typingOne: "{first} is typing…",
    typingTwo: "{first} and {second} are typing…",
    typingMany: "{first} and {count} others are typing…",
    mentionPeople: "Mention a participant",
    mentionAllHelp: "Notify everyone",
    emojiPicker: "Emoji picker",
    searchEmoji: "Search emoji",
    recentEmoji: "Recent",
    moreEmoji: "More emoji",
    createPoll: "Create poll",
    pollQuestion: "Poll question",
    pollOption: "Option",
    addOption: "Add option",
    allowMultiple: "Allow multiple choices",
    anonymousPoll: "Anonymous poll",
    allowAddOptions: "Participants can add options",
    pollClosesAt: "Closes at",
    vote: "Vote",
    totalVoters: "{count} voters",
    pollClosed: "Poll closed",
    closePoll: "Close poll",
    poll: "Poll",
    pin: "Pin",
    unpin: "Unpin",
    pinned: "Pinned",
    forwarded: "Forwarded message",
    forward: "Forward",
    hideForMe: "Hide for me",
    forwardTarget: "Choose a conversation",
    forwardWithoutFiles: "Attachments are not forwarded in this version.",
    members: "Members",
    owner: "Owner",
    member: "Member",
    removeMemberAction: "Remove",
    removeMember: "Remove {name} from chat",
    removeMemberConfirm: "Remove {name} from the Project chat? Their Project role will remain unchanged.",
    openProject: "Open Project",
    eligibleUsersLoadFailed: "Could not load users eligible for Chat.",
    online: "Online",
    offline: "Offline",
    jumpToLatest: "Jump to latest",
    moreActions: "More actions",
    retryConnection: "Retry",
    searchScopeHint:
      "Search covers recent messages; archived history is not indexed.",
    seenBy: "Seen by",
    membershipChanged:
      "Your conversation membership changed. The list was refreshed.",
    unknownUser: "Former member",
    createIssue: "Create issue",
    linkedIssue: "Linked issue",
    kindProjectGroup: "Project group",
    kindDirect: "Direct chat",
    kindCustomGroup: "Custom group",
    kindProjectTopic: "WBS topic",
    connection: {
      connected: "Online",
      degraded: "Reconnecting",
      off: "Offline",
    },
  },
  roles: {
    Sales: "Sales",
    PiPic: "PI/PIC",
    Leader: "Project Leader",
    Member: "Member",
    Approver: "Approver",
  },
  milestone: {
    Receipt: "Receipt",
    Survey: "Survey",
    SolutionProposal: "Solution proposal",
    Demo: "Demo",
    Quotation: "Quotation",
    PurchaseOrder: "Purchase order",
    Implementation: "Implementation",
    GoLive: "Go-live",
  },
  timesheets: {
    afterProjectActualEnd: "The work date is after the project's actual end date.",
    unsavedChanges: "Discard unsaved timesheet changes?",
    weekView: {
      label: "Week {week} · {from}–{to}",
      previous: "Previous week",
      next: "Next week",
      today: "Today",
      goTo: "Go to date",
      total: "Week total",
      openDay: "Log day",
      submit: "Submit week",
      submitted: "Submitted {count} day(s) for approval.",
      submitFailed: "{date}: {message}",
      grid: "Weekly timesheet",
      rowLabel: "Project / Task",
      dayTotal: "Day total",
      empty: "No time entries this week. Pick a day and select \"Log day\".",
      overCapacity: "Over standard hours",
      underCapacity: "Under standard hours",
      offDay: "Day off",
      reminder: "Timesheet reminder",
      openCell: "Open {date} to log details",
    },
    weekCopy: {
      button: "Copy to week",
      title: "Copy the timesheet of {date} to other days of the week",
      hint: "Each day is saved as its own draft and is not submitted. Days that already have entries are skipped, never overwritten.",
      run: "Copy as drafts",
      saved: "Draft saved",
      hasEntries: "Already has entries — skipped",
    },
    copyPrevious: "Copy previous day",
    noPreviousEntries: "No entries to copy from the previous day.",
    approvalPart: "Approval part",
    openApprovalInbox: "Open timesheet approval inbox",
    title: "Day timesheet",
    myAttendance: "My time clock",
    myAttendanceHint: "Your own clock-in/out, recorded and pending effort for the selected month.",
    subtitle: "Record actual mandays by Project and WBS",
    calendar: "Monthly timesheet calendar",
    workDate: "Work date",
    project: "Project",
    task: "WBS / Task",
    hours: "Hours",
    hourType: "Hour type",
    normal: "Normal",
    overtime: "Overtime",
    workType: "Work type",
    content: "Description",
    result: "Result",
    ineligibleReference:
      "The Project or WBS/Task is no longer eligible or assigned to you; please select again.",
    add: "Add row",
    total: "Total hours",
    capacity: "Capacity",
    attendanceCheck: "Attendance",
    attendanceEffort: "Recorded effort",
    pendingEffort: "Pending",
    policy:
      "Use 15-minute increments; normal hours must fit capacity and daily total cannot exceed 16 hours.",
    approvals: "Timesheets awaiting approval",
    history: "Version history",
    currentVersion: "Current version",
    user: "Employee",
    overload: "Over daily capacity",
    missing: "Timesheet missing",
    periodLock: "Timesheet period lock",
    lock: "Lock",
    unlock: "Unlock",
    unlockPeriod: "Unlock period",
    unlockReason: "Unlock reason",
    periodEvents: "Period lock / unlock history",
    confirmForceLock:
      "This period still has pending timesheets. Do you want to force lock?",
    from: "From",
    to: "To",
    withdraw: "Withdraw timesheet",
    deleteDraft: "Delete draft",
    withdrawn: "Timesheet withdrawn.",
    deleted: "Draft timesheet deleted.",
    resubmit: "Resubmit",
    rejectedBanner: "Timesheet rejected: {reason}",
    rejectReason: "Reject reason",
    reminderEnabled: "Timesheet reminder",
    timeZone: "Time zone",
    cutoff: "Reminder time",
    saveReminder: "Save reminder",
    importCapacity: "Import capacity",
    capacityImportHelp: "CSV headers: userId,date,availableMinutes.",
    weekday1: "Mon",
    weekday2: "Tue",
    weekday3: "Wed",
    weekday4: "Thu",
    weekday5: "Fri",
    weekday6: "Sat",
    weekday7: "Sun",
    companyCalendar: "Company Calendar",
    defaultCapacity: "Standard Capacity",
    batchSaveSuccess: "Company calendar saved successfully",
    working: "Working day",
    weekend: "Weekend",
    holiday: "Holiday",
    off: "Unpaid leave",
    missingWbsTitle: "Tasks without a timesheet entry",
    missingWbsSubtitle:
      "Add an explanation when a task was not logged; it does not suppress the manager warning.",
    missingWbsReasonPlaceholder: "Reason (up to 1,000 characters)",
    saveReason: "Save reason",
    noMissingWbs: "No missing WBS task remains for this date.",
    explainedWbs: "Explained ({count})",
    obligationsLoadFailed: "Could not load tasks requiring a timesheet entry.",
  },
  masterImport: {
    customersTitle: "Import customers",
    productsTitle: "Import products",
    mode: "Mode",
    insertOnly: "Insert only",
    upsert: "Insert or update",
    csv: "CSV data",
    customerHelp:
      "CSV headers: code,legalName,shortName,countryCode,taxCode,industry,sector,legalRepresentative,corporateEmail,fax,salesOwnerId.",
    preview: "Preview",
    commit: "Commit",
    insert: "inserts",
    update: "updates",
    errors: "errors",
    invalidFile: "CSV data is invalid or empty.",
    committed: "Committed: {inserted} inserted, {updated} updated.",
  },
  reports: {
    projectReports: "Project reports",
    exportAll: "Export all",
    exportAllHint: "Export every report matching the current filter to one Excel file, grouped by project with an index for every report.",
    author: "Author",
    general: "General",
    periodFrom: "From",
    periodTo: "To",
    content: "Content",
    issueTitle: "Issue",
    countermeasures: "Countermeasures",
    openIssues: "Open",
    closedIssues: "Closed",
    issueDetails: "Issue description",
    handling: "Owner & deadlines",
    allProjects: "All projects",
    schedulesHelp: "On each project schedule the system takes the latest approved report (daily or weekly) and notifies the recipients. Without an approved report the run is recorded as skipped and recipients are told.",
    whatToSend: "What to send",
    whenToSend: "When to send",
    everyDay: "Every day",
    everyWeek: "Every week",
    scheduleSettings: "Settings",
    lastRun: "Last sent",
    statuses: {
      Draft: "Draft",
      Submitted: "Submitted",
      Reviewed: "Reviewed",
      Approved: "Approved",
      Returned: "Returned",
      Rejected: "Rejected",
    },
    severities: {
      Low: "Low",
      Medium: "Medium",
      High: "High",
      Critical: "Critical",
    },
    weekdays: {
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
    },
    title: "Project reports",
    subtitle: "Daily/Weekly reports, evidence and lessons learned",
    type: "Type",
    period: "Period",
    workPerformed: "Work performed",
    result: "Work results",
    nextPlan: "Next plan",
    lessons: "Lessons learned",
    new: "New report",
    edit: "Edit report",
    daily: "Daily",
    weekly: "Weekly",
    description: "Description",
    cause: "Cause",
    receivedDate: "Received date",
    requestSource: "Request source",
    requester: "Requester",
    issueContent: "Request / issue content",
    handlingApproach: "Handling approach",
    actualCompletedDate: "Actual completion date",
    sourceCustomer: "Customer",
    sourceInternal: "Internal",
    deadline: "Deadline",
    internalDeadline: "Internal deadline",
    customerDeadline: "Customer deadline",
    deliveryState: "Delivery state",
    severity: "Severity",
    impact: "Impact",
    action: "Countermeasure",
    completeAction: "Complete",
    evidenceId: "Evidence attachment ID",
    history: "Version history",
    review: "Review",
    return: "Return",
    decisionReason: "Decision reason",
    lessonsLibrary: "Lessons learned",
    newLesson: "Capture lesson",
    lessonContent: "Lesson content",
    schedules: "Scheduled report delivery",
    newSchedule: "New delivery schedule",
    editSchedule: "Edit delivery schedule",
    frequency: "Frequency",
    deliveryTime: "Delivery time",
    weekday: "Weekday",
    recipients: "Recipients",
    nextRun: "Next run",
    enable: "Enable",
    disable: "Disable",
    project: "Project",
  },
  issueTracking: {
    workspace: "Request tracking workspace",
    availableAfterApproval:
      "Request tracking is available after the project is approved.",
    summary: "Summary",
    requests: "Requests & handling",
    closure: "Close-out review",
    surveyTitle: "Customer satisfaction survey",
    surveyWarning:
      "This project has no satisfaction survey yet (warning only, closing is not blocked).",
    surveyEmpty: "No survey recorded for this project yet.",
    surveyDate: "Survey date",
    surveyRespondent: "Respondent",
    surveyRole: "Respondent role",
    surveySchedule: "Schedule",
    surveyQuality: "Quality",
    surveyCommunication: "Communication",
    surveySupport: "Support",
    surveyOverall: "Overall",
    surveyRecommend: "Recommend score (0–10)",
    surveyComment: "Comment",
    total: "Total requests",
    open: "In progress",
    closed: "Completed",
    late: "Late",
    awaitingDecision: "Awaiting decision",
    plannedMandays: "Total planned MD",
    completionRate: "Completion rate",
    onTimeRate: "On-time / early rate",
    closeOutProgress: "Close-out reviews",
    statusDistribution: "Request status",
    scheduleDistribution: "Schedule health",
    severityDistribution: "Severity",
    decisionDistribution: "Decision checkpoints",
    early: "Early",
    onTrack: "On track",
    severityLow: "Low",
    severityMedium: "Medium",
    severityHigh: "High",
    severityCritical: "Critical",
    decisionPending: "Pending",
    decisionApproved: "Approved",
    decisionRejected: "Rejected",
    reviewsCompleted: "{completed}/{total} reviews completed",
    newRequest: "New request",
    workflowDefinitionUnavailable:
      "No active workflow is configured for requests.",
    workflowCreatePending: "Request saved; waiting for workflow start.",
    workflowCreateStarting:
      "Workflow is starting; the request remains recoverable.",
    workflowCreateFailed:
      "Workflow start failed; retry with the same request key.",
    workflowCreateRecoverable:
      "The request attempt is recoverable; retry uses the saved payload.",
    workflowCreateDraftChanged:
      "The draft changed after the failed attempt. Start a New Attempt to use the edited payload.",
    workflowCreateNewAttemptRequired:
      "This attempt has no immutable payload snapshot. Start a New Attempt before submitting.",
    newAttempt: "New Attempt",
    workflowTaskState: "Workflow task: {state}",
    openWorkflowTask: "Open workflow task",
    resumeWorkflow: "Resume approval submission",
    lastUpdated: "Updated",
    lastUpdatedAt: "Last updated",
    createOpen: "New request",
    copyLink: "Copy link",
    linkCopied: "Copied",
    checkpointDetails: "Details",
    summaryMetrics: "Metrics",
    dueOverdue: "{days} days late",
    dueToday: "Due today",
    dueIn: "{days} days left",
    mineOnly: "Mine",
    mineOnlyHint: "Show only requests you own, with open actions assigned to you, or awaiting your decision",
    awaitingMe: "Awaiting you",
    nextStep: "Next step",
    nextDecideMine: "Your decision is needed: {stage}",
    nextWaitingDecision: "Waiting for decision: {stage}",
    nextAddAction: "No handling action yet, add the first one",
    nextOpenActions: "{count} handling actions still open",
    nextRecordNmi: "All handling actions are done, record the NMI completion date",
    nextRecordDelivery: "Record the customer delivery date to complete the request",
    addLogLine: "Add log line",
    addLogLineHint: "Insert a new line with the time and your name at the top of the notes",
    unsaved: "Unsaved",
    saveShortcut: "Ctrl+Enter to save",
    unsavedCloseWarning: "Actual result has unsaved changes.",
    keepEditing: "Keep editing",
    discardChanges: "Discard changes",
    saveAndClose: "Save and close",
    deadlineOrder: "Internal deadline must be on or before the customer deadline",
    emptyNoRequests: "No requests yet.",
    emptyCreateHint: "No requests yet. Use New request to log the first one.",
    emptyFiltered: "No requests match the current filter.",
    nmiCompletedDate: "NMI completion date",
    customerDeliveredDate: "Customer delivery date",
    picCheckpoint: "PIC decision",
    confirmCheckpoint: "Confirmation",
    approvalCheckpoint: "Approval",
    decisionComment: "Enter a decision comment (required when rejecting)",
    actualTracking: "Actual result",
    notes: "Notes",
    addAction: "Add handling action",
    actions: "Handling actions",
    completedAt: "Completed at",
    evidence: "Evidence",
    documents: "Request documents",
    issuesAndObservations: "Issues / observations",
    lessonsLearned: "Lessons learned",
    finalConclusion: "Final conclusion",
    outcome: "Outcome",
    canClose: "Project can close",
    cannotClose: "Project cannot close",
    conclusionComment: "Conclusion comment",
    roleLeader: "Project Leader",
    roleImplementation: "Implementation",
    roleProduction: "Production",
    roleSales: "Sales",
    roleDirector: "Board of Directors",
  },
  documentCategory: {
    Survey: "Survey",
    Drawing: "Drawing",
    Contract: "Contract",
    Report: "Report",
    Other: "Other",
  },
  ganttStage: {
    cancelled: "Cancelled",
    notStarted: "Not",
    inProgress: "In progress",
    completed: "Done",
  },
  wbsAssignees: {
    label: "Assignees",
    help: "Hold Ctrl or Cmd to select multiple people.",
  },
  status: {
    draft: "Draft",
    stockissue: "Stock issue (FIFO)",
    active: "Active",
    inactive: "Inactive",
    discontinued: "Discontinued",
    submitted: "Submitted",
    reviewed: "Reviewed",
    confirmed: "Confirmed",
    approved: "Approved",
    rejected: "Rejected",
    returned: "Returned",
    pending: "Pending",
    pendingconfirmation: "Pending confirmation",
    adminreceived: "Admin received",
    accountingreceived: "Accounting received",
    received: "Received",
    missing: "Missing",
    nonworkday: "Non-workday",
    planned: "Planned",
    due: "Due",
    overdue: "Overdue",
    delivered: "Delivered",
    closed: "Closed",
    cancelled: "Cancelled",
    notapplicable: "N/A – Not applicable",
    notstarted: "Not started",
    inprogress: "In progress",
    blocked: "Blocked",
    withdrawn: "Withdrawn",
    completed: "Completed",
    early: "Early",
    ontrack: "On track",
    atrisk: "At risk",
    late: "Late",
    low: "Low",
    normal: "Normal",
    high: "High",
    critical: "Critical",
    disbursing: "Disbursing",
    paid: "Paid",
    notsubmitted: "Not submitted",
    pendingapproval: "Pending approval",
    quoted: "Quoted",
    reversed: "Reversed",
    available: "Available",
    open: "Open",
    resolved: "Resolved",
    medium: "Medium",
  },
  documentRevisions: {
    title: "Edit history",
    history: "History",
    edit: "Edit",
    empty: "No edits yet.",
    version: "Version",
    changedAt: "Changed at",
    changedBy: "Changed by",
    reason: "Reason",
    changes: "Before → after",
    reasonLabel: "Reason for the change",
    reasonRequired: "Enter the reason for the change.",
    line: "Line {n}",
    lineAdded: "line added",
    lineRemoved: "line removed",
    you: "You",
    invoiceTitle: "Edit invoice",
    cashTitle: "Edit entry",
    bankTitle: "Edit statement line",
    paidLocked: "The invoice has receipts: only the responsible person, customs number and due date can change. Remove the receipts before changing amounts or lines.",
    cashMoneyHint: "Changing fund, date, side or amount reverses the old entry and records a linked new one; other fields are edited in place.",
    sourceManaged: "Entry generated from a payment request: only descriptive fields can change; amounts must be corrected on the source request.",
    bankImmutable: "Bank amount and date cannot change; only classification, note and affiliation can.",
    periodHint: "Reopen a closed month before editing.",
    fields: {
      issueDate: "Invoice date",
      invoiceNumber: "Invoice number",
      responsibleName: "Responsible person",
      affiliationCode: "Affiliation",
      customsDeclarationNumber: "Customs declaration",
      dueDate: "Due date",
      currency: "Currency",
      amount: "Amount",
      itemCode: "Item code",
      model: "Model",
      serial: "Serial",
      description: "Description",
      itemGroup: "Item group",
      classification: "Classification",
      quantity: "Quantity",
      unit: "Unit",
      unitPrice: "Unit price",
      taxRatePercent: "Tax rate",
      projectCode: "Project",
      commercialPoCode: "Commercial PO",
      materialId: "Material",
      invoiceDate: "Invoice date",
      supplierName: "Supplier",
      endUser: "End user",
      purchaseOrderNumber: "P/O number",
      expenseCategoryCode: "Expense code",
      exchangeRate: "Exchange rate",
      totalAmount: "Total amount",
      note: "Note",
      fund: "Fund",
      entryDate: "Date",
      receiptAmount: "Receipt",
      disbursementAmount: "Disbursement",
      documentRef: "Document",
      payeeName: "Payee",
      payeeUnit: "Affiliation",
      flowCode: "Flow code",
      matchedPaymentRequestId: "Matched payment request",
      matchedInvoicePaymentId: "Matched invoice receipt",
      matchedSupplierInvoicePaymentId: "Matched supplier payment",
      replacedByEntryId: "Replacement entry",
      reversalEntryId: "Reversal entry",
    },
  },
  systemSettings: {
    title: "System settings",
    subtitle: "Organization, security, email, calendar and integration settings. Each group is saved separately, applies immediately and is audited.",
    general: "Organization",
    security: "Security & sessions",
    auditGroup: "Log retention",
    organizationName: "Organization name",
    organizationNameHint: "Shown on the sign-in screen, in emails and in the system title.",
    supportEmail: "Support email",
    supportPhone: "Support phone",
    defaultLanguage: "Default language",
    defaultLanguageHint: "Used until a user picks a language in the top bar.",
    languages: {
      vi: "Vietnamese",
      en: "English",
    },
    fields: {
      failureLimit: "Failed sign-ins before a temporary lock",
      windowMinutes: "Temporary lock duration (minutes)",
      minLength: "Minimum password length",
      accessTokenMinutes: "Access session lifetime (minutes)",
      retentionDays: "System log retention (days, 0 = keep forever)",
    },
    default: "default {value}",
    reason: "Reason for change",
    reasonHint: "Reason for change (recorded in the authorization history)",
    discard: "Discard changes",
    saved: "Saved; effective immediately.",
    readOnly: "You can only view these settings.",
    updatedAt: "Last updated {at}",
    unsaved: "Unsaved changes",
    copy: "Copy",
    copied: "Copied",
    navGroup: {
      organization: "Organization",
      security: "Security",
      integrations: "Integrations",
      platform: "Platform",
    },
    nav: {
      overview: "Overview",
      general: "General",
      security: "Sign-in & passwords",
      audit: "Logs",
      email: "Email & notifications",
      calendar: "Google & Microsoft calendar",
      webpush: "Push notifications",
      platform: "System & features",
      ecosystem: "Q One ecosystem",
    },
    intro: {
      general: "Organization name, support contacts and the default interface language.",
      security: "Sign-in lockout policy, password length and access session lifetime.",
      audit: "How long system activity logs are kept before automatic deletion.",
    },
    overview: {
      intro: "Current configuration status. Choose an item to edit it.",
      on: "On",
      off: "Off",
      password: "Passwords of at least {n} characters",
      session: "{n}-minute access sessions",
      deploymentTitle: "Parameters kept in the deployment configuration",
      deploymentHint: "Database connection, RabbitMQ, JWT signing key, internal service keys, storage folders, ports/domains and the Cloudflare Tunnel stay in .env because they are needed before the system starts or are root secrets.",
    },
    source: {
      locked: "Locked by environment",
      lockedHint: "The deployment environment (e.g. DEV forcing email to Mailpit) locks this group; values stored in the database are not applied.",
      database: "Stored in database",
      deployment: "Deployment configuration",
      deploymentHint: "Not saved in the UI yet: using appsettings/environment variables. Saving once moves this group into the database.",
      reset: "Restore deployment configuration",
      resetTitle: "Restore deployment configuration",
      resetContext: "Deletes the stored copy; this group goes back to appsettings/environment variables.",
    },
    secret: {
      keep: "Set — leave blank to keep",
      empty: "Not set",
      unreadable: "Cannot be decrypted — enter again",
      unreadableHint: "The stored value was encrypted with another environment's key (e.g. a database copied from Production). Enter it again.",
      willClear: "Will be cleared on save",
      clear: "Clear value",
      undoClear: "Keep value",
    },
    emailNotifications: {
      intro: "One SMTP account for notification, password reset and payslip email (left); notification email cadence, quiet hours, display and retention (right). Both parts save together.",
    },
    email: {
      intro: "SMTP account used for notification, password reset and payslip emails.",
      enabled: "Enable email",
      enabledHint: "When off the system sends no email (notifications still appear in the app).",
      account: "Sending account",
      presets: "Quick fill:",
      preset: {
        microsoft365: "Microsoft 365",
        google: "Google Workspace",
      },
      host: "SMTP server",
      port: "Port",
      security: "Security",
      tls: "STARTTLS/TLS",
      noTls: "No encryption",
      userName: "User name",
      password: "Password / App password",
      fromAddress: "Sender address",
      fromName: "Display name",
      usage: "Use for",
      notifications: "Notification email",
      notificationsHint: "Approvals, tasks, due-date reminders… per each user's email preferences.",
      passwordReset: "Password reset",
      passwordResetHint: "Sends reset links; requires TLS and an https system address.",
      payroll: "Payslips",
      payrollHint: "Sends password-protected payslip PDFs to employees.",
      payrollSeparate: "Use a separate account for payslips",
      payrollSeparateHint: "E.g. a dedicated accounting/HR mailbox.",
      test: "Send a test email",
      testHint: "Sends with the effective configuration to check the SMTP connection.",
      testTo: "Recipient email",
      testPayroll: "Use the payslip account",
      testSend: "Send test",
      testSent: "Test email sent to {to}.",
      saveBeforeTest: "Save your changes before sending a test.",
    },
    calendar: {
      intro: "OAuth apps that let users connect Google Calendar and Microsoft 365/Outlook: two-way event sync and Meet/Teams links.",
      enable: "Allow connections",
      googleClientId: "Client ID",
      microsoftClientId: "Application (client) ID",
      clientSecret: "Client secret",
      tenant: "Tenant",
      tenantHint: "common = any Microsoft account; organizations = work accounts only; or your tenant ID/domain.",
      redirectUri: "Redirect URI (register it in the OAuth app)",
      howTo: "How to create the app",
      googleStep1: "Google Cloud Console › APIs & Services › Credentials › Create OAuth client ID (Web application); enable the Google Calendar API.",
      microsoftStep1: "Microsoft Entra admin center › App registrations › New registration (Web); create a client secret under Certificates & secrets.",
      openConsole: "Open console",
      stepRedirect: "Add the redirect URI:",
      stepScopes: "Scopes to grant:",
      stepPaste: "Paste the client ID and secret here and save; users connect in Account › Connected apps or Calendar › Settings.",
      redirectFollowsUrl: "Redirect URIs follow the system address (System & features).",
    },
    webpush: {
      intro: "Desktop/mobile push notifications through the browser (Web Push standard, VAPID keys).",
      enabled: "Enable push notifications",
      enabledHint: "Users still need to allow them in their browser (Account › Notifications).",
      keys: "VAPID keys",
      subject: "Subject",
      subjectHint: "Administrator mailto: or https:// contact sent to push services.",
      publicKey: "Public key",
      privateKey: "Private key",
      generateHint: "Generate the key pair once and keep it (changing keys drops existing push subscriptions):",
    },
    notifications: {
      intro: "How long notifications are shown and kept, email cadence, daily email cap and quiet hours (ADR-089). Changes apply within about a minute.",
      display: "Display and retention",
      legacyAudienceDays: "Show legacy role/department notifications (days)",
      legacyAudienceDaysHint: "Notifications sent to a whole role or department (legacy) appear in the bell and unread count only for this many days.",
      readRetentionDays: "Keep read notifications (days)",
      readRetentionDaysHint: "Read notifications older than this are deleted automatically. 0 = never delete; minimum 30 days.",
      deliveryLogRetentionDays: "Keep delivery logs (days)",
      deliveryLogRetentionDaysHint: "Finished processing, delivery, email and de-duplication records are purged after this many days.",
      email: "Notification email",
      emailDefaultCadence: "Default email cadence",
      emailDefaultCadenceHint: "Applies to users who have not chosen one under Account › Notifications.",
      cadenceImmediate: "Send immediately",
      cadenceHourly: "Hourly digest",
      cadenceDaily: "Daily digest",
      dailyDigestHour: "Daily digest hour",
      emailDailyLimit: "Maximum emails per person per day",
      emailDailyLimitHint: "0 = unlimited. Notifications over the cap are folded into the next digest.",
      quietHours: "Quiet hours",
      quietHoursEnabled: "Do not send email during quiet hours",
      quietHoursEnabledHint: "Notifications raised during this window are combined into one email when it ends.",
      quietHoursStart: "From",
      quietHoursEnd: "To",
      timeZone: "Time zone",
      timeZoneHint: "IANA name, e.g. Asia/Ho_Chi_Minh.",
      overviewLine: "Shown {days} days · email {cadence}",
    },
    platform: {
      intro: "System address and feature flags that used to be Docker variables.",
      address: "Access address",
      publicBaseUrl: "System address",
      publicBaseUrlHint: "Used for links in emails, calendar OAuth redirects and the password reset page (e.g. https://crm.nmi.vn).",
      features: "Features",
      projectIssueWorkflow: "Approve project issues through workflows",
      projectIssueWorkflowHint: "Project issues go through Workflow (approvers resolved from the project leader).",
      projectCancellation: "Project cancellation",
      projectCancellationHint: "Allows requesting project cancellation through an approval workflow.",
      documentStorage: "Project document storage",
      documentStorageHint: "Project documents are always written to the server store. Q One Document mode also pushes a copy to doc.nmi.vn along the NMI Rev01 folder standard, as the uploading user.",
      documentStorageLocal: "Server storage only (data folder)",
      documentStorageQOneDocument: "Sync to Q One Document",
      documentStorageQOneDocumentHint: "Files are pushed to QOD under the uploader's QOD account (linked by email or created the first time); QOD must have \"Sign in with Q One\" enabled. If QOD is unreachable, files are still stored and sync later.",
      overviewStorageLocal: "Project files: server only",
      overviewStorageQOneDocument: "Project files: sync to Q One Document",
      qodApiBaseUrl: "Q One Document gateway address",
      qodApiBaseUrlHint: "CRM calls the QOD integration API here. Same Docker host: http://host.docker.internal:5188; another host: its public address, e.g. https://doc.nmi.vn.",
      qodApiKey: "Q One Document integration key",
      qodApiKeyHint: "Must match QOD_CRM_INTEGRATION_API_KEY in the Q One Document deployment. Not shown again after saving.",
      qodWebBaseUrl: "Q One Document web address",
      qodWebBaseUrlHint: "Used for \"Open in Q One Document\" links (e.g. https://doc.nmi.vn).",
      qodTestHint: "After saving, check it under Q One ecosystem › Connection test. Uploader tokens are requested from Q One Platform when \"Sign in with Q One\" is on.",
      restartNotice: "Toggling project cancellation and the Workflow project-leader resolver requires restarting the related service to change registrations; other items apply within about a minute.",
    },
    ecosystem: {
      intro: "Sign in to CRM with a Q One Platform account (the shared identity provider of the ecosystem, like Q One Document and Q One EDU). Access requires a CRM account with the same email; roles and permissions stay in CRM. Takes effect immediately.",
      login: "Sign in with Q One",
      enabled: "Allow signing in with Q One",
      enabledHint: "Shows the \"Sign in with Q One\" button on the CRM sign-in page.",
      authority: "Q One Platform address (issuer)",
      authorityHint: "For example https://qone.nmi.vn/ — must match the Platform issuer. The CRM application must be allowed in Q One Platform › System › Settings › Q One ecosystem sign-in.",
      clientId: "CRM web client ID",
      clientIdHint: "Public client registered on Platform (default qone-crm-web), redirecting to https://<CRM address>/auth/callback.",
      service: "Service client (delegation tokens)",
      delegate: "Request Q One Document delegation tokens from Q One Platform",
      delegateHint: "When project files sync to Q One Document, CRM requests a token on behalf of the uploader from Platform using this service client.",
      serviceClientId: "Service client ID",
      serviceClientSecret: "Service client secret",
      serviceClientSecretHint: "Secret of the qone-crm-service client on Platform (oidc.env on the Platform server). Not shown again after saving.",
      test: "Connection test",
      testHint: "Uses the saved settings: reads Platform discovery, gets a service client token and tries the Q One Document integration key (when sync is on).",
      testRun: "Test",
      check: {
        platformDisabled: "Sign in with Q One is off",
        platformDiscovery: "Q One Platform responds, issuer matches",
        platformService: "Service client obtains a delegation token",
        document: "Q One Document accepts the integration key",
      },
      detail: {
        secret: "client secret not set",
        missing: "address or integration key not set",
        key: "wrong integration key",
        qone_login_disabled: "Q One Document has \"Sign in with Q One\" disabled",
      },
    },
  },
  usage: {
    tabs: { overview: "Usage overview", accounts: "Accounts" },
    period: "Period",
    lastDays: "{n} days",
    searchAccount: "Search account, name, employee code",
    includeInactive: "Include locked accounts",
    note: "An active day is a working day (Mon–Fri) with at least one action or sign-in. Rates start from the account creation date. Background calls (notifications, session refresh) are not counted.",
    kpi: {
      accounts: "Active accounts", activeInPeriod: "{n} accounts used it in the period", today: "Active today", week: "Active in 7 days", month: "Active in 30 days",
      rate: "Active-day rate (avg)", dormant: "Idle > 30 days", actions: "Actions", writes: "{n} writes", logins: "Sign-ins",
    },
    activeUsers: "Active users",
    activeTrend: "Active users over time",
    byArea: "Usage by module",
    otherAreas: "Other modules",
    mostActive: "Most active",
    dormant: "Idle accounts",
    noDormant: "Every account was used in the last 30 days.",
    accountsTitle: "Usage frequency by account",
    account: "Account",
    roles: "Roles",
    department: "Department",
    rate: "Active-day rate",
    activeDays: "Active days",
    trend: "Trend",
    requests: "Actions",
    writes: "Writes",
    logins: "Sign-ins",
    topArea: "Top module",
    lastActive: "Last active",
    never: "Never",
    today: "Today",
    daysAgo: "{n} days ago",
    statusActive: "Active",
    statusLocked: "Locked",
    openPermissions: "Open permissions",
    panel: { overview: "Account profile", activity: "Activity calendar", areas: "By module", actions: "Recent actions" },
    fields: {
      employeeCode: "Employee code", position: "Position", employment: "Employment status", createdAt: "Account created", sessions: "Active sign-in sessions",
      groups: "Account groups", directGrants: "{n} direct grants", password: "Password", mustChangePassword: "Must change password at next sign-in",
    },
    dayTitle: "{requests} actions, {writes} writes, {logins} sign-ins",
    legend: "Less",
    day: "Day",
    firstLast: "First – last",
    time: "Time",
    action: "Action",
    area: "Module",
    noData: "No data in this period.",
    areas: {
      "projects": "Projects",
      "customers": "Customers",
      "organizations": "Partners & suppliers",
      "products": "Products",
      "quotations": "Quotations",
      "customer-orders": "Customer POs",
      "project-contracts": "Contracts",
      "document-templates": "Document templates",
      "timesheets": "Attendance & requests",
      "calendar": "Work calendar",
      "reports": "Reports",
      "dashboards": "Operations center",
      "workflow": "Approvals",
      "documents": "Documents",
      "chat": "Chat",
      "procurement": "Purchasing",
      "purchase-requests": "Purchase requests",
      "purchase-orders": "Supplier POs",
      "materials": "Materials",
      "payment-requests": "Payment vouchers",
      "finance": "Accounting",
      "users": "Accounts",
      "roles": "Roles",
      "audit-trail": "Audit log",
      "exchange-rates": "Exchange rates",
      "login": "Sign-in",
      "work": "Work inbox",
    },
  },
  auditLog: {
    title: "Logs & diagnostics",
    sections: { trail: "Activity log", outbox: "Data sync diagnostics" },
    hints: { trail: "Who did what, when and with which result (no data content).", outbox: "Events waiting between services (Outbox): backlog, failures, retries." },
  },
  auditTrail: {
    title: "System audit log",
    note: "Every create/update/delete through the API: who, when, what and the result. Data contents are not stored.",
    occurredAt: "Time",
    actor: "User",
    anonymous: "Not signed in",
    method: "Action",
    path: "Path",
    area: "Area",
    status: "Result",
    duration: "ms",
    success: "Succeeded",
    failure: "Failed / denied",
    from: "From",
    to: "To",
    searchHint: "Path, user or reference id",
    invalidRange: "From must be on or before To.",
    export: "Export CSV",
    correlationId: "Reference id",
    clientAddress: "IP address",
  },
  reauth: {
    title: "Confirm password",
    message: "Changing permissions requires your password again.",
    password: "Current password",
    confirm: "Confirm",
  },
  errors: {
    settings_locked: "This settings group is locked by the deployment environment.",
    email_not_configured: "The SMTP server and sender address are not configured.",
    email_test_failed: "Sending the test email failed.",
    reauth_required: "Enter your current password to confirm this permission change.",
    reauth_failed: "The password is not correct.",
    ...businessErrorsEn,
    ...errorUiEn,
    payment_bank_account_required: "Choose or enter the company bank account used for this transaction.",
    payment_bank_account_locked: "The bank account must match the account assigned by accounting.",
    document_revision_no_changes: "There is nothing to save.",
    document_revision_reason_required: "Enter the reason for editing this document.",
    invoice_has_payments: "The invoice has receipts: remove them before changing amounts, dates or lines.",
    cash_entry_source_managed: "This entry comes from a payment request: correct the amount on the source request.",
    invoice_number_occupied: "That invoice number is already used for the same destination.",
    cash_entry_already_reversed: "This entry has already been reversed.",
    cash_entry_is_reversal: "A reversal entry cannot be edited.",
    payment_expense_category_required: "Accounting must assign an expense code to every line before payment.",
    expense_category_scope_mismatch: "Expense code out of scope: projects cannot use office expense codes and office expenses cannot use project incidental codes.",
    supplier_invoice_allocation_conflict: "Do not combine an invoice-level project with line allocations.",
    supplier_invoice_line_allocation_required: "Each supplier invoice line needs exactly one project or external commercial PO code.",
    invoice_line_allocation_required: "Each sales invoice line needs exactly one project or external commercial PO code.",
    invoice_line_allocation_conflict: "Do not combine an invoice-level P/O or project with line allocations.",
    invoice_customer_mismatch: "All project lines must belong to the same customer.",
    invalid_customer: "Choose an active customer for external commercial PO lines.",
    supplier_invoice_service_not_stock: "Service lines cannot receive physical stock.",
    stock_backdate_blocked: "Stock cannot be dated before the latest approved issue of this material. Reverse the later issues first.",
    stock_receipt_consumed: "This receipt has already been issued (FIFO cost). Reverse the issues that consumed it first.",
    invoice_service_not_stock: "Service lines are not issued from stock.",
    invoice_material_unit_mismatch: "The line unit differs from the material unit.",
    supplier_invoice_material_mismatch:
      "Choose an active material with the same unit as the invoice line.",
    supplier_invoice_material_required:
      "Link the invoice line to a stock material before creating a receipt.",
    supplier_invoice_stock_locked:
      "Linked invoice and stock receipt source details cannot be changed.",
    amortization_affiliation_locked:
      "Affiliation cannot change after allocation has started.",
    amortization_opening_locked:
      "Opening allocations cannot change after allocation has started.",
    invoice_lines_immutable:
      "Issued lines are immutable; issue a replacement invoice to change them.",
    login_rate_limited:
      "Too many failed login attempts. Wait a few minutes and try again.",
    bank_match_no_candidate:
      "No document matches the exact amount and currency within ±15 days.",
    bank_match_ambiguous:
      "Several documents match; open “Reconcile” to choose one.",
    bank_line_already_matched: "This statement line is already matched.",
    bank_batch_too_large: "A batch can process at most 200 statement lines.",
    finance_period_blocked:
      "The period still has blocking items. Resolve them, then close again.",
    finance_period_already_closed:
      "This period is already closed. Reopen it before closing again.",
    finance_period_not_closed: "Only a closed period can be reopened.",
    finance_period_not_ended: "Only an ended period can be closed.",
    finance_reopen_reason_too_short:
      "The reopening reason needs at least 10 characters.",
    supplier_allocation_exceeds_payment:
      "Allocations exceed the paid amount of the request.",
    supplier_allocation_mixed_suppliers:
      "One payment can only be allocated to invoices of a single supplier.",
    supplier_allocation_duplicate:
      "This payment already has an allocation for the invoice. Remove it before allocating again.",
    contract_signed_date_required:
      "Record the PO date before activating the contract.",
    contract_invalid_transition:
      "The contract status does not allow this action.",
    contract_not_editable:
      "A completed or terminated contract can no longer be changed.",
    contract_number_taken: "The contract number is already used.",
    acceptance_remarks_required:
      "Remarks are required unless the result is “Accepted”.",
    acceptance_warranty_not_allowed:
      "A rejected acceptance cannot start the warranty.",
    acceptance_number_taken:
      "The record number is already used in this project.",
    acceptance_already_void: "This acceptance record is already void.",
    warranty_invalid_transition:
      "The ticket status does not allow this action.",
    warranty_assignee_required: "Assign the ticket before starting work.",
    project_not_writable: "A rejected project cannot hold contracts or tickets.",
    project_cancelled: "The project is cancelled and business writes are blocked.",
    cancellation_active: "Project cancellation is in progress. Check its status before continuing.",
    project_cancellation_preparing: "Project cancellation is being prepared, so business writes are blocked.",
    payroll_password_notice_unknown: "The password notice outcome is unknown. Reconcile it before sending payslips.",
    payroll_password_notice_failed: "The password notice failed. Resolve the cause and explicitly retry failed deliveries.",
    payroll_password_mismatch: "This legacy PDF uses a different password from the issued credential. Review it or issue a corrected revision before sending.",
    payroll_password_credential_missing: "This older delivery has no password credential. Reload payroll and explicitly retry the failed delivery.",
    email_authentication_failed: "SMTP authentication was rejected. Check the sender account and SMTP app password.",
    email_configuration_invalid: "SMTP configuration is invalid. Check the host, port, TLS and sender address.",
    payroll_recipient_rejected: "The mail server rejected the recipient. Check the email address before retrying.",
    amortization_source_locked: "The linked purchase, cost, kind and recognition date cannot be changed.",
    amortization_source_in_use: "This purchase already has an allocation schedule; duplicate allocation or source reversal is not allowed.",
    amortization_source_invalid: "The purchase is unavailable, reversed or already allocated.",
    amortization_source_mismatch: "Cost, kind, currency and recognition date must match the purchase; allocation cannot start before its month.",
    bank_invoice_required: "Select a valid invoice to record its settlement.",
    bank_manual_link_locked:
      "This bank movement settles an invoice; its link or payment cannot be removed separately.",
    payroll_employee_linked:
      "This employee has payments linked to the period. Resolve the links before removing the employee.",
    finance_period_closed:
      "The financial period is closed. Reopen it before changing its data.",
    amortization_code_exists: "The amortization code already exists.",
    amortization_effective_month:
      "The effective month must start on or after the current business month.",
    amortization_revision_order:
      "The effective month cannot precede an existing revision.",
    amortization_currency_locked:
      "Currency cannot change on an existing amortization item.",
    amortization_below_allocated:
      "Total amount cannot be less than the amount already allocated before the effective month.",
    amortization_no_remaining_period:
      "Extend the schedule to allocate the remaining amount after the effective month.",
    expense_category_unknown: "The expense category does not exist.",
    bank_csv_empty: "The statement file is empty.",
    bank_csv_header_not_found:
      "No header row with a date and a credit/debit column was found.",
    bank_csv_too_large:
      "The statement exceeds the maximum number of lines for one import.",
    bank_csv_no_rows: "The file has a header but no readable statement rows.",
    bank_csv_invalid_quotes: "The CSV ends inside a quoted field.",
    bank_match_not_paid: "Only a paid payment request can be matched.",
    bank_match_taken:
      "This document is already matched to another statement line.",
    bank_line_is_credit:
      "Only a debit line can be matched to a payment request.",
    bank_line_is_debit:
      "Only a credit line can be matched to an invoice payment.",
    cash_opening_future:
      "Opening balances cannot be certified for a future date.",
    cash_opening_exists:
      "A certified opening already exists for this currency and date; record a new dated certification instead.",
    cash_negative_confirmation_required:
      "This payment would make the certified cash balance negative. Confirm with a reason to continue.",
    payroll_payment_ineligible:
      "Only an unpaid VND employee payment selected for payroll can be linked.",
    advance_not_found: "The referenced advance was not found.",
    currency_mismatch: "The settlement must use the advance currency.",
    workflow_definition_mismatch:
      "The active workflow does not match the frozen payment approval policy.",
    workflow_submit_not_ready:
      "The first workflow activity is not ready yet. Try again shortly.",
    supplier_invoice_void: "A voided invoice cannot be paid.",
    supplier_invoice_overpayment:
      "The payment exceeds the invoice outstanding amount.",
    supplier_invoice_overpaid: "Payments exceed the invoice total.",
    supplier_invoice_payment_held:
      "The invoice does not match its purchase order and receipts, so payment is on hold until an authorized release.",
    supplier_invoice_exists: "This supplier invoice already exists.",
    supplier_invoice_source_locked:
      "Supplier, project and currency are fixed while a linked payment request exists.",
    supplier_invoice_has_payments:
      "Remove the payments before changing or voiding this invoice.",
    supplier_invoice_lines_required: "At least one invoice line is required.",
    supplier_payment_request_not_paid:
      "Only a paid payment request can settle an invoice.",
    supplier_payment_request_taken:
      "This payment request already settles another invoice.",
    supplier_payment_source_locked:
      "A payment created from its source request cannot be detached; use an authorized reversal.",
    exchange_rate_snapshot_required:
      "A foreign invoice requires a rate source and an effective date no later than the invoice date.",
    invoice_slot_occupied: "This invoice slot is already occupied.",
    invoice_slot_out_of_order:
      "Invoices must be issued in the next available slot.",
    invoice_slot_invalid: "Invoice sequence must be positive.",
    payment_payer_required:
      "Select a payer or collector from the configured list.",
    payment_payer_invalid: "Select only active accounts.",
    payment_payer_unavailable:
      "The payer directory is unavailable. Please retry.",
    payment_payer_directory_unavailable:
      "The account directory is unavailable. Please retry.",
    invoice_slots_exhausted:
      "The purchase order already used all four invoice slots.",
    invoice_referenced_by_stock:
      "Cannot void an invoice referenced by an approved stock transaction.",
    replacement_invoice_not_found: "Replacement invoice not found.",
    invalid_replacement_invoice:
      "The replacement invoice must belong to the same purchase order.",
    invoice_voided: "A voided invoice cannot change its amount.",
    invoice_already_voided: "This invoice has already been voided.",
    invoice_amount_incomplete:
      "Amount, currency and due date are required together.",
    invoice_amount_missing:
      "Set the invoice amount before recording a payment.",
    payment_exceeds_invoice: "Payment exceeds the outstanding invoice amount.",
    purchase_request_not_found: "Purchase request not found.",
    purchase_request_not_approved:
      "A purchase order requires an approved purchase request.",
    purchase_request_immutable:
      "The purchase request can no longer be changed.",
    purchase_request_not_editable:
      "Only a draft purchase request can be edited.",
    purchase_request_not_deletable:
      "Only a draft without workflow or dependent purchase order can be deleted.",
    purchase_request_lines_required: "At least one request line is required.",
    quote_not_found: "Quote was not found for the current request revision.",
    invalid_editor: "Only the owner can edit this record.",
    invalid_supplier: "An active supplier is required.",
    invalid_party: "An active party of the matching type is required.",
    invalid_material: "Purchase-request material must be active.",
    purchase_order_not_found: "Purchase order not found.",
    purchase_order_not_editable: "Only a draft purchase order can be edited.",
    purchase_order_not_deletable:
      "Only a draft purchase order without dependent transactions can be deleted.",
    purchase_order_not_issued:
      "An invoice requires a submitted, approved or delivered purchase order.",
    purchase_order_exceeds_request:
      "The purchase order total exceeds the purchase request total beyond the tolerance.",
    purchase_order_lines_required:
      "At least one purchase-order line is required.",
    purchase_order_not_receivable:
      "Only approved supplier purchase orders can receive stock.",
    purchase_order_overreceipt:
      "Received quantity cannot exceed the outstanding purchase-order quantity.",
    purchase_receipt_material_mismatch:
      "Choose an active material with the purchase-order part code and unit.",
    project_revision_stale: "The project revision changed. Refresh and retry.",
    insufficient_stock: "Stock is insufficient.",
    invalid_stock_count:
      "Counted quantity must be non-negative with at most four decimal places.",
    stock_count_no_difference:
      "The physical count equals the book balance; no adjustment is needed.",
    stock_count_stale:
      "Stock changed after this physical count. Record a new count before approval.",
    stock_count_immutable:
      "Create a new count instead of editing a physical-count snapshot.",
    stock_transaction_not_editable:
      "Only a draft stock transaction can be edited.",
    stock_transaction_not_deletable:
      "Only a draft without workflow can be deleted.",
    material_approval_rejected:
      "Continue or resolve the existing rejected workflow before submitting again.",
    material_immutable: "The material of this transaction cannot be changed.",
    material_unit_mismatch:
      "Transaction unit must match the active material unit.",
    invalid_transaction_type: "Unsupported stock transaction type.",
    review_separation_required:
      "The confirmer and the approver must be different users.",
    duplicate_code: "This code already exists.",
    idempotency_conflict:
      "This operation was already sent with different details. Reload and try again.",
    invalid_date_range: "The end date cannot be before the start date.",
    unauthenticated: "Please sign in again.",
    employee_not_found:
      "One or more selected employees do not have an employee profile.",
    workflow_managed_request:
      "This project part must be reviewed through its workflow.",
    group_details_required:
      "A grouped request requires participants and project allocations.",
    group_fields_required:
      "The participants and allocations of a grouped request are required.",
    participant_not_found:
      "Every participant must have an approved employee profile.",
    participant_allocation_required:
      "Every participant requires at least one project allocation.",
    duplicate_participant:
      "A participant can only be registered once per request.",
    approved_part_locked:
      "A participant linked to an approved part cannot be changed.",
    travel_interval_required:
      "Actual departure and return dates and times are required for each traveller.",
    travel_outside_request:
      "Each travel interval must be inside the request dates.",
    invalid_travel_form: "In-day travel must return on its departure date.",
    allocation_outside_travel:
      "A project allocation must be inside that participant's travel interval.",
    allocation_outside_request:
      "An allocation must be inside the request date range.",
    allocation_overlap:
      "A participant cannot have overlapping project allocations on the same date.",
    overtime_minimum_not_met:
      "Each participant's daily overtime total must exceed 60 minutes.",
    active_request_overlap:
      "A participant already has an effective request during this time.",
    part_revision_required:
      "A rejected request part must be revised before the group can be submitted again.",
    part_not_editable:
      "A submitted or confirmed request part cannot be changed.",
    request_parts_incomplete:
      "Every current request part must be approved before the request can be approved.",
    project_part_required: "Review each project part separately.",
    request_type_immutable: "Request type cannot be changed.",
    invalid_request_group:
      "Only overtime and field-work requests support grouped allocations.",
    leave_classification_required:
      "Choose paid or unpaid leave before submitting the request.",
    monthly_late_limit_reached:
      "Only two late-arrival corrections are allowed per month.",
    invalid_late_arrival_time:
      "Late arrival time must be between 08:01 and 08:59.",
    receipt_not_supported:
      "Only business-trip and vehicle requests have a receipt step.",
    receipt_separation_required:
      "Admin and Accounting receipt actors must be different users.",
    vehicle_in_use:
      "Retire this vehicle instead: it is referenced by existing requests.",
    duplicate_vehicle_code: "Another vehicle already uses this plate.",
    invalid_time_zone: "The reminder time zone is not supported.",
    profile_not_editable: "Only draft or rejected profiles can be edited.",
    assessment_not_editable:
      "Only draft or rejected assessments can be edited.",
    assessment_header_immutable:
      "Assessment header cannot be changed; create another assessment instead.",
    calendar_not_editable:
      "Only draft, rejected or approved calendar headers can start a revision.",
    new_calendar_revision_required:
      "An approved calendar can be reopened only with a new document number or revision.",
    invalid_author: "Only the calendar author can edit the header.",
    payroll_locked: "Procurement additions require a draft payroll period.",
    payroll_not_calculated: "Calculate and review payroll before approving.",
    payroll_not_approved: "Approve payroll before publishing.",
    payroll_incomplete: "Payroll has no approved calculation.",
    payroll_not_published: "Publish payroll before sending payslips.",
    payroll_delivery_unknown:
      "A previous attempt has an unknown outcome. Reconcile it before another delivery.",
    payroll_already_sent:
      "This payslip is already queued or accepted. Only known failed deliveries can be retried.",
    payroll_period_duplicate:
      "Another payroll revision already exists for this month.",
    payroll_employee_duplicate:
      "An employee is already included in this payroll. Reload before selecting more.",
    payroll_recipient_invalid: "Confirm one valid payroll recipient email.",
    bank_match_mismatch:
      "The bank transaction does not match the document amount, currency or payment method.",
    supplier_payment_request_mismatch:
      "The supplier payment does not match the paid payment request.",
    bank_csv_invalid_amount:
      "The statement contains an invalid monetary value. Check the reported row and column.",
    project_closing:
      "A close operation is in progress; nothing can be changed right now.",
    invalid_rebaseline:
      "A rebaseline request needs exactly one row per work item.",
    dependency_cycle: "This dependency would create a cycle.",
    duplicate_dependency: "The dependency already exists.",
    assignee_unknown: "The assignee is not a known user account.",
    progress_regression:
      "Progress cannot decrease unless a completed item is reopened with a reason.",
    forbidden_scope:
      "You are not within the scope allowed to act on this project.",
    validation_failed:
      "The data is invalid. Please check the information you entered.",
    wbs_has_allocations:
      "This task has resource allocations. Confirm deletion to proceed.",
    wbs_child_dates_out_of_parent_range:
      "Child task dates must be within parent task dates.",
    wbs_parent_dates_must_enclose_children:
      "Parent task dates must enclose all child tasks.",
    summary_node_progress_locked:
      "Parent work item progress is calculated automatically from child tasks.",
    wbs_reparenting_not_allowed:
      "Changing parent task is not allowed. Please delete and recreate under the new parent.",
    company_calendar_year_locked: "The work calendar for this year is locked.",
    date_range_too_large: "The requested date range exceeds the allowed limit.",
    duplicate_capacity: "Work capacity contains a duplicate employee and date.",
    invalid_wbs_obligation:
      "This task is not assigned to you for timesheet reporting on the selected date.",
    invalid_wbs_reference:
      "The WBS task does not belong to the selected project.",
    timesheet_project_not_active:
      "The project is not in a state that allows time reporting.",
    timesheet_after_project_actual_end: "The work date cannot be after the project's actual end date.",
    timesheet_progress_work_pending: "This day's timesheet is awaiting progress reconciliation.",
    progress_work_operation_conflict: "The operation identifier belongs to a different actor or payload.",
    progress_work_coordination_unavailable: "Progress and work time coordination is not enabled.",
    progress_work_operation_cancelled: "The progress and work time operation was cancelled.",
    progress_work_operation_invalid: "The stored progress and work time input is invalid.",
    progress_actual_mandays_read_only: "Progress updates cannot directly change approved timesheet mandays.",
    progress_work_unavailable: "Progress and work time coordination is not enabled.",
    progress_work_operation_id_required: "An operation ID is required when recording work time with progress.",
    progress_work_payload_conflict: "The operation ID has already been used with a different progress request.",
    progress_work_pending: "A progress and work time operation is awaiting reconciliation for this project.",
    progress_work_cancelled: "The operation was cancelled before applying progress.",
    progress_work_intake_paused: "New progress and work time operations are temporarily paused.",
    timesheet_wbs_not_assigned: "You are not assigned to this WBS task.",
    timesheet_wbs_not_eligible:
      "The WBS task is cancelled, N/A – Not applicable, or not in a state that allows time reporting.",
    meal_date_passed: "Meal registrations for past dates cannot be changed.",
    request_inactive:
      "This request was withdrawn or cancelled and cannot be processed further.",
    request_source_mismatch:
      "The generated request does not belong to this source request.",
    workflow_cancel_failed:
      "Workflow cancellation is not complete. Please retry.",
    workflow_cancel_unavailable:
      "Workflow cancellation is currently unavailable. Please retry.",
    mixed_timesheet_approvers: "The timesheet contains multiple approvers.",
    project_leader_required:
      "Project leader is required for timesheet approval.",
    timesheet_period_locked: "The timesheet period is locked.",
    timesheet_not_withdrawable:
      "The timesheet cannot be withdrawn in its current status.",
    timesheet_not_deletable: "Only draft timesheets can be deleted.",
    timesheet_has_multiple_parts: "The timesheet has multiple approval parts.",
    not_part_approver: "You are not an approver for this part.",
    unauthorized_part_approver:
      "You are not authorized to decide on this timesheet part.",
    timesheet_part_already_decided:
      "This timesheet part has already been decided.",
    timesheet_part_not_found: "Timesheet part not found.",
    part_concurrency_conflict:
      "This timesheet part was updated by another user.",
    concurrency_conflict:
      "Data has been modified by another user. Please refresh.",
    row_version_required:
      "Record version (rowVersion) is required. Please reload and try again.",
    invalid_audience: "Invalid export audience (only customer or internal).",
    duplicate_quotation:
      "This quote number and revision already exist in the project.",
    vehicle_code_locked:
      "Tickets already reference this plate, so it cannot change. Retire this vehicle and register the new plate.",
    vehicle_has_future_bookings:
      "Approved tickets still use this vehicle, so it cannot be retired yet.",
    vehicle_status_change_requires_reason:
      "Retire or reactivate the vehicle with the dedicated action and a reason.",
    vehicle_log_entry_locked:
      "System log entries of a vehicle cannot be edited or deleted.",
    document_number_busy:
      "The document number counter is busy; please save again.",
    password_change_required:
      "Change the temporary password before using this feature.",
    user_has_open_responsibilities:
      "The account still holds open responsibilities. Transfer them first or force the deactivation.",
    responsibility_check_unavailable:
      "Open responsibilities could not be checked in some services. Try again later.",
    target_user_inactive:
      "Responsibilities can only be transferred to an active account.",
    responsibility_transfer_failed: "The target service refused the transfer.",
    no_step_roles:
      "The approval step has no fallback role; pick a specific user.",
    scope_not_supported:
      "Scoped grants are not enforced yet (ADR-022 Q23); use the Global scope.",
    stale_row_version: "Data is stale, please refresh before continuing.",
    period_has_pending_timesheets: "The period still has pending timesheets.",
    period_locked: "The period is locked.",
    period_not_locked: "The period is not locked.",
    timesheet_already_approved: "The timesheet has already been approved.",
    self_approval_forbidden: "You cannot approve your own timesheet.",
    invalid_daily_minutes:
      "Total daily minutes are invalid (maximum 16 hours/day).",
    normal_minutes_exceed_capacity:
      "Normal working minutes exceed daily capacity.",
    duplicate_time_entry: "Duplicate time entry for the same project and task.",
    timesheet_not_editable: "Timesheet is not in an editable state.",
    invalid_transition: "Invalid status transition.",
    not_found: "The requested resource was not found.",
    forbidden: "You do not have permission to perform this action.",
    request_not_editable: "The request cannot be edited in its current status.",
    request_not_withdrawable:
      "The request can only be withdrawn while pending approval.",
    request_not_deletable: "Only draft requests can be deleted.",
    request_not_cancellable: "Only approved requests can be cancelled.",
    meal_cutoff_passed:
      "The meal registration deadline for this day has passed.",
    not_a_meal_day: "Meals cannot be registered on a holiday or a rest day.",
    approved_request_cannot_be_deleted: "Approved requests cannot be deleted.",
    insufficient_annual_leave_balance: "Insufficient annual leave balance.",
    meal_registration_cutoff_passed:
      "The meal registration cutoff time has passed.",
    meal_registration_locked: "Meal registration is locked.",
    unknown: "An unexpected error occurred. Please try again.",
    unexpected_action_error: "An unexpected error occurred. Please try again.",
  },
  historyReader: {
    searchChat: "Search the conversation (Ctrl + F)",
    previousResult: "Previous result",
    nextResult: "Next result",
    removeFile: "Remove file",
    sendMedia: "Send photo or video",
    sendFile: "Send file",
    messagePlaceholder: "Type a message...",
    pickEmoji: "Choose emoji",
    popularEmoji: "Popular emoji",
    send: "Send",
  },
  multiSelect: {
    placeholder: "— Select or leave empty (All) —",
    clearAll: "Clear all",
    search: "Search...",
    selectAll: "Select all",
    clear: "Clear",
    noResults: "No results found",
  },
  identity: {
    toast_invalidImageFile: "Invalid image file.",
    toast_imageTooLarge: "The image is too large.",
    toast_failedUploadImage: "Could not upload the image.",
    removePhoto: "Remove photo",
  },
  bug112: {
    deleteWbsSubtreeConfirm: "Delete WBS item {code} and all {count} descendants?",
    deleteWbsStarted: "Cannot delete {code}: this item or a descendant has progress, timesheet data or a changed status.",
    deleteWbsHistory: "Cannot delete {code}: this item or a descendant has progress, timesheet or closed PIC assignment history.",
  },
  progressWarnings: {
    title: "Progress warnings",
    from: "From date",
    to: "To date",
    asOf: "Assessed as of {date}",
    generated: "Data read at {time}",
    allProjects: "All accessible projects",
    allLeaders: "All project leaders",
    apply: "Filter warnings",
    groupsLabel: "Three progress warning groups",
    allGroups: "Show all three groups",
    group: "Warning group",
    taskCode: "WBS code",
    task: "Task",
    actual: "Actual %",
    expected: "Expected %",
    evidence: "Reason / activity in period",
    planRule: "Daily allocations take precedence; otherwise current planned dates and mandays apply. Only elapsed days are assessed. A task can appear in multiple groups.",
    invalidRange: "Select a valid period: the start date must not follow the end date.",
    noUpdateEvidence: "Planned in the period, with no progress update effective in that period.",
    overdueEvidence: "Overdue by {days} days and not completed.",
    behindEvidence: "Actual progress is {gap} percentage points below the expected progress.",
    progressEvidence: "{updates} progress updates outside the plan",
    timeEvidence: "{minutes} minutes outside the plan (draft {draft}, pending {pending}, approved {approved}, rejected {rejected})",
    timeUnknown: "Timesheets: insufficient data to conclude",
    incompleteHistory: "{count} tasks lack sufficient history to determine progress/status in the selected past period. Unknown values show —; the at-risk group may be incomplete.",
    empty: "No matching warnings in the selected period.",
    partialEmpty: "No warnings found in the available data; some sources remain incomplete.",
    unavailable: "Warnings could not be loaded. Try again.",
    wbsMissing: {
      title: "Work without hours",
      subtitle: "Tasks with activity whose assignees logged no hours (detected by the server). Informational monitoring for managers; not an approval step.",
      employee: "Employee",
      project: "Project / WBS",
      workDate: "Work date",
      reason: "Reason",
      detected: "Detected",
      late: "Late entry at {time}",
      noReason: "No reason",
      dismiss: "Dismiss / Seen",
      loadFailed: "Could not load the work-without-hours list.",
    },
    groups: {
      NoUpdate: "Planned, no progress update",
      UnplannedActivity: "Activity outside the plan",
      AtRisk: "At risk of delay",
    },
    sources: {
      Forbidden: "Full timesheet visibility is not permitted. The unplanned-activity group currently includes progress updates only; counts may be incomplete.",
      Unavailable: "The timesheet source is temporarily unavailable. The unplanned-activity group currently includes progress updates only; reload to reconcile all activity.",
    },
  },
  progressOverview: {
    demoMappingNote: "The 16-stage WBS template has no separate execution demo. Quotation demo and operation tests are not substitutes. Template and weight decisions are needed before adding data.",
    quoteSources: {
      Quotation: "Issued quotation",
      QuotationMilestone: "Actual quotation milestone",
      WbsQuotation: "Completed quotation WBS",
    },
    noData: "No data recorded",
    target: "100% target",
    stageCatalog: "Compare {count} stages",
    ordinalHint: "Numbers indicate business sequence, not WBS codes. Missing mappings do not count as 0% or complete.",
    openWbsCode: "Open WBS {code}",
    unmappedStage: "No WBS mapping",
    missingStage: "No corresponding WBS stage",
    openWbs: "Open detailed WBS",
    noPhaseMapping: "Insufficient mapping for the two steps",
    zeroDuration: "The plan has no working days in (start, finish]; the target is reached at the finish milestone, with no division by zero.",
    noCurveData: "Insufficient data to draw this stage’s chart.",
    chartData: "Read chart data as a table",
    projectionMissing: "The server does not yet provide the new step projection. Legacy groups 01–06/07–16 cannot substitute for it.",
    pendingHint: "Aggregation is pending; no ahead/behind conclusion is available.",
    preparation: "Before visiting the factory",
    preparationRequirement: "Complete work instructions and a detailed work plan for delivery, installation/operation, training and acceptance.",
    preparationUnknown: "Completion of work instructions and the preparation plan has not been confirmed. A WBS status or attachment alone does not establish readiness.",
    preparationWork: "Source tasks",
    relatedTasks: "Related detailed tasks",
    preparationDocuments: "Project documents for review",
    openDocuments: "Open project documents",
    documentsUnavailable: "Documents could not be loaded; missing or completed cannot be inferred.",
    noPreparationDocuments: "No project-level attachments. Documents attached to individual WBS tasks must be reviewed at the source task.",
    documentsForbidden: "Document read permission is unavailable.",
    abnormalHint: "WBS stage 16 appears in Step 2. Project requests are tracked separately; no mapping exists to include all requests in this stage’s progress.",
    followUpTitle: "Quoted · customer P/O not received",
    followUpScope: "A separate view of readable projects, including those before operations; independent of Gantt PO/progress filters and pagination. These are customer P/Os, not supplier or subcontractor purchase orders.",
    followUpSnapshot: "Current state at {date}, grouped by latest quotation issue month. These are not historical month-end balances; history is insufficient to reconstruct them.",
    followUpMonths: "Projects currently awaiting P/O by quotation month",
    projectCount: "{count} projects",
    quoteIssued: "Issued quotation",
    responsible: "Project leader",
    unresolvedPerson: "Name could not be resolved",
    quoteOutcome: "Quotation outcome",
    recordedOutcomeReason: "Recorded outcome reason",
    noPoReason: "Reason for missing P/O",
    noPoReasonMissing: "No reason for missing P/O has been recorded.",
    followUpForbidden: "WBS, quotation and customer P/O read permissions are required.",
    followUpUnavailable: "Could not load quotations awaiting P/O.",
    followUpEmpty: "No issued quotations awaiting P/O in your readable scope.",
    retry: "Retry",
    stages: {
      receipt: "Receive requirements",
      survey: "Survey",
      solution: "Solution proposal",
      quotationDemo: "Quotation demo",
      quotation: "Quotation",
      customerPo: "Receive customer P/O",
      execution: "Project execution",
      executionDemo: "Execution demo",
      supplierPo: "Issue supplier P/O",
      subcontractorPo: "Issue subcontractor P/O",
      assembly: "Product assembly complete",
      delivery: "Delivery",
      installation: "Installation, setup and operation",
      training: "Training and technology transfer",
      acceptance: "Acceptance",
      payment: "Payment",
      abnormal: "Abnormality handling",
    },
    dataStates: {
      Available: "Data available",
      Partial: "Values cover mapped WBS only. Some stages still lack sources; a whole-step conclusion is unavailable.",
      NoData: "No matching WBS data.",
      NoWeight: "No effective WBS weights; stages are not equally weighted.",
      NotApplicable: "All mapped stages are N/A; this is not completion.",
      Cancelled: "Effective stages are cancelled; no progress conclusion.",
      NotStarted: "Not started or no actual observation; no artificial 0% line.",
    },
    conclusions: {
      ahead: "Ahead of plan",
      behind: "Behind plan",
      onPlan: "On plan",
      insufficient: "Insufficient data for a whole-stage conclusion",
      pending: "Aggregation pending",
    },
    quoteOutcomes: {
      None: "No outcome recorded",
      Sent: "Sent",
      Accepted: "Accepted",
      Rejected: "Rejected",
      Expired: "Expired",
    },
    title: "Progress tracking",
    planned: "Plan",
    actual: "Actual",
    today: "Today",
    colSeq: "No.",
    colProject: "Project",
    detail: "Details",
    done: "Reached 100%",
    remaining: "{days} days left",
    empty: "No operational project in the three years shown.",
    unavailable: "Could not load project progress.",
    pageInfo: "Page {page}/{pages} · {total} projects",
    previousPage: "Previous page",
    nextPage: "Next page",
    summary: "Summary",
    overall: "Overall progress",
    ahead: "ahead",
    behind: "behind",
    onPlan: "on plan",
    poDate: "PO date",
    poFromPlannedStart: "(from the planned start date)",
    plannedEnd: "End date",
    durationValue: "{days} working days = 100% ⇒ 1 day = {daily}%",
    daysValue: "{days} days",
    overdue: "Overdue by {days} days",
    chart: "Progress chart",
    aheadZone: "Ahead",
    behindZone: "Behind",
    curveUnavailable: "Could not load the progress charts.",
    scale: "Time scale",
    colPo: "PO",
    lateButton: "Late work ({count})",
    weekdaysCalendar: "(Monday–Friday calendar)",
    chartPreOrder: "Step 1 · Quotation progress",
    chartQuoted: "Quoted",
    chartCompleted: "Completed",
    completedTitle: "Projects completed at 100%",
    completedEmpty: "No project reached 100% in the three years shown.",
    colPlannedEnd: "Planned end",
    colActualStart: "Actual start",
    colActualEnd: "Actual end",
    chartExecution: "Step 2 · Project execution progress",
    stepTabs: "Progress tracking stages",
    sharedProjectScope: "Filters, percentages and late alerts apply to the whole project. Details show metrics for the selected Step.",
    projectPercent: "Project %",
    projectRemaining: "Project: {days} days left",
    phasePreOrder: "Step 1",
    phaseExecution: "Step 2",
    phaseDone: "{done}/{total} items done",
    phaseLegend: "Step 1: quotation (WBS 01–05) · Step 2: execution (WBS 06–16)",
    chartNoItems: "The project has no root item in this group.",
    unmappedRoots: "{count} root items outside codes 01–16 are not in any chart.",
    planDoneAtStartPreOrder: "The PO date ({po}) is not after the earliest planned start of the group ({start}), so the plan is 100% from the start.",
    planDoneAtStartExecution: "The end date ({end}) is not after the PO date ({po}), so the plan is 100% from the start.",
    lateTitle: "Late work · {project}",
    lateHint: "Unfinished WBS items at any level past their planned end as of {date}; click a row to see its progress tracking notes.",
    colCode: "Code",
    colName: "Item",
    colLateDays: "Days late",
    historyTitle: "Progress tracking notes · {node}",
    historyForbidden: "You do not have permission to view the update history.",
    historyUnavailable: "Could not load the update history.",
    historyEmpty: "The item has no progress update yet.",
    historyDate: "Date",
    historyStatus: "Status",
    historyContent: "Notes",
    historyBy: "Updated by",
    colIssues: "Requests",
    issueOpen: "{count} open",
    issueLate: "{count} late",
    issueForbidden: "No permission to view requests",
    issuesTitle: "Requests · {project}",
    issuesEmpty: "The project has no requests.",
    issuesUnavailable: "Could not load the requests.",
    issueColTitle: "Title",
    issueColSchedule: "Deadline health",
    openIssueTracking: "Open request tracking",
    filters: "Project progress filters",
    searchPlaceholder: "Search project code or name",
    filterAll: "All",
    filterProgress: "Progress",
    filterLate: "Late",
    clearFilters: "Clear filters",
    progressActive: "In progress (below 100%)",
    progressCompleted: "Reached 100%",
    progressBehind: "Behind plan",
    progressOverdue: "Past end date",
    lateWbs: "Has late work",
    lateIssue: "Has late requests",
    lateAny: "Has late work or requests",
    emptyFiltered: "No projects match the filters.",
    chartTitleQuotation: "Quotation progress management chart",
    chartTitleExecution: "Project construction progress management chart",
    chartLegend: "Chart legend",
    targetLegend: "Target",
    axisProgress: "Progress (%)",
    infoBox: "Step progress summary",
    infoReceipt: "Request received:",
    infoQuotation: "Quotation issued:",
    infoDuration: "Total project days:",
    infoRemaining: "Total days remaining:",
    infoOverdue: "({days} days overdue)",
    infoPlanned: "Planned progress:",
    infoActual: "Actual progress:",
    infoAhead: "The project is {value}% ahead of plan",
    infoBehind: "The project is {value}% behind plan",
    rangeLine: "Plan {plannedStart} → {plannedEnd} · Actual {actualStart} → {actualEnd}",
    rangePo: "PO date {date}",
    notesTitle: "Notes",
    noteWeekdays: "Days are counted Monday–Friday (company calendar unavailable).",
  },
};
